/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
import WelcomePage from "../../components/layout/Workspace/index";
import error1 from "../../assets/error.svg";
import { notification, Button } from "antd";
import successful from "../../assets/successful.svg";
import info from "../../assets/information.svg";
import alert from "../../assets/alert.svg";
import moment from "moment-timezone";
import Dashboard from "../../components/layout2/dashboard";
import uuid from "react-uuid";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import InfoCard from "../../components/layout/DeepDive/DeepDiveInfoBar/InfoCard";
import { isArray } from "highcharts";
import { SecondstoHumanReadable } from "../../components/utils/charts/HighCharts/graphFunction";
import { CloseOutlined } from "@ant-design/icons";
import { supportedBenchmarkTraceChartTypes } from "./enums";
import parse from "html-react-parser";
export const initialPanes = [
  {
    title: "New Worksheet",
    content: <WelcomePage />,
    key: "1",
    homePage: true,
    filterObj: [],
    splitObj: null,
    primeAttribute: null,
    secondAttribute: null,
    base: "mentions",
    report_id: null,
  },
];
export var urlParams; // url encrypted parameters
//Function to get url params from URL and set it to urlParams variable
(window.onpopstate = function () {
  var match,
    pl = /\+/g, // Regex for replacing addition symbol with a space
    search = /([^&=]+)=?([^&]*)/g,
    decode = function (s) {
      return decodeURIComponent(s.replace(pl, " "));
    },
    query = window.location.search.substring(1);

  urlParams = {};
  while ((match = search.exec(query)))
    urlParams[decode(match[1])] = decode(match[2]);
})();

export const errorCode = [
  { key: -1, value: "Internal server error", msg: "unknown error" },
  { key: 6, value: "session expired! Please reload page" },
  {
    key: 1,
    value: "Split attribute name and Graph attribute names must be different",
  },
  { key: 2, value: "No data found for selected filter combinations" },
  {
    key: 3,
    value: "Something went wrong!",
    msg: "incomplete data from frontend",
  },
  {
    key: 4,
    value: "Internal server error",
  },
  { key: 5, value: "No data available for selected attributes" },
  {
    key: 7,
    value: "Internal server error. Please contact AWA team.",
    msg: "no database source available issue",
  },
  {
    key: 11,
    value:
      "Requested workspace does not exist! Redirecting you to reports page...",
    msg: "Report id does not exist",
  },
  {
    key: 13,
    value: "Cannot filter on multiple channels for page widgets",
    msg: "Cannot filter on multiple channels for page widgets",
  },
  {
    key: 9,
    value: "Your session has expired!",
    msg: "You are not logged in",
  },
  {
    key: 100,
    value: "You have exceeded the mention limit! Please contact AWA team.",
    msg: "Mention limit surpassed",
  },
  {
    key: 101,
    value:
      "You have exceeded the active workspace limit! Please contact AWA team.",
    msg: "active ws limit surpassed",
  },

  {
    key: 102,
    value: "Try again after a minute.",
    msg: "Keep one minute gap between report creation",
  },
  {
    key: 103,
    value: "Workspace creation timeout! Please try again.",
    msg: "Workspace creation timeout, retry from estimate",
  },

  {
    key: 104,
    value: "Another workspace creation in progress. Please wait!",
    msg: "Another workspace is in creation, wait for completion",
  },
  {
    key: 500,
    value: "user does not have access to the dashboard",
    msg: "user does not have access to the dashboard",
  },
  {
    key: 501,
    value: "Dashboard does not exist",
    msg: "Dashboard does not exist",
  },
  {
    key: 600,
    value: "Invalid password",
    msg: "invalid share link password",
  },
  {
    key: 602,
    value: "Share link expired",
    msg: "Share link expired",
  },
  {
    key: 21,
    value: "Restricted keywords or combination of keywords usage detected.",
    msg: "Restricted keywords or combination of keywords usage detected.",
  },
];

export const prolificUserDeepDiveArray = [{ name: "Mentions", key: "1" }];
export const localArray = [
  { name: "Mentions", key: "1" },
  { name: "Word Cloud", key: "2" },
  { name: "Category", key: "3" },
  { name: "Influencers", key: "4" },
  { name: "Source of Post", key: "5" },
  // { name: "Location Profiles", key: "10" },
];
export const getDeepDiveTabList = (userPrivileges) => {
  let tabLists = [...localArray];
  if (userPrivileges) {
    if (userPrivileges?.location_profile_enabled) {
      tabLists = [...tabLists, { name: "Location Profiles", key: "10" }];
    }
  }
  return tabLists;
};

//function to get cookie
export const getCookie = (cname) => {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
// Distance from the bottom of the viewport, when placement is bottomRight or bottomLeft (unit: pixels), default 24
export const callNotification = (
  message,
  value,
  bottom = 24,
  className = "",
  isPreviewScreen = false
) => {
  return notification.open({
    className: `notification_body ${className ? className : ""}`,
    key: 1,
    placement: "bottomLeft",
    icon: (
      <img
        src={
          value === "error"
            ? error1
            : value === "info"
            ? info
            : value === "alert"
            ? alert
            : successful
        }
        alt={
          value === "error"
            ? "error"
            : value === "info"
            ? "info"
            : value === "alert"
            ? "alert"
            : "successful"
        }
      />
    ),
    btn: isPreviewScreen ? (
      <Button
        type="primary"
        size="small"
        className="notification_btn"
        onClick={() => notification.close(1)}
      >
        <CloseOutlined />
      </Button>
    ) : (
      <Button
        type="primary"
        size="small"
        className="notification_btn"
        onClick={() => notification.close(1)}
      >
        Dismiss
      </Button>
    ),
    message: (
      <span className="notification_message">
        {value === "error"
          ? message
            ? message
            : "Internal Server Error!"
          : message}
      </span>
    ),
    bottom: bottom ? bottom : 24,
  });
};

export const sessionExpired = (value) => {
  let timer = null;
  if (value) {
    timer = setTimeout(() => {
      window.location.href = "/sessionexpired";
    }, 1000);
  }
  return () => {
    clearTimeout(timer);
  };
};

export const workspaceNotExist = (value) => {
  let timer = null;
  if (value) {
    timer = setTimeout(() => {
      window.location.href = "/dashboard";
    }, 2000);
  }
  return () => {
    clearTimeout(timer);
  };
};

export function getColor() {
  return (
    "hsl(" +
    360 * Math.random() +
    "," +
    (25 + 70 * Math.random()) +
    "%," +
    (85 + 10 * Math.random()) +
    "%)"
  );
}

//threesplitdate

export const getThreeSplitDate = (dateStrings, startDate, endDate) => {
  var Diff_in_days = setDiffInDays(dateStrings);

  let divideDateThree = Math.floor(Diff_in_days / 3);
  let d1, f1, d2, f2;

  let defaultDate1, defaultDate2, defaultDate3;

  if (Diff_in_days === 3) {
    d1 = moment(startDate).format("YYYY/MM/DD");
    defaultDate1 = [startDate, `${d1} 23:59`];

    f1 = moment(d1).add(1, "days").format("YYYY/MM/DD");
    defaultDate2 = [`${f1} 00:00`, `${f1} 23:59`];

    f2 = moment(f1).add(1, "days").format("YYYY/MM/DD");
    defaultDate3 = [`${f2} 00:00`, endDate];
  } else if (Diff_in_days >= 3) {
    d1 = moment(startDate).add(divideDateThree, "days").format("YYYY/MM/DD");
    defaultDate1 = [startDate, `${d1} 23:59`];

    f1 = moment(d1).add(1, "days").format("YYYY/MM/DD");
    d2 = moment(d1).add(divideDateThree, "days").format("YYYY/MM/DD");
    defaultDate2 = [`${f1} 00:00`, `${d2} 23:59`];

    f2 = moment(d2).add(1, "days").format("YYYY/MM/DD");
    d2 = moment(d1).add(divideDateThree, "days").format("YYYY/MM/DD");
    defaultDate3 = [`${f2} 00:00`, endDate];
  } else if (Diff_in_days < 3) {
    defaultDate1 = [`${startDate}`, `${endDate}`];
    defaultDate2 = [`${startDate}`, `${endDate}`];
    defaultDate3 = [`${startDate}`, `${endDate}`];
  }

  return { defaultDate1, defaultDate2, defaultDate3 };
};

export const getCrisisDates = (reportInfo, startDate, endDate, timeValue) => {
  let reportStartDate = reportInfo?.result?.report_date_range.start;
  let reportEndDate = reportInfo?.result?.report_date_range.end;
  let defaultDate3, defaultDate2, defaultDate1;

  defaultDate1 = getCrisisValidation(reportInfo, startDate, endDate);
  // defaultDate1 = [startDate, endDate];
  let defaultDate2StartDate = reportStartDate;
  let defaultDate2endDate = moment(startDate)
    .subtract(1, "days")
    .set({ hour: 23, minute: 59 })
    .format("YYYY/MM/DD HH:mm");
  defaultDate2 = getCrisisValidation(
    reportInfo,
    defaultDate2StartDate,
    defaultDate2endDate
  );
  let defaultDate3StartDate = moment(endDate)
    .add(1, "days")
    .set({ hour: 0, minute: 0 })
    .format("YYYY/MM/DD HH:mm");
  let defaultDate3endDate = reportEndDate;
  defaultDate3 = getCrisisValidation(
    reportInfo,
    defaultDate3StartDate,
    defaultDate3endDate
  );

  return { defaultDate1, defaultDate2, defaultDate3 };
};

export const getCrisisValidation = (reportInfo, startDate, endDate) => {
  let defaultDate;
  let reportStartDate = reportInfo?.result?.report_date_range.start;
  let reportEndDate = reportInfo?.result?.report_date_range.end;
  if (
    !moment(startDate).isSame(reportStartDate, "date") &&
    moment(endDate).isSame(reportEndDate, "date")
  ) {
    defaultDate = [
      moment(startDate).set({ hour: 0, minute: 0 }),
      reportEndDate,
    ];
  } else if (
    moment(startDate).isSame(reportStartDate, "date") &&
    !moment(endDate).isSame(reportEndDate, "date")
  ) {
    defaultDate = [
      reportStartDate,
      moment(endDate).set({ hour: 23, minute: 59 }),
    ];
  } else if (
    moment(startDate).isSame(endDate, "date") &&
    !(
      moment(startDate).isSame(reportStartDate, "date") &&
      moment(endDate).isSame(reportEndDate, "date")
    )
  ) {
    defaultDate = [
      moment(startDate).set({ hour: 0, minute: 0 }),
      moment(endDate).set({ hour: 23, minute: 59 }),
    ];
  } else if (
    moment(startDate).isSame(reportStartDate, "date") &&
    moment(endDate).isSame(reportEndDate, "date")
  ) {
    defaultDate = [reportStartDate, reportEndDate];
  } else if (
    !moment(startDate).isSame(reportStartDate, "date") &&
    !moment(endDate).isSame(reportEndDate, "date")
  ) {
    defaultDate = [
      moment(startDate).set({ hour: 0, minute: 0 }),
      moment(endDate).set({ hour: 23, minute: 59 }),
    ];
  }
  return defaultDate;
};

export const getTimeExtendChecks = (extendDates, date) => {
  let finalTimeObj;
  if (
    moment(date[0]).isSame(extendDates?.start, "date") &&
    moment(date[1]).isSame(extendDates?.start, "date")
  ) {
    finalTimeObj = {
      type: "createWorkspace",
      data: {
        startTime: "00:00",
        endTime: moment(extendDates?.start)
          .subtract(1, "minutes")
          .format("HH:mm"),
      },
    };
  } else if (
    moment(date[0]).isSame(extendDates?.end, "date") &&
    moment(date[1]).isSame(extendDates?.end, "date")
  ) {
    finalTimeObj = {
      type: "createWorkspace",
      data: {
        startTime: moment(extendDates?.end).add(1, "minutes").format("HH:mm"),
        endTime: "23:59",
      },
    };
  } else if (
    moment(date[0]).isSame(extendDates?.start, "date") &&
    moment(date[1]).isSame(extendDates?.end, "date")
  ) {
    finalTimeObj = {
      type: "createWorkspace",
      data: {
        startTime: moment(extendDates?.start).add(1, "minutes").format("HH:mm"),
        endTime: moment(extendDates?.end)
          .subtract(1, "minutes")
          .format("HH:mm"),
      },
    };
  } else if (
    !moment(date[0]).isSame(extendDates?.start, "date") &&
    moment(date[1]).isSame(extendDates?.start, "date")
  ) {
    finalTimeObj = {
      type: "createWorkspace",
      data: {
        startTime: "00:00",
        endTime: moment(extendDates?.start)
          .subtract(1, "minutes")
          .format("HH:mm"),
      },
    };
  } else if (
    moment(date[0]).isSame(extendDates?.end, "date") &&
    !moment(date[1]).isSame(extendDates?.end, "date")
  ) {
    finalTimeObj = {
      type: "createWorkspace",
      data: {
        startTime: moment(extendDates?.end).add(1, "minutes").format("HH:mm"),
        endTime: "23:59",
      },
    };
  } else if (
    !moment(date[0]).isSame(extendDates?.start, "date") &&
    !moment(date[1]).isSame(extendDates?.end, "date")
  ) {
    finalTimeObj = {
      type: "createWorkspace",
      data: {
        startTime: "00:00",
        endTime: "23:59",
      },
    };
  } else if (
    moment(date[0]).isSame(extendDates?.start, "date") &&
    moment(extendDates?.end).isBetween(date[0], date[1], "date")
  ) {
    finalTimeObj = {
      type: "createWorkspace",
      data: {
        startTime: moment(extendDates?.start).format("HH:mm"),
        endTime: "23:59",
      },
    };
  } else if (
    moment(date[1]).isSame(extendDates?.end, "date") &&
    moment(extendDates?.start).isBetween(date[0], date[1], "date")
  ) {
    finalTimeObj = {
      type: "createWorkspace",
      data: {
        startTime: "00:00",
        endTime: moment(extendDates?.end).format("HH:mm"),
      },
    };
  }
  return finalTimeObj;
};

//function to get the customized date range
export const getCustomizedDate = (value, type, custom_relative, mode_type) => {
  let currentDate = new Date();
  let newDate = null;
  if (type === "Minutes") {
    newDate = moment(currentDate).subtract(value, "minutes")._d;
  } else if (type === "Hours") {
    newDate = moment(currentDate).subtract(value, "h")._d;
  } else if (type === "Days") {
    newDate = moment(currentDate).subtract(value, "d")._d;
  } else if (type === "Weeks") {
    newDate = moment(currentDate).subtract(value, "week")._d;
  } else if (type === "Months") {
    newDate = moment(currentDate).subtract(value, "month")._d;
  } else if (type === "Years") {
    newDate = moment(currentDate).subtract(value, "year")._d;
  } else if (type === "short") {
    if (value === "MTD") {
      newDate = moment().startOf("month").format("DD MMM YYYY");
    } else if (value === "YTD") {
      newDate = moment().startOf("year").format("DD MMM YYYY");
    }
  }
  let fromDate = custom_relative
    ? moment(newDate).add(1, "d").format("DD MMM YYYY")
    : moment(newDate).format("DD MMM YYYY");
  let fromTime = moment(newDate).format("HH:mm");
  let toDate = moment(currentDate).format("DD MMM YYYY");
  let toTime1 = moment(currentDate).format("HH:mm");
  let toTime = "23:59";

  let timeValue = {
    startTime: type === "Hours" || type === "Minutes" ? fromTime : "00:00",
    endTime:
      type === "Hours" ||
      type === "Minutes" ||
      mode_type === "schedule_date_time"
        ? toTime1
        : toTime,
  };
  return { date: [fromDate, toDate], time: timeValue };
};
export const getDefaultDateRange = () => {
  let obj = getCustomizedDate(14, "Days");
  let dateObj = {
    days: 15,
    from:
      moment(obj?.date[0]).format("YYYY/MM/DD") + " " + obj?.time?.startTime,

    to: moment(obj?.date[1]).format("YYYY/MM/DD") + " " + obj?.time?.endTime,
  };
  return dateObj;
};
export const rangePickerDisabledDate = (
  current,
  startDate,
  endDate,
  duration,
  extend
) => {
  // You cannot choose today or later, you can only choose [Today ~ 90 days forward]. Today is optional.

  let durationStart, durationEnd;
  let extendStart = moment(duration?.start).set({ hour: 0, minute: 0 });
  let extendEnd = moment(duration?.end).set({ hour: 23, minute: 59 });
  if (extend) {
    if (moment(duration?.start).isSame(extendStart)) {
      durationStart = moment(duration?.start).subtract(1, "days");
    } else {
      durationStart = moment(duration?.start);
    }
    if (moment(duration?.end).isSame(extendEnd)) {
      durationEnd = moment(duration?.end).endOf("day");
    } else {
      durationEnd = moment(duration?.end).subtract(1, "days");
    }
  }
  let startDate1 = moment(startDate).format("YYYY/MM/DD");

  if (current) {
    if (
      duration &&
      current > moment(durationStart).subtract("days") &&
      current < moment(durationEnd).endOf("day")
    ) {
      return true;
    }
    if (
      current < moment(startDate1).subtract("days") ||
      current > moment(endDate).endOf("day")
    ) {
      return true;
    } else {
      return false;
    }
  }
};
export function secondsToHms(d) {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor((d % 3600) / 60);

  var hDisplay =
    h > 0
      ? h +
        (h == 1
          ? m > 0
            ? " hour, "
            : " hour "
          : m > 0
          ? " hours, "
          : " hours ")
      : "";
  var mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes ") : "";

  return hDisplay + mDisplay;
}
export const setDiffInDays = (date) => {
  //to get the difference of days
  let date1 = new Date(date && date[0]);
  let date2 = new Date(date && date[1]);
  let Diff_time = date1.getTime() - date2.getTime();
  let Diff_in_days = isNaN(date1)
    ? 0
    : Math.abs(Math.round(Diff_time / (1000 * 3600 * 24)));

  return Diff_in_days + 1;
};
export const customDebounceCallback = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func && func(...args);
    }, delay);
  };
};

// Helper function to check if the value is a valid number
export const isValidNumber = (val) =>
  typeof val === "number" && !Number.isNaN(val);

export const showNotification = (message) => {
  var options = {
    body: message,
    icon: "https://i.postimg.cc/W4R0f574/AWA123.png",
    dir: "ltr",
  };

  new Notification("Analytics Workspace App", options);
};
export const getFrequentConfigData = (schema) => {
  let obj = {};
  schema &&
    Object?.entries(schema)?.map((e) => {
      if (e[1].is_group === true) {
        e[1].members &&
          typeof e[1].members === "object" &&
          Object.entries(e[1].members).map((el, i) => {
            return (obj[el[0]] = el[1]);
          });
      }
    });
  return obj;
};
export const initialPaneObject = {
  title: "Dashboards",
  description: null,

  key: "1",
  duration: null,
  brands: null,
  sections: null,
  onlyWidgets: null,
  isDashboard: false,
  isDeepDive: false,
  isDeepDiveDashboard: false,
  public_engagement_only: false,
  deepdive: { deepdiveResponse: [], tabName: null },
  pills: "All Dashboards",
  sortOrder: "asc",
  sortBy: "name",
  dashboard_template_filters: {
    filter_vals: [],
    search_text: "",
    pill: "All Dashboards",
    offset: 0,
    no_of_rows: 12,
    sort_expression: null,
    sort_order: null,
    type: "dashboard",
  },
  filter_template_details: {
    filter_templates: [],
    pinned_filters: [],
  },
  selected_pills: [],
  adsset_list: [],
  adsset_value: null,
  ads_list: [],
  ads_value: null,
  is_active_ad_campaign: false,
};
export const dashboardInitialPanes = [initialPaneObject];

export const setCookie = (cname, cvalue) => {
  document.cookie = cname + "=" + cvalue + ";" + ";path=/";
};
export const getPaneIndex = (panes, activeKey) => {
  let index;
  panes?.map((el, i) => {
    if (el?.key === activeKey) index = i;
  });

  return index;
};

export const getCheckedState = (config, preDefineTabs) => {
  let myArray = [];
  if (config?.status !== "error") {
    config?.result?.schema &&
      typeof config?.result?.schema === "object" &&
      Object.entries(config?.result?.schema)?.map((el, index) => {
        if (preDefineTabs && el[1].datatype === "varchar")
          el[1]?.values?.forEach((element) => {
            myArray = {
              ...myArray,
              [el[0]]: {
                ...myArray[el[0]],
                [`${el[0]}#${element?.id}`]: "include",
              },
            };
          });
      });
  }
  return myArray;
};

export const getValue = (filterObj) => {
  let obj = {};
  filterObj.forEach((el) => {
    if (el.attribute !== "BrandID" && el.type === "varchar") {
      let g = {
        [el.attribute]: [{ name: null, type: "include" }],
      };
      obj = { ...obj, ...g };
    }
  });
  return obj;
};

export const getFilterArray = (filterPanelData, isDefault) => {
  let myArray = [];
  if (isDefault) {
    myArray = filterPanelData?.map((el, i) => {
      if (el?.datatype === "boolean") {
        return {
          type: el?.datatype,
          attribute: el?.attribute,
          source: el?.source || el?.data_source,
          columns: [{ name: null, type: "include" }],
        };
      } else {
        return {
          type: el?.datatype,
          attribute: el?.attribute,
          source: el?.source || el?.data_source,
          columns: el?.id
            ?.filter((e) => e?.name === "All")
            ?.map((e) => {
              return { name: e?.id, type: "include" };
            }),
        };
      }
    });
  } else {
    myArray = filterPanelData?.map((el, i) => {
      if (el?.datatype === "boolean") {
        return {
          type: el?.datatype,
          attribute: el?.attribute,
          source: el?.source || el?.data_source,
          columns: el.id,
        };
      } else {
        return {
          type: el?.datatype,
          attribute: el?.attribute,
          source: el?.source || el?.data_source,
          columns: el?.id?.map((e) => {
            return { name: e?.id, type: "include" };
          }),
        };
      }
    });
  }
  let finalArray = myArray?.filter((el) => el?.columns?.length > 0);
  return finalArray;
};
export const getFilterPanelData = (
  config,
  preDefineTabs,
  supported_filters,
  data_source = "mentions"
) => {
  const myArray = [];

  if (config && config?.status !== "error") {
    // Handle different possible structures in the response
    let entriesToProcess = [];

    // Handle nested filters structure first
    let schemaData = config?.result?.schema;
    if (config?.result?.filters) {
      schemaData = config?.result?.filters?.schema || schemaData;
    }

    // Check if we have schema data to process
    if (schemaData && typeof schemaData === "object") {
      entriesToProcess = Object.entries(schemaData);
    }
    // Check if result contains data sources with their own schemas (new structure)
    else if (config?.result && typeof config.result === "object") {
      // Process all data sources (common, author, mentions, page, tickets)
      ["common", "author", "mentions", "page", "tickets"].forEach(
        (dataSourceKey) => {
          const dataSourceValue = config.result[dataSourceKey];
          if (dataSourceValue && typeof dataSourceValue === "object") {
            Object.entries(dataSourceValue).forEach((el) => {
              if (el && el[1] && typeof el[1] === "object") {
                // Add data source info to the entry
                entriesToProcess.push([
                  el[0],
                  { ...el[1], dataSource: dataSourceKey },
                ]);
              }
            });
          }
        }
      );
    }

    // Process the collected entries using the original logic
    entriesToProcess.forEach((el) => {
      // Get the data source from the entry if it exists
      const dataSource = el[1]?.dataSource || el[1]?.source;

      // Check if entry has members (either with is_group flag or just members property)
      if (
        el[1] &&
        el[1].members &&
        typeof el[1].members === "object" &&
        el[1].members !== null
      ) {
        Object.entries(el[1].members).forEach((e, i) => {
          // Check if this member is a filter
          if (e[1] && e[1].is_filter === true) {
            // Determine the source for this filter
            const filterSource = e[1]?.source || dataSource || "common";

            // Determine attribute_type based on the data source
            let attributeType = "common"; // default
            if (dataSource) {
              // If dataSource is explicitly provided from parent, use it
              attributeType = dataSource;
            } else if (filterSource) {
              // Otherwise use the filter's source
              const sourceLower = filterSource.toLowerCase();
              if (sourceLower === "author") {
                attributeType = "author";
              } else if (
                sourceLower === "mentions" ||
                sourceLower === "mention"
              ) {
                attributeType = "mentions";
              } else if (
                sourceLower === "tickets" ||
                sourceLower === "ticket"
              ) {
                attributeType = "tickets";
              } else if (
                sourceLower === "page" ||
                sourceLower === "pages" ||
                sourceLower === "page insights"
              ) {
                attributeType = "pages";
              } else {
                attributeType = "common";
              }
            }

            const filterItem = {
              title: e[1]?.title || e[0],
              values: e[1]?.values,
              datatype: e[1]?.datatype,
              source: filterSource, // Use dataSource from parent if not specified
              attribute: e[0],
              attribute_type: attributeType, // Add the new attribute_type key
              type: el[0],
              is_searchable: e[1].is_searchable,
              id_attribute: e[1]?.id_attribute,
              filter_type: e?.[1]?.filter_type ? e?.[1]?.filter_type : null,
              default_value: e?.[1]?.default_value
                ? e?.[1]?.default_value
                : null,
            };
            // console.log("Adding filter to myArray:", filterItem);
            if (
              supported_filters?.length &&
              supported_filters.includes(filterItem?.attribute)
            ) {
              myArray.push(filterItem);
            } else if (!supported_filters) {
              myArray.push(filterItem);
            }
          }
        });
      }
      if (
        el[0] === "others" &&
        !supported_filters &&
        el[1]?.members?.Description
      ) {
        const descSource =
          el[1]?.members?.Description?.source ||
          el[1]?.members?.Description?.data_source ||
          "common";

        // Determine attribute_type for Description
        let descAttributeType = "common";
        const descSourceLower = descSource.toLowerCase();
        if (descSourceLower === "author") {
          descAttributeType = "author";
        } else if (
          descSourceLower === "mentions" ||
          descSourceLower === "mention"
        ) {
          descAttributeType = "mentions";
        } else if (
          descSourceLower === "tickets" ||
          descSourceLower === "ticket"
        ) {
          descAttributeType = "tickets";
        } else if (
          descSourceLower === "page" ||
          descSourceLower === "pages" ||
          descSourceLower === "page insights"
        ) {
          descAttributeType = "pages";
        }

        myArray.push({
          title: el[1]?.members?.Description?.title,
          datatype: el[1]?.members?.Description?.datatype,
          source: descSource,
          attribute: "Description",
          attribute_type: descAttributeType, // Add attribute_type for Description
        });
      }
      if (preDefineTabs) {
        const preDefineSource = el[1]?.source || el[1]?.data_source || "common";

        // Determine attribute_type for predefined tabs
        let preDefineAttributeType = "common";
        const preDefineSourceLower = preDefineSource.toLowerCase();
        if (preDefineSourceLower === "author") {
          preDefineAttributeType = "author";
        } else if (
          preDefineSourceLower === "mentions" ||
          preDefineSourceLower === "mention"
        ) {
          preDefineAttributeType = "mentions";
        } else if (
          preDefineSourceLower === "tickets" ||
          preDefineSourceLower === "ticket"
        ) {
          preDefineAttributeType = "tickets";
        } else if (
          preDefineSourceLower === "page" ||
          preDefineSourceLower === "pages" ||
          preDefineSourceLower === "page insights"
        ) {
          preDefineAttributeType = "pages";
        }

        if (supported_filters?.length && supported_filters.includes(el[0])) {
          myArray.push({
            title: el[1]?.title,
            datatype: el[1]?.datatype,
            source: preDefineSource,
            attribute: el[0],
            attribute_type: preDefineAttributeType, // Add attribute_type for predefined tabs
            values: el[1]?.values?.map((e) => e?.name),
            id: el[1]?.values,
          });
        } else if (!supported_filters) {
          myArray.push({
            title: el[1]?.title,
            datatype: el[1]?.datatype,
            source: preDefineSource,
            attribute: el[0],
            attribute_type: preDefineAttributeType, // Add attribute_type for predefined tabs
            values: el[1]?.values?.map((e) => e?.name),
            id: el[1]?.values,
          });
        }
      }
    });
  }
  return myArray;
};

export const getAllFilters = (
  graphConditionConfig,
  panes,
  index,
  section_index,
  widget_index,
  brands,
  brand_ids,
  widgetObj,
  sectionObj,
  quickFilterRes
) => {
  let GlobalFilter = panes?.[index]?.filters ? panes[index].filters : [];

  let hidden_filter = panes?.[index]?.hidden_filter
    ? [panes?.[index]?.hidden_filter]
    : [];

  let quickFilterAttribute = panes?.[index]?.quick_filter
    ? panes?.[index]?.quick_filter === "AccountID"
      ? "SettingID"
      : panes?.[index]?.quick_filter === "Category"
      ? "CategoryID"
      : panes?.[index]?.quick_filter
    : null;
  let quickFilter = quickFilterRes?.[0]?.columns
    ? quickFilterRes
    : panes?.[index]?.quick_filter_value
    ? [panes?.[index]?.quick_filter_value]
    : [];

  if (quickFilterAttribute === "Ads_Campaign") {
    let adsetFilterRes = [];
    let adsetFilter = adsetFilterRes?.[0]?.columns
      ? adsetFilterRes
      : panes?.[index]?.adsset_value?.attribute
      ? [panes?.[index]?.adsset_value]
      : [];
    if (adsetFilter?.length) {
      quickFilter = [...quickFilter, ...adsetFilter];
    }
    let adsFilterRes = [];
    let adsFilter = adsFilterRes?.[0]?.columns
      ? adsFilterRes
      : panes?.[index]?.ads_value?.attribute
      ? [panes?.[index]?.ads_value]
      : [];
    if (adsFilter?.length) {
      quickFilter = [...quickFilter, ...adsFilter];
    }
  }
  // let quickFilter = quickFilterRes?.[0]?.columns
  //   ? quickFilterRes
  //   : quickFilterAttribute && GlobalFilter?.length
  //   ? GlobalFilter?.filter((el) => el?.attribute === quickFilterAttribute)
  //   : [];
  let getFilters = sectionObj
    ? sectionObj?.brand_ids || sectionObj?.brand_groups
      ? getBrands(
          brands,
          sectionObj?.brand_ids ? sectionObj?.brand_ids : null,
          sectionObj?.singleBrands,
          sectionObj?.brand_groups ? sectionObj?.brand_groups : null
        )
      : null
    : panes[index]?.sections
    ? getBrands(
        brands,
        panes[index]?.sections?.[section_index]?.brand_ids
          ? panes[index]?.sections?.[section_index]?.brand_ids
          : null,
        widgetObj?.singleBrands,
        panes[index]?.sections?.[section_index]?.brand_groups
          ? panes[index]?.sections?.[section_index]?.brand_groups
          : null
      )
    : null;
  let sectionBrandFilter = getFilters ? [getFilters] : [];
  let sectionDateFilter = sectionObj?.dateFilters
    ? sectionObj?.dateFilters
    : panes?.[index]?.sections
    ? panes?.[index]?.sections[section_index]?.dateFilters
      ? panes?.[index]?.sections[section_index]?.dateFilters
      : []
    : panes[index]?.section && panes[index]?.section[0]?.dateFilters
    ? panes[index]?.section[0]?.dateFilters
    : [];
  let sectionFilter = sectionObj?.filters
    ? sectionObj?.filters
    : panes[index]?.sections
    ? panes[index]?.sections[section_index]?.filters
      ? panes[index]?.sections[section_index]?.filters
      : []
    : panes[index]?.section && panes[index]?.section[0]?.filters
    ? panes[index]?.section[0]?.filters
    : [];
  // to filter section level date and brands filter if these are exits in sectionFilter
  sectionFilter = sectionFilter?.filter(
    (el) => el?.attribute !== "CreatedDate" && el?.attribute !== "BrandID"
  );
  let WidgetFilter = widgetObj?.filters
    ? widgetObj?.filters
    : panes && panes[index]?.sections
    ? panes[index]?.sections[section_index]?.widgets?.[widget_index]?.filters
      ? panes[index]?.sections[section_index]?.widgets?.[widget_index]?.filters
      : []
    : panes[index]?.section &&
      panes[index]?.section[0]?.widgets?.[widget_index]?.filters
    ? panes[index]?.section[0]?.widgets?.[widget_index]?.filters
    : [];

  // to filter widget level date and brands filter if these are exits in WidgetFilter
  WidgetFilter = WidgetFilter?.filter(
    (el) => el?.attribute !== "BrandID" && el?.attribute !== "CreatedDate"
  );
  let finalBrand_list =
    brand_ids?.length > 0 || widgetObj?.brand_groups?.length > 0
      ? getBrands(
          brands,
          brand_ids,
          widgetObj?.singleBrands,
          widgetObj?.brand_groups
        )
      : null;
  let WidgetBrandFilter = finalBrand_list ? [finalBrand_list] : [];
  let WidgetDateFilter = widgetObj?.duration?.from
    ? [
        {
          attribute: "CreatedDate",
          type: "datetime",
          columns: widgetObj?.duration,
        },
      ]
    : [];
  if (WidgetDateFilter?.length === 0) {
    if (panes[index]?.sections || panes[index]?.section) {
      if (
        (panes[index]?.sections &&
          panes[index]?.sections[section_index]?.widgets?.[widget_index]
            ?.dateFilters) ||
        (panes[index]?.section &&
          panes[index]?.section[0]?.widgets?.[widget_index]?.dateFilters)
      ) {
        WidgetDateFilter = panes[index]?.sections
          ? panes[index]?.sections[section_index]?.widgets?.[widget_index]
              ?.dateFilters
          : panes[index]?.section[0]?.widgets?.[widget_index]?.dateFilters;
      } else if (
        (panes[index]?.sections &&
          panes[index]?.sections[section_index]?.widgets?.[widget_index]
            ?.start_date) ||
        (panes[index]?.section &&
          panes[index]?.section[0]?.widgets?.[widget_index]?.start_date)
      ) {
        let relativeDuration;
        if (
          panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
            ?.relative_duration?.is_relative
        ) {
          relativeDuration = getMtdYtdDuration(
            panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
              ?.relative_duration?.relative_type
          );
        } else if (
          panes[index]?.section?.[0]?.widgets?.[widget_index]?.relative_duration
            ?.is_relative
        ) {
          relativeDuration = getMtdYtdDuration(
            panes[index]?.section?.[0]?.widgets?.[widget_index]
              ?.relative_duration?.relative_type
          );
        }
        WidgetDateFilter = [
          {
            attribute: "CreatedDate",
            type: "datetime",
            columns: relativeDuration
              ? relativeDuration
              : {
                  from: panes[index]?.sections
                    ? panes[index]?.sections[section_index]?.widgets?.[
                        widget_index
                      ]?.start_date
                    : panes[index]?.section[0]?.widgets?.[widget_index]
                        ?.start_date,
                  to: panes[index]?.sections
                    ? panes[index]?.sections[section_index]?.widgets?.[
                        widget_index
                      ]?.end_date
                    : panes[index]?.section[0]?.widgets?.[widget_index]
                        ?.end_date,
                },
          },
        ];
      } else {
        WidgetDateFilter = [];
      }
    }
  }
  //combine all filters array to make final filter array
  let totalFilter = [];
  let isSectionLocked = sectionObj?.is_locked
    ? sectionObj?.is_locked
    : panes[index]?.sections
    ? panes[index]?.sections[section_index]?.is_locked
      ? panes[index]?.sections[section_index]?.is_locked
      : false
    : panes[index]?.section && panes[index]?.section[0]?.is_locked
    ? panes[index]?.section[0]?.is_locked
    : false;
  isSectionLocked = isSectionLocked ? isSectionLocked : false;
  let isWidgetLocked = widgetObj?.is_locked
    ? widgetObj?.is_locked
    : panes[index]?.sections
    ? panes[index]?.sections[section_index]?.widgets?.[widget_index]?.is_locked
      ? panes[index]?.sections[section_index]?.widgets?.[widget_index]
          ?.is_locked
      : false
    : panes[index]?.section &&
      panes[index]?.section[0]?.widgets?.[widget_index]?.is_locked
    ? panes[index]?.section[0]?.widgets?.[widget_index]?.is_locked
    : false;
  isWidgetLocked = isWidgetLocked ? isWidgetLocked : false;
  let widget_type = widgetObj?.type
    ? widgetObj?.type
    : panes[index]?.sections
    ? panes[index]?.sections[section_index]?.widgets?.[widget_index]?.type
      ? panes[index]?.sections[section_index]?.widgets?.[widget_index]?.type
      : false
    : panes[index]?.section &&
      panes[index]?.section[0]?.widgets?.[widget_index]?.type
    ? panes[index]?.section[0]?.widgets?.[widget_index]?.type
    : false;
  let widget_data_source = widgetObj?.data_source
    ? widgetObj?.data_source
    : panes?.[index]?.sections
    ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
        ?.data_source
      ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
          ?.data_source
      : false
    : panes?.[index]?.section &&
      panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.data_source
    ? panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.data_source
    : false;
  let widget_id = widgetObj?.widget_id
    ? widgetObj?.widget_id
    : panes?.[index]?.sections
    ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
        ?.widget_id
      ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
          ?.widget_id
      : false
    : panes?.[index]?.section &&
      panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.widget_id
    ? panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.widget_id
    : false;
  widget_id = widget_id ? widget_id : false;
  widget_data_source = widget_data_source ? widget_data_source : false;
  widget_type = widget_type ? widget_type : false;

  // let saved_similar_hidden_filter_obj = null;
  // let saved_similar_quick_filter_obj = null;
  // if (quickFilter?.length && GlobalFilter?.length) {
  //   saved_similar_quick_filter_obj = getSimilarStaticFilter(
  //     [],
  //     GlobalFilter,
  //     quickFilter
  //   );
  //   GlobalFilter = GlobalFilter?.filter(
  //     (el) => el?.attribute !== quickFilter?.[0]?.attribute
  //   );
  // }

  // // console.log("panes?.[index]", panes?.[index]);

  // if (
  //   hidden_filter?.length &&
  //   GlobalFilter?.length &&
  //   (panes?.[index]?.private_conversation ||
  //     panes?.[index]?.private_conversation === undefined)
  // ) {
  //   saved_similar_hidden_filter_obj = getSimilarStaticFilter(
  //     hidden_filter,
  //     GlobalFilter,
  //     []
  //   );
  //   GlobalFilter = GlobalFilter?.filter(
  //     (el) => el?.attribute !== hidden_filter?.[0]?.attribute
  //   );
  // }

  // console.log(
  //   "saved_similar_hidden_filter_obj : ",
  //   saved_similar_hidden_filter_obj,
  //   "saved_similar_quick_filter_obj : ",
  //   saved_similar_quick_filter_obj
  // );

  // if (saved_similar_hidden_filter_obj?.filter?.length) {
  //   GlobalFilter = [
  //     ...GlobalFilter,
  //     ...saved_similar_hidden_filter_obj?.filter,
  //   ];
  // }
  // if (saved_similar_quick_filter_obj?.filter?.length) {
  //   GlobalFilter = [...GlobalFilter, ...saved_similar_quick_filter_obj?.filter];
  // }

  // console.log("GlobalFilter : ", GlobalFilter);

  if (isSectionLocked) {
    if (isWidgetLocked) {
      totalFilter = [...hidden_filter, ...quickFilter, ...WidgetFilter];
    } else if (!isWidgetLocked) {
      let finalFilter =
        widget_type === "predefined" &&
        widget_data_source !== "realtime" &&
        !(
          widget_id &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.length > 0 &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.includes(widget_id)
        )
          ? [...WidgetFilter]
          : [...sectionFilter, ...WidgetFilter];

      totalFilter = [
        ...hidden_filter,
        ...quickFilter,
        ...finalFilter,
        ...WidgetBrandFilter,
        ...WidgetDateFilter,
      ];
    }
  } else if (!isSectionLocked) {
    if (isWidgetLocked) {
      totalFilter = [...hidden_filter, ...quickFilter, ...WidgetFilter];
    } else if (!isWidgetLocked) {
      let finalFilter = [];

      finalFilter =
        widget_type === "predefined" &&
        widget_data_source !== "realtime" &&
        !(
          widget_id &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.length > 0 &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.includes(widget_id)
        )
          ? [...WidgetFilter]
          : [...GlobalFilter, ...sectionFilter, ...WidgetFilter];
      totalFilter = [
        ...hidden_filter,
        ...quickFilter,
        ...finalFilter,
        ...sectionBrandFilter,
        ...WidgetBrandFilter,
        ...sectionDateFilter,
        ...WidgetDateFilter,
      ];
    }
  }
  return totalFilter;
};

export const getAllShareFilters = (
  graphConditionConfig,
  shareTemplateData,
  section_index,
  widget_index,
  shareBrands
) => {
  let hidden_filter = shareTemplateData?.hidden_filter
    ? [shareTemplateData?.hidden_filter]
    : [];

  let quickFilterAttribute =
    shareTemplateData?.allow_multiple_selection &&
    shareTemplateData?.quick_filter_value
      ? shareTemplateData?.quick_filter_value?.attribute
      : shareTemplateData?.quick_filter
      ? shareTemplateData?.quick_filter?.attribute
      : null;
  let quickFilter =
    shareTemplateData?.allow_multiple_selection &&
    shareTemplateData?.quick_filter_value
      ? [shareTemplateData?.quick_filter_value]
      : shareTemplateData?.quick_filter
      ? [shareTemplateData?.quick_filter]
      : [];
  // to set extra subset filter of quick filter in charts payload
  if (quickFilterAttribute && quickFilterAttribute === "Ads_Campaign") {
    let adsetFilter = shareTemplateData?.adsset_value?.attribute
      ? [shareTemplateData?.adsset_value]
      : [];
    if (adsetFilter?.length) {
      quickFilter = [...quickFilter, ...adsetFilter];
    }
    let adsFilter = shareTemplateData?.ads_value?.attribute
      ? [shareTemplateData?.ads_value]
      : [];
    if (adsFilter?.length) {
      quickFilter = [...quickFilter, ...adsFilter];
    }
  }

  let section = shareTemplateData?.sections
    ? shareTemplateData?.sections?.[section_index]
    : shareTemplateData?.section?.[0];
  let section_brands = getBrands(
    shareBrands?.brand_groups,
    section?.brand_ids,
    shareBrands?.brand_list,
    section?.brand_groups
  );

  let sectionBrandFilter = section_brands ? [section_brands] : [];

  let sectionDateFilter = [];
  if (sectionDateFilter?.length === 0) {
    if (shareTemplateData?.sections) {
      if (shareTemplateData?.sections[section_index]?.dateFilters) {
        sectionDateFilter =
          shareTemplateData?.sections[section_index]?.dateFilters;
      } else if (shareTemplateData?.sections[section_index]?.start_date) {
        let relativeDuration;
        if (
          shareTemplateData?.sections[section_index]?.relative_duration
            ?.is_relative
        ) {
          relativeDuration = getMtdYtdDuration(
            shareTemplateData?.sections[section_index]?.relative_duration
              ?.relative_type
          );
        }
        sectionDateFilter = [
          {
            attribute: "CreatedDate",
            type: "datetime",
            columns: relativeDuration
              ? relativeDuration
              : {
                  from: shareTemplateData?.sections[section_index]?.start_date,
                  to: shareTemplateData?.sections[section_index]?.end_date,
                },
          },
        ];
      } else {
        sectionDateFilter = [];
      }
    }
  }

  let sectionFilter = shareTemplateData?.sections
    ? shareTemplateData?.sections?.[section_index]?.filters
      ? shareTemplateData?.sections?.[section_index]?.filters
      : []
    : shareTemplateData?.section?.[0]?.filters
    ? shareTemplateData?.section?.[0]?.filters
    : [];
  // to filter section level date and brands filter if these are exits in sectionFilter
  sectionFilter = sectionFilter?.filter(
    (el) => el?.attribute !== "CreatedDate" && el?.attribute !== "BrandID"
  );
  let WidgetFilter = shareTemplateData?.sections
    ? shareTemplateData?.sections?.[section_index]?.widgets?.[widget_index]
        ?.filters
      ? shareTemplateData?.sections?.[section_index]?.widgets?.[widget_index]
          ?.filters
      : []
    : shareTemplateData?.section &&
      shareTemplateData?.section?.[0]?.widgets?.[widget_index]?.filters
    ? shareTemplateData?.section?.[0]?.widgets?.[widget_index]?.filters
    : [];
  // to filter widget level date and brands filter if these are exits in WidgetFilter
  WidgetFilter = WidgetFilter?.filter(
    (el) => el?.attribute !== "BrandID" && el?.attribute !== "CreatedDate"
  );
  let widegetBrand_list = getBrands(
    shareBrands?.brand_groups,
    section?.widgets?.[widget_index]?.brand_ids,
    shareBrands?.brand_list,
    section?.widgets?.[widget_index]?.brand_groups
  );
  let WidgetBrandFilter = widegetBrand_list ? [widegetBrand_list] : [];

  let WidgetDateFilter = [];
  if (WidgetDateFilter?.length === 0) {
    if (section) {
      if (section?.widgets?.[widget_index]?.dateFilters) {
        WidgetDateFilter = section?.widgets[widget_index]?.dateFilters;
      } else if (section?.widgets?.[widget_index]?.start_date) {
        let relativeDuration;
        if (section?.widgets?.[widget_index]?.relative_duration?.is_relative) {
          relativeDuration = getMtdYtdDuration(
            section?.widgets?.[widget_index]?.relative_duration?.relative_type
          );
        }
        WidgetDateFilter = [
          {
            attribute: "CreatedDate",
            type: "datetime",
            columns: relativeDuration
              ? relativeDuration
              : {
                  from: section?.widgets[widget_index]?.start_date,
                  to: section?.widgets[widget_index]?.end_date,
                },
          },
        ];
      } else {
        WidgetDateFilter = [];
      }
    }
  }

  //combine all filters array to make final filter array

  let totalFilter = [];
  let isSectionLocked = shareTemplateData?.sections
    ? shareTemplateData?.sections[section_index]?.is_locked
      ? shareTemplateData?.sections[section_index]?.is_locked
      : false
    : false;
  let isWidgetLocked = section
    ? section?.widgets?.[widget_index]?.is_locked
      ? section?.widgets?.[widget_index]?.is_locked
      : false
    : false;
  let widget_type = section
    ? section?.widgets?.[widget_index]?.type
      ? section?.widgets?.[widget_index]?.type
      : false
    : false;
  let widget_data_source = section
    ? section?.widgets?.[widget_index]?.data_source
      ? section?.widgets?.[widget_index]?.data_source
      : false
    : false;
  let widget_id = section
    ? section?.widgets?.[widget_index]?.widget_id
      ? section?.widgets?.[widget_index]?.widget_id
      : false
    : false;
  widget_id = widget_id ? widget_id : false;
  widget_data_source = widget_data_source ? widget_data_source : false;
  //global filters + comp_hidden_filters
  let global_filters = shareTemplateData?.filters
    ? shareTemplateData?.filters
    : [];
  if (isSectionLocked) {
    if (isWidgetLocked) {
      totalFilter = [...hidden_filter, ...quickFilter, ...WidgetFilter];
    } else if (!isWidgetLocked) {
      let finalFilter =
        widget_type === "predefined" &&
        widget_data_source !== "realtime" &&
        !(
          widget_id &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.length > 0 &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.includes(widget_id)
        )
          ? [...WidgetFilter]
          : [...sectionFilter, ...WidgetFilter];

      totalFilter = [
        ...hidden_filter,
        ...quickFilter,
        ...finalFilter,
        ...WidgetBrandFilter,
        ...WidgetDateFilter,
      ];
    }
  } else if (!isSectionLocked) {
    if (isWidgetLocked) {
      totalFilter = [...hidden_filter, ...quickFilter, ...WidgetFilter];
    } else if (!isWidgetLocked) {
      let finalFilter = [];

      finalFilter =
        widget_type === "predefined" &&
        widget_data_source !== "realtime" &&
        !(
          widget_id &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.length > 0 &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.includes(widget_id)
        )
          ? [...WidgetFilter]
          : [...global_filters, ...sectionFilter, ...WidgetFilter];

      totalFilter = [
        ...hidden_filter,
        ...quickFilter,
        ...finalFilter,
        ...sectionBrandFilter,
        ...WidgetBrandFilter,
        ...sectionDateFilter,
        ...WidgetDateFilter,
      ];
    }
  }
  return totalFilter;
};
export const getAllTemplateFilters = (
  graphConditionConfig,
  Section,
  section_index,
  widget_index,
  SectionObj
) => {
  let GlobalFilter = SectionObj?.filters ? SectionObj?.filters : [];
  let hidden_filter = SectionObj?.hidden_filter
    ? [SectionObj?.hidden_filter]
    : [];
  let quickFilter = SectionObj?.quick_filter_value
    ? [SectionObj?.quick_filter_value]
    : [];

  if (
    SectionObj?.quick_filter_value &&
    SectionObj?.quick_filter_value?.attribute === "Ads_Campaign"
  ) {
    let adsetFilter = SectionObj?.adsset_value?.attribute
      ? [SectionObj?.adsset_value]
      : [];
    if (adsetFilter?.length) {
      quickFilter = [...quickFilter, ...adsetFilter];
    }
    let adsFilter = SectionObj?.ads_value?.attribute
      ? [SectionObj?.ads_value]
      : [];
    if (adsFilter?.length) {
      quickFilter = [...quickFilter, ...adsFilter];
    }
  }

  let sectionBrandFilter =
    Section[section_index] && Section[section_index]?.brands
      ? Section[section_index]?.brands
      : [];
  let sectionDateFilter = Section[section_index]?.dateFilters
    ? Section[section_index]?.dateFilters?.[0]?.columns
      ? Section[section_index]?.dateFilters
      : [
          {
            attribute: "CreatedDate",
            type: "datetime",
            columns: {
              from: Section[section_index]?.dateFilters?.from,
              to: Section[section_index]?.dateFilters?.to,
            },
          },
        ]
    : [];
  let sectionFilter =
    Section[section_index] && Section[section_index]?.filters
      ? Section[section_index]?.filters
      : [];
  // to filter section level date and brands filter if these are exits in sectionFilter
  sectionFilter = sectionFilter?.filter(
    (el) => el?.attribute !== "CreatedDate" && el?.attribute !== "BrandID"
  );
  let WidgetFilter = SectionObj?.filterChange
    ? SectionObj?.currentFilter
    : section_index
    ? Section?.[section_index] &&
      Section?.[section_index]?.data[widget_index]?.filters
      ? Section?.[section_index]?.data[widget_index]?.filters
      : []
    : Section?.[0]?.data[widget_index]?.filters
    ? Section?.[0]?.data[widget_index]?.filters
    : [];

  // to filter widget level date and brands filter if these are exits in WidgetFilter
  WidgetFilter = WidgetFilter?.filter(
    (el) => el?.attribute !== "BrandID" && el?.attribute !== "CreatedDate"
  );
  let WidgetBrandFilter = section_index
    ? Section?.[section_index] &&
      Section?.[section_index]?.data?.[widget_index]?.brands
      ? Section?.[section_index]?.data?.[widget_index]?.brands
      : []
    : Section?.[0]?.data?.[widget_index]?.brands
    ? Section?.[0]?.data?.[widget_index]?.brands
    : [];
  let WidgetDateFilter = section_index
    ? Section?.[section_index]?.data?.[widget_index]?.dateFilters
      ? Section?.[section_index]?.data?.[widget_index]?.dateFilters?.columns
        ? Section?.[section_index]?.data?.[widget_index]?.dateFilters
        : [
            {
              attribute: "CreatedDate",
              type: "datetime",
              columns: {
                from: Section?.[section_index]?.data?.[widget_index]
                  ?.dateFilters?.from,
                to: Section?.[section_index]?.data?.[widget_index]?.dateFilters
                  ?.to,
              },
            },
          ]
      : Section?.[section_index]?.data?.[widget_index]?.duration?.from
      ? [
          {
            attribute: "CreatedDate",
            type: "datetime",
            columns: Section?.[section_index]?.data?.[widget_index]?.duration,
          },
        ]
      : []
    : Section?.[0]?.data?.[widget_index]?.dateFilters
    ? Section?.[0]?.data?.[widget_index]?.dateFilters?.columns
      ? Section?.[0]?.data?.[widget_index]?.dateFilters
      : [
          {
            attribute: "CreatedDate",
            type: "datetime",
            columns: {
              from: Section?.[0]?.data?.[widget_index]?.dateFilters?.from,
              to: Section?.[0]?.data?.[widget_index]?.dateFilters?.to,
            },
          },
        ]
    : Section?.[0]?.data?.[widget_index]?.duration?.from
    ? [
        {
          attribute: "CreatedDate",
          type: "datetime",
          columns: Section?.[0]?.data?.[widget_index]?.duration,
        },
      ]
    : [];

  //combine all filters array to make final filter array

  let totalFilter = [];
  let isSectionLocked = section_index
    ? Section[section_index] && Section[section_index]?.is_locked
      ? Section[section_index]?.is_locked
      : false
    : Section && Section[0]?.is_locked
    ? Section[0]?.is_locked
    : false;
  let isWidgetLocked = section_index
    ? Section[section_index] &&
      Section[section_index]?.data[widget_index]?.is_locked
      ? Section[section_index]?.data[widget_index]?.is_locked
      : false
    : Section && Section[0]?.data[widget_index]?.is_locked
    ? Section[0]?.data[widget_index]?.is_locked
    : false;
  let widget_type = section_index
    ? Section[section_index] && Section[section_index]?.data[widget_index]?.type
      ? Section[section_index]?.data[widget_index]?.type
      : false
    : Section && Section[0]?.data[widget_index]?.type
    ? Section[0]?.data[widget_index]?.type
    : false;
  let widget_data_source = section_index
    ? Section[section_index] &&
      Section[section_index]?.data[widget_index]?.data_source
      ? Section[section_index]?.data[widget_index]?.data_source
      : false
    : Section && Section[0]?.data[widget_index]?.data_source
    ? Section[0]?.data[widget_index]?.data_source
    : false;
  let widget_id = section_index
    ? Section[section_index] &&
      Section[section_index]?.data[widget_index]?.widget_id
      ? Section[section_index]?.data[widget_index]?.widget_id
      : false
    : Section && Section[0]?.data[widget_index]?.widget_id
    ? Section[0]?.data[widget_index]?.widget_id
    : false;
  widget_id = widget_id ? widget_id : false;
  widget_data_source = widget_data_source ? widget_data_source : false;
  if (isSectionLocked) {
    if (isWidgetLocked) {
      totalFilter = [...hidden_filter, ...quickFilter, ...WidgetFilter];
    } else if (!isWidgetLocked) {
      let finalFilter =
        widget_type === "predefined" &&
        widget_data_source !== "realtime" &&
        !(
          widget_id &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.length > 0 &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.includes(widget_id)
        )
          ? [...WidgetFilter]
          : [...sectionFilter, ...WidgetFilter];

      totalFilter = [
        ...hidden_filter,
        ...quickFilter,
        ...finalFilter,
        ...WidgetBrandFilter,
        ...WidgetDateFilter,
      ];
    }
  } else if (!isSectionLocked) {
    if (isWidgetLocked) {
      totalFilter = [...hidden_filter, ...quickFilter, ...WidgetFilter];
    } else if (!isWidgetLocked) {
      let finalFilter = [];

      finalFilter =
        widget_type === "predefined" &&
        widget_data_source !== "realtime" &&
        !(
          widget_id &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.length > 0 &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.includes(widget_id)
        )
          ? [...WidgetFilter]
          : [...GlobalFilter, ...sectionFilter, ...WidgetFilter];
      totalFilter = [
        ...hidden_filter,
        ...quickFilter,
        ...finalFilter,
        ...sectionBrandFilter,
        ...WidgetBrandFilter,
        ...sectionDateFilter,
        ...WidgetDateFilter,
      ];
    }
  }

  return totalFilter;
};
export const getAllDeepDiveDashboardFilters = (
  graphConditionConfig,
  dashboardData, // This is indicating to parent dashboard
  templateData, // This is for currect deep dive template data
  section_index,
  widget_index,
  brandsContainter
) => {
  let GlobalFilter = dashboardData?.filters ? dashboardData.filters : [];
  let templateFilter = templateData?.filters ? templateData.filters : [];
  if (
    templateFilter &&
    Array.isArray(templateFilter) &&
    templateFilter?.length > 0
  ) {
    GlobalFilter = [...GlobalFilter, ...templateFilter];
  }
  let hidden_filter = templateData?.hidden_filter
    ? [templateData?.hidden_filter]
    : [];

  let quickFilterAttribute = templateData?.quick_filter
    ? templateData?.quick_filter === "AccountID"
      ? "SettingID"
      : templateData?.quick_filter === "Category"
      ? "CategoryID"
      : templateData?.quick_filter
    : null;
  let quickFilter = templateData?.quick_filter_value
    ? [templateData?.quick_filter_value]
    : [];

  if (quickFilterAttribute === "Ads_Campaign") {
    let adsetFilterRes = [];
    let adsetFilter = adsetFilterRes?.[0]?.columns
      ? adsetFilterRes
      : templateData?.adsset_value?.attribute
      ? [templateData?.adsset_value]
      : [];
    if (adsetFilter?.length) {
      quickFilter = [...quickFilter, ...adsetFilter];
    }
    let adsFilterRes = [];
    let adsFilter = adsFilterRes?.[0]?.columns
      ? adsFilterRes
      : templateData?.ads_value?.attribute
      ? [templateData?.ads_value]
      : [];
    if (adsFilter?.length) {
      quickFilter = [...quickFilter, ...adsFilter];
    }
  }

  let section_data = templateData?.sections
    ? templateData?.sections?.[section_index]
    : null;
  let widget_metadata = section_data?.widgets?.[widget_index]
    ? section_data?.widgets?.[widget_index]
    : null;

  let getFilters = templateData?.sections
    ? getBrands(
        brandsContainter?.brandGroupList,
        section_data?.brand_ids ? section_data?.brand_ids : null,
        brandsContainter?.singleBrands,
        section_data?.brand_groups ? section_data?.brand_groups : null
      )
    : null;
  let sectionBrandFilter = getFilters ? [getFilters] : [];
  let sectionDateFilter = section_data?.dateFilters
    ? section_data?.dateFilters
    : [];
  let sectionFilter = section_data?.filters ? section_data?.filters : [];
  // to filter section level date and brands filter if these are exits in sectionFilter
  sectionFilter = sectionFilter?.filter(
    (el) => el?.attribute !== "CreatedDate" && el?.attribute !== "BrandID"
  );

  let WidgetFilter = widget_metadata?.filters ? widget_metadata?.filters : [];

  // to filter widget level date and brands filter if these are exits in WidgetFilter
  WidgetFilter = WidgetFilter?.filter(
    (el) => el?.attribute !== "BrandID" && el?.attribute !== "CreatedDate"
  );
  let finalBrand_list =
    brandsContainter?.brand_ids?.length > 0 ||
    brandsContainter?.brand_groups?.length > 0
      ? getBrands(
          brandsContainter?.brandGroupList,
          brandsContainter?.brand_ids,
          brandsContainter?.singleBrands,
          brandsContainter?.brand_groups
        )
      : null;
  let WidgetBrandFilter = finalBrand_list ? [finalBrand_list] : [];
  let WidgetDateFilter = widget_metadata?.duration?.from
    ? [
        {
          attribute: "CreatedDate",
          type: "datetime",
          columns: widget_metadata?.duration,
        },
      ]
    : [];
  if (WidgetDateFilter?.length === 0) {
    if (widget_metadata?.dateFilters) {
      WidgetDateFilter = widget_metadata?.dateFilters;
    } else if (widget_metadata?.start_date) {
      WidgetDateFilter = [
        {
          attribute: "CreatedDate",
          type: "datetime",
          columns: {
            from: widget_metadata?.start_date,
            to: widget_metadata?.end_date,
          },
        },
      ];
    } else {
      WidgetDateFilter = [];
    }
  }
  //combine all filters array to make final filter array
  let totalFilter = [];
  let isSectionLocked = section_data?.is_locked
    ? section_data?.is_locked
    : false;
  isSectionLocked = !!isSectionLocked;
  let isWidgetLocked = widget_metadata?.is_locked
    ? widget_metadata?.is_locked
    : false;
  isWidgetLocked = !!isWidgetLocked;
  let widget_type = widget_metadata?.type ? widget_metadata?.type : false;
  let widget_data_source = widget_metadata?.data_source
    ? widget_metadata?.data_source
    : false;
  let widget_id = widget_metadata?.widget_id
    ? widget_metadata?.widget_id
    : false;

  if (isSectionLocked) {
    if (isWidgetLocked) {
      totalFilter = [...hidden_filter, ...quickFilter, ...WidgetFilter];
    } else if (!isWidgetLocked) {
      let finalFilter =
        widget_type === "predefined" &&
        widget_data_source !== "realtime" &&
        !(
          widget_id &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.length > 0 &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.includes(widget_id)
        )
          ? [...WidgetFilter]
          : [...sectionFilter, ...WidgetFilter];

      totalFilter = [
        ...hidden_filter,
        ...quickFilter,
        ...finalFilter,
        ...WidgetBrandFilter,
        ...WidgetDateFilter,
      ];
    }
  } else if (!isSectionLocked) {
    if (isWidgetLocked) {
      totalFilter = [...hidden_filter, ...quickFilter, ...WidgetFilter];
    } else if (!isWidgetLocked) {
      let finalFilter = [];

      finalFilter =
        widget_type === "predefined" &&
        widget_data_source !== "realtime" &&
        !(
          widget_id &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.length > 0 &&
          graphConditionConfig?.["ticket_user_widget_ids"]?.includes(widget_id)
        )
          ? [...WidgetFilter]
          : [...GlobalFilter, ...sectionFilter, ...WidgetFilter];
      totalFilter = [
        ...hidden_filter,
        ...quickFilter,
        ...finalFilter,
        ...sectionBrandFilter,
        ...WidgetBrandFilter,
        ...sectionDateFilter,
        ...WidgetDateFilter,
      ];
    }
  }
  return totalFilter;
};
export const getUniqueFilters = (finalFilter) => {
  const result = [];
  const map = new Map();
  for (const item of finalFilter) {
    if (!map.has(item?.attribute)) {
      map.set(item?.attribute, true);
      result.push({
        attribute: item?.attribute,
        type: item?.type,
        data_source: item?.data_source || item?.source,
        columns: item?.columns,
        predefined_filters: item?.predefined_filters,
      });
    } else {
      const resultItemIndex = result.findIndex(
        (el) => el?.attribute === item?.attribute
      );
      if (resultItemIndex !== -1) {
        result[resultItemIndex].columns = item?.columns?.length
          ? item?.columns
          : [];
        // for (let i = 0; i < item?.columns?.length; i++) {
        //   if (
        //     !resultItem?.columns?.find(
        //       (el) => el?.name === item?.columns?.[i]?.name
        //     )
        //   ) {
        //     console.log("If got called ")
        //     resultItem?.columns.push({
        //       name: item?.columns[i]?.name ? item?.columns[i]?.name : null,
        //       type: item?.columns[i]?.type ? item?.columns[i]?.type : null,
        //       display_name: item?.columns[i]?.display_name ? item?.columns[i]?.display_name : null,
        //       brand_id: item?.columns[i]?.brand_id ? item?.columns[i]?.brand_id : null,
        //       profile_channel: item?.columns[i]?.profile_channel ? item?.columns[i]?.profile_channel : null,
        //     });
        //   } else {
        //     console.log("else got called ")
        //     resultItem.columns[i].type = item?.columns[i]?.type;
        //   }
        // }
      }
    }
  }
  return result;
};
export const getUpdatedPredefinedFilter = (widgetFilter, uniqueFilters) => {
  let finalFilter = uniqueFilters?.length ? [...uniqueFilters] : [];
  let predefinedWidgetFilter =
    widgetFilter?.length &&
    widgetFilter?.filter((el) => el?.predefined_filters);
  if (predefinedWidgetFilter && predefinedWidgetFilter?.length) {
    finalFilter = finalFilter?.map((el) => {
      for (let i = 0; i < predefinedWidgetFilter?.length; i++) {
        if (el?.attribute === predefinedWidgetFilter[i]?.attribute) {
          el = { ...el, ...predefinedWidgetFilter[i] };
          break;
        }
      }
      return el;
    });
  }
  return finalFilter;
};
export const dataDurations = {
  Hourly: [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
    { label: "7", value: 7 },
    { label: "8", value: 8 },
    { label: "9", value: 9 },
    { label: "10", value: 10 },
    { label: "11", value: 11 },
    { label: "12", value: 12 },
    { label: "13", value: 13 },
    { label: "14", value: 14 },
    { label: "15", value: 15 },
    { label: "16", value: 16 },
    { label: "17", value: 17 },
    { label: "18", value: 18 },
    { label: "19", value: 19 },
    { label: "20", value: 20 },
    { label: "21", value: 21 },
    { label: "22", value: 22 },
    { label: "23", value: 23 },
  ],
  Daily: [
    { label: "Today", value: "Today" },
    { label: "Yesterday", value: "Yesterday" },
    { label: "Last X days", value: "LastXDays" },
    { label: "This week so far", value: "ThisWkSoFar" },
    { label: "This month so far", value: "ThisMthSoFar" },
    { label: "Custom", value: "Custom" },
  ],
  Weekly: [
    { label: "This week so far", value: "ThisWkSoFar" },
    { label: "Last week", value: "LastWeek" },
    { label: "Custom", value: "Custom" },
  ],
  Monthly: [
    { label: "This month so far", value: "ThisMthSoFar" },
    { label: "Last month", value: "LastMonth" },
    { label: "Custom", value: "Custom" },
  ],
};

export const reportDeliveryDaysList = [
  { name: "S", isSelected: false, value: 1, fullName: "Sunday" },
  { name: "M", isSelected: false, value: 2, fullName: "Monday" },
  { name: "T", isSelected: false, value: 3, fullName: "Tuesday" },
  { name: "W", isSelected: false, value: 4, fullName: "Wednesday" },
  { name: "T", isSelected: false, value: 5, fullName: "Thursday" },
  { name: "F", isSelected: false, value: 6, fullName: "Friday" },
  { name: "S", isSelected: false, value: 7, fullName: "Saturday" },
];

export const timeOptionList = [
  { label: "12:00 AM" },
  { label: "12:15 AM" },
  { label: "12:30 AM" },
  { label: "12:45 AM" },
  { label: "01:00 AM" },
  { label: "01:15 AM" },
  { label: "01:30 AM" },
  { label: "01:45 AM" },
  { label: "02:00 AM" },
  { label: "02:15 AM" },
  { label: "02:30 AM" },
  { label: "02:45 AM" },
  { label: "03:00 AM" },
  { label: "03:15 AM" },
  { label: "03:30 AM" },
  { label: "03:45 AM" },
  { label: "04:00 AM" },
  { label: "04:15 AM" },
  { label: "04:30 AM" },
  { label: "04:45 AM" },
  { label: "05:00 AM" },
  { label: "05:15 AM" },
  { label: "05:30 AM" },
  { label: "05:45 AM" },
  { label: "06:00 AM" },
  { label: "06:15 AM" },
  { label: "06:30 AM" },
  { label: "06:45 AM" },
  { label: "07:00 AM" },
  { label: "07:15 AM" },
  { label: "07:30 AM" },
  { label: "07:45 AM" },
  { label: "08:00 AM" },
  { label: "08:15 AM" },
  { label: "08:30 AM" },
  { label: "08:45 AM" },
  { label: "09:00 AM" },
  { label: "09:15 AM" },
  { label: "09:30 AM" },
  { label: "09:45 AM" },
  { label: "10:00 AM" },
  { label: "10:15 AM" },
  { label: "10:30 AM" },
  { label: "10:45 AM" },
  { label: "11:00 AM" },
  { label: "11:15 AM" },
  { label: "11:30 AM" },
  { label: "11:45 AM" },
  { label: "12:00 PM" },
  { label: "12:15 PM" },
  { label: "12:30 PM" },
  { label: "12:45 PM" },
  { label: "01:00 PM" },
  { label: "01:15 PM" },
  { label: "01:30 PM" },
  { label: "01:45 PM" },
  { label: "02:00 PM" },
  { label: "02:15 PM" },
  { label: "02:30 PM" },
  { label: "02:45 PM" },
  { label: "03:00 PM" },
  { label: "03:15 PM" },
  { label: "03:30 PM" },
  { label: "03:45 PM" },
  { label: "04:00 PM" },
  { label: "04:15 PM" },
  { label: "04:30 PM" },
  { label: "04:45 PM" },
  { label: "05:00 PM" },
  { label: "05:15 PM" },
  { label: "05:30 PM" },
  { label: "05:45 PM" },
  { label: "06:00 PM" },
  { label: "06:15 PM" },
  { label: "06:30 PM" },
  { label: "06:45 PM" },
  { label: "07:00 PM" },
  { label: "07:15 PM" },
  { label: "07:30 PM" },
  { label: "07:45 PM" },
  { label: "08:00 PM" },
  { label: "08:15 PM" },
  { label: "08:30 PM" },
  { label: "08:45 PM" },
  { label: "09:00 PM" },
  { label: "09:15 PM" },
  { label: "09:30 PM" },
  { label: "09:45 PM" },
  { label: "10:00 PM" },
  { label: "10:15 PM" },
  { label: "10:30 PM" },
  { label: "10:45 PM" },
  { label: "11:00 PM" },
  { label: "11:15 PM" },
  { label: "11:30 PM" },
  { label: "11:45 PM" },
  { label: "11:59 PM" },
];

export const days = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
];

export const handleScheduleDateChange = (
  e,
  frequency,
  dataDuration,
  lastXDays,
  scheduleDay,
  scheduleTime,
  scheduleMonth,
  timeOffsetText,
  scheduleDays,
  reportDeliveryTime
) => {
  let startDate,
    endDate,
    scheduleDateTime,
    scheduleReportJSON = null;
  if (frequency === "Hourly") {
    startDate = moment(e).subtract(dataDuration, "h");
    endDate = moment(e);
    scheduleDateTime = moment(e);
    const { workingStartTime, workingEndTime } = getReportWorkingDates(
      e,
      reportDeliveryTime
    );

    scheduleReportJSON = {
      ScheduleDetails: {
        ScheduleDays: scheduleDays,
        WorkingHrs: {
          startTime: moment(workingStartTime).format("HH:mm:ss"),
          endTime: moment(workingEndTime).format("HH:mm:ss"),
        },
        DataDuration: dataDuration,
        ScheduleDateTime: moment(scheduleDateTime)
          .tz(timeOffsetText.split(" ")[1])
          .format("YYYY-MM-DD HH:mm:ss"),
      },
      timeOffsetText: timeOffsetText,
    };
  } else if (frequency === "Daily") {
    if (dataDuration === "Today") {
      startDate = moment(e).tz(timeOffsetText.split(" ")[1]).startOf("day");
      endDate = moment(e).tz(timeOffsetText.split(" ")[1]);
      scheduleDateTime = moment(e).tz(timeOffsetText.split(" ")[1]);
    } else if (dataDuration === "Yesterday") {
      startDate = moment(e)
        .tz(timeOffsetText.split(" ")[1])
        .startOf("day")
        .subtract(1, "days");
      endDate = moment(e)
        .tz(timeOffsetText.split(" ")[1])
        .endOf("day")
        .subtract(1, "days");
      scheduleDateTime = moment(e).tz(timeOffsetText.split(" ")[1]);
    } else if (dataDuration === "LastXDays") {
      startDate = moment(e)
        .tz(timeOffsetText.split(" ")[1])
        .subtract(lastXDays, "days");
      endDate = moment(e).tz(timeOffsetText.split(" ")[1]);
      scheduleDateTime = moment(e).tz(timeOffsetText.split(" ")[1]);
    } else if (dataDuration === "ThisWkSoFar") {
      startDate = moment(e).tz(timeOffsetText.split(" ")[1]).startOf("week");
      endDate = moment(e).tz(timeOffsetText.split(" ")[1]);
      scheduleDateTime = moment(e).tz(timeOffsetText.split(" ")[1]);
    } else if (dataDuration === "ThisMthSoFar") {
      startDate = moment(e).tz(timeOffsetText.split(" ")[1]).startOf("month");
      endDate = moment(e).tz(timeOffsetText.split(" ")[1]);
      scheduleDateTime = moment(e).tz(timeOffsetText.split(" ")[1]);
    } else if (dataDuration === "Custom") {
      if (typeof e?.from === "string") {
        startDate = moment(e?.from);
        endDate = moment(e?.to);
      } else {
        scheduleDateTime = moment(e).tz(timeOffsetText.split(" ")[1]);
      }
    }

    if (dataDuration === "LastXDays" && lastXDays) {
      scheduleReportJSON = {
        ScheduleDetails: {
          [dataDuration]: {
            ScheduleDateTime: moment(scheduleDateTime)
              .tz(timeOffsetText.split(" ")[1])
              .format("YYYY-MM-DD HH:mm:ss"),

            dataDuration: lastXDays,
          },
        },
        timeOffsetText: timeOffsetText,
      };
    } else {
      scheduleReportJSON = {
        ScheduleDetails: {
          [dataDuration]: {
            ScheduleDateTime: moment(scheduleDateTime)
              .tz(timeOffsetText.split(" ")[1])
              .format("YYYY-MM-DD HH:mm:ss"),
          },
        },
        timeOffsetText: timeOffsetText,
      };
    }
  } else if (frequency === "Weekly") {
    const isCurrentWeek = moment()
      .tz(timeOffsetText.split(" ")[1])
      .startOf("week")
      .add({
        days: scheduleDay - 1,
        hours:
          moment(scheduleTime, ["h:mm A"])?.format("HH:mm")?.split(":")[0] || 0,
        minutes:
          moment(scheduleTime, ["h:mm A"])
            ?.format("HH:mm")
            ?.split(":")[1]
            ?.split(" ")[0] || 0,
      })
      .diff(moment().tz(timeOffsetText.split(" ")[1]));
    if (dataDuration === "ThisWkSoFar") {
      if (isCurrentWeek > 0) {
        startDate = moment().tz(timeOffsetText.split(" ")[1]).startOf("week");
        endDate = moment()
          .tz(timeOffsetText.split(" ")[1])
          .startOf("week")
          .add({
            days: scheduleDay - 1,
            hours:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[0] || 0,
            minutes:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[1]
                ?.split(" ")[0] || 0,
          });
      } else {
        startDate = moment()
          .tz(timeOffsetText.split(" ")[1])
          .add(1, "w")
          .startOf("week");
        endDate = moment()
          .tz(timeOffsetText.split(" ")[1])
          .add(1, "w")
          .startOf("week")
          .add({
            days: scheduleDay - 1,
            hours:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[0] || 0,
            minutes:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[1]
                ?.split(" ")[0] || 0,
          });
      }
      scheduleDateTime = endDate;
    } else if (dataDuration === "LastWeek") {
      if (isCurrentWeek > 0) {
        startDate = moment()
          .tz(timeOffsetText.split(" ")[1])
          .startOf("week")
          .subtract(1, "week");
        endDate = moment()
          .tz(timeOffsetText.split(" ")[1])
          .endOf("week")
          .subtract(1, "week");
        scheduleDateTime = moment()
          .tz(timeOffsetText.split(" ")[1])
          .startOf("week")
          .add({
            days: scheduleDay - 1,
            hours:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[0] || 0,
            minutes:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[1]
                ?.split(" ")[0] || 0,
          });
      } else {
        startDate = moment()
          .tz(timeOffsetText.split(" ")[1])
          .add(1, "w")
          .startOf("week")
          .subtract(1, "week");
        endDate = moment()
          .tz(timeOffsetText.split(" ")[1])
          .add(1, "w")
          .endOf("week")
          .subtract(1, "week");
        scheduleDateTime = moment()
          .tz(timeOffsetText.split(" ")[1])
          .add(1, "w")
          .startOf("week")
          .add({
            days: scheduleDay - 1,
            hours:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[0] || 0,
            minutes:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[1]
                ?.split(" ")[0] || 0,
          });
      }
    } else if (dataDuration === "Custom") {
      if (typeof e?.from === "string") {
        startDate = moment(e?.from);
        endDate = moment(e?.to);
      } else {
        if (isCurrentWeek > 0) {
          scheduleDateTime = moment()
            .tz(timeOffsetText.split(" ")[1])
            .startOf("week")
            .add({
              days: scheduleDay - 1,
              hours:
                moment(scheduleTime, ["h:mm A"])
                  ?.format("HH:mm")
                  ?.split(":")[0] || 0,
              minutes:
                moment(scheduleTime, ["h:mm A"])
                  ?.format("HH:mm")
                  ?.split(":")[1]
                  ?.split(" ")[0] || 0,
            });
        } else {
          scheduleDateTime = moment()
            .tz(timeOffsetText.split(" ")[1])
            .add(1, "w")
            .startOf("week")
            .add({
              days: scheduleDay - 1,
              hours:
                moment(scheduleTime, ["h:mm A"])
                  ?.format("HH:mm")
                  ?.split(":")[0] || 0,
              minutes:
                moment(scheduleTime, ["h:mm A"])
                  ?.format("HH:mm")
                  ?.split(":")[1]
                  ?.split(" ")[0] || 0,
            });
        }
      }
    }
    if (scheduleDay && scheduleTime) {
      scheduleReportJSON = {
        ScheduleDetails: {
          [dataDuration]: {
            ScheduleDays: scheduleDay,
            ScheduleTime: scheduleTime,
          },
        },
        timeOffsetText: timeOffsetText,
      };
    }
  } else if (frequency === "Monthly") {
    let daysInMonth;
    const isCurrentMonth = moment()
      .tz(timeOffsetText.split(" ")[1])
      .startOf("month")
      .add({
        days: scheduleMonth - 1,
        hours:
          moment(scheduleTime, ["h:mm A"])?.format("HH:mm")?.split(":")[0] || 0,
        minutes:
          moment(scheduleTime, ["h:mm A"])
            ?.format("HH:mm")
            ?.split(":")[1]
            ?.split(" ")[0] || 0,
      })
      .diff(moment().tz(timeOffsetText.split(" ")[1]));
    if (dataDuration === "ThisMthSoFar") {
      if (isCurrentMonth > 0) {
        daysInMonth = moment().tz(timeOffsetText.split(" ")[1]).daysInMonth();
        startDate = moment().tz(timeOffsetText.split(" ")[1]).startOf("month");
        endDate = moment()
          .tz(timeOffsetText.split(" ")[1])
          .startOf("month")
          .add({
            days:
              (scheduleMonth >= daysInMonth ? daysInMonth : scheduleMonth) - 1,
            hours:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[0] || 0,
            minutes:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[1]
                ?.split(" ")[0] || 0,
          });
      } else {
        daysInMonth = moment()
          .tz(timeOffsetText.split(" ")[1])
          .add(1, "M")
          .daysInMonth();
        startDate = moment()
          .tz(timeOffsetText.split(" ")[1])
          .add(1, "M")
          .startOf("month");
        endDate = moment()
          .tz(timeOffsetText.split(" ")[1])
          .add(1, "M")
          .startOf("month")
          .add({
            days:
              (scheduleMonth >= daysInMonth ? daysInMonth : scheduleMonth) - 1,
            hours:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[0] || 0,
            minutes:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[1]
                ?.split(" ")[0] || 0,
          });
      }
      scheduleDateTime = endDate;
    } else if (dataDuration === "LastMonth") {
      if (isCurrentMonth > 0) {
        daysInMonth = moment().tz(timeOffsetText.split(" ")[1]).daysInMonth();
        startDate = moment()
          .tz(timeOffsetText.split(" ")[1])
          .subtract(1, "M")
          .startOf("month");
        endDate = moment()
          .tz(timeOffsetText.split(" ")[1])
          .subtract(1, "M")
          .endOf("month");
        scheduleDateTime = moment()
          .tz(timeOffsetText.split(" ")[1])
          .startOf("month")
          .add({
            days:
              (scheduleMonth >= daysInMonth ? daysInMonth : scheduleMonth) - 1,
            hours:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[0] || 0,
            minutes:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[1]
                ?.split(" ")[0] || 0,
          });
      } else {
        daysInMonth = moment()
          .tz(timeOffsetText.split(" ")[1])
          .add(1, "M")
          .daysInMonth();
        startDate = moment().tz(timeOffsetText.split(" ")[1]).startOf("month");
        endDate = moment().tz(timeOffsetText.split(" ")[1]).endOf("month");
        scheduleDateTime = moment()
          .tz(timeOffsetText.split(" ")[1])
          .add(1, "M")
          .startOf("month")
          .add({
            days:
              (scheduleMonth >= daysInMonth ? daysInMonth : scheduleMonth) - 1,
            hours:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[0] || 0,
            minutes:
              moment(scheduleTime, ["h:mm A"])
                ?.format("HH:mm")
                ?.split(":")[1]
                ?.split(" ")[0] || 0,
          });
      }
    } else if (dataDuration === "Custom") {
      daysInMonth = moment().daysInMonth();
      if (typeof e?.from === "string") {
        startDate = moment(e?.from);
        endDate = moment(e?.to);
      } else {
        if (isCurrentMonth > 0) {
          scheduleDateTime = moment()
            .startOf("month")
            .add({
              days:
                (scheduleMonth >= daysInMonth ? daysInMonth : scheduleMonth) -
                1,
              hours:
                moment(scheduleTime, ["h:mm A"])
                  ?.format("HH:mm")
                  ?.split(":")[0] || 0,
              minutes:
                moment(scheduleTime, ["h:mm A"])
                  ?.format("HH:mm")
                  ?.split(":")[1]
                  ?.split(" ")[0] || 0,
            });
        } else {
          daysInMonth = moment().add(1, "M").daysInMonth();
          scheduleDateTime = moment()
            .startOf("month")
            .add(1, "M")
            .add({
              days:
                (scheduleMonth >= daysInMonth ? daysInMonth : scheduleMonth) -
                1,
              hours:
                moment(scheduleTime, ["h:mm A"])
                  ?.format("HH:mm")
                  ?.split(":")[0] || 0,
              minutes:
                moment(scheduleTime, ["h:mm A"])
                  ?.format("HH:mm")
                  ?.split(":")[1]
                  ?.split(" ")[0] || 0,
            });
        }
      }
    }
    if (scheduleMonth && scheduleTime) {
      scheduleReportJSON = {
        ScheduleDetails: {
          [dataDuration]: {
            ScheduleDays: scheduleMonth,
            ScheduleTime: scheduleTime,
          },
        },
        timeOffsetText: timeOffsetText,
      };
    }
  }

  return { startDate, endDate, scheduleDateTime, scheduleReportJSON };
};

export const getReportWorkingDates = (scheduleDate, reportDeliveryTime) => {
  const workingStartTime = moment(scheduleDate ? scheduleDate : undefined)
    .startOf("day")
    .add({
      hours: moment(reportDeliveryTime?.startTime, ["h:mm A"])
        .format("HH:mm")
        ?.split(":")[0],
      minutes: moment(reportDeliveryTime?.startTime, ["h:mm A"])
        .format("HH:mm")
        ?.split(":")[1],
    });
  const workingEndTime = moment(scheduleDate ? scheduleDate : undefined)
    .startOf("day")
    .add({
      hours: moment(reportDeliveryTime?.endTime, ["h:mm A"])
        .format("HH:mm")
        ?.split(":")[0],
      minutes: moment(reportDeliveryTime?.endTime, ["h:mm A"])
        .format("HH:mm")
        ?.split(":")[1],
    });
  return { workingStartTime, workingEndTime };
};

export const handleGenerateDateChange = (e) => {
  let startDate,
    endDate = null;

  startDate = moment(e?.from).format("YYYY-MM-DD HH:mm:ss");
  endDate = moment(e?.to).format("YYYY-MM-DD HH:mm:ss");
  let relative_duration = e?.save_as_relative
    ? {
        is_relative: e?.relative?.type === "short",
        relative_type: e?.relative?.value ?? null,
        // relative_days: e?.relative?.days ?? null,
        relative_days: null, // For now sending null
      }
    : null;

  return {
    startDate,
    endDate,
    relative: e?.relative ? e?.relative : null,
    relative_duration: relative_duration,
  };
};

export const getTimeInterval = (enddate, startdate) => {
  let currentDate = moment(new Date()).format("YYYY/MM/DD H:mm");
  let hourDiff = moment(currentDate).diff(moment(startdate), "hour");

  let diff;
  if (hourDiff < 24) {
    diff = hourDiff;
  } else {
    diff = moment(enddate).diff(moment(startdate), "hour");
  }

  let defaultVal;
  let timeList;
  let obj;

  if (diff == 1) {
    defaultVal = 60;
    timeList = [60];
  } else if (diff <= 3) {
    defaultVal = 60;
    timeList = [60, 120];
  } else if (diff <= 5) {
    defaultVal = 60;
    timeList = [60, 120, 180, 240];
  } else if (diff <= 6) {
    defaultVal = 60;
    timeList = [60, 120, 180, 240, 360];
  } else if (diff <= 12) {
    defaultVal = 60;
    timeList = [60, 120, 180, 240, 360, 720];
  } else if (diff < 24) {
    defaultVal = 60;
    timeList = [60, 120, 180, 240, 360];
  } else if (diff < 2 * 24) {
    defaultVal = 240;
    timeList = [60, 240, 480, 720, "D"];
  } else if (diff < 7 * 24) {
    defaultVal = 720;
    timeList = [240, 480, 720, "D"];
  } else if (diff < 14 * 24) {
    defaultVal = 720;
    timeList = [480, 720, "D"];
  } else if (diff < 31 * 24) {
    defaultVal = "W";
    timeList = ["D", "W"];
  } else if (diff < 90 * 24) {
    defaultVal = "W";
    timeList = ["W", "M", "Y"];
  } else if (diff < 365 * 24) {
    defaultVal = "M";
    timeList = ["W", "M", "Y"];
  } else if (diff > 365 * 24) {
    defaultVal = "Y";
    timeList = ["W", "M", "Y"];
  }
  obj = {
    defaultVal,
    timeList,
  };
  return obj;
};
export const getNewTimeIntervalDate = (
  lastEndDate,
  dataSource,
  attribute,
  dateAggregation
) => {
  if (!lastEndDate) return lastEndDate;
  let hourlyList = ["1h", "2h", "3h", "4h", "6h", "8h", "12h"];
  let newDate = null;
  if (!dateAggregation || dateAggregation === "D") {
    newDate = moment(deepCopy(lastEndDate))
      ?.add(1, "days")
      ?.format("YYYY/MM/DD HH:mm");
  } else if (dateAggregation === "1m") {
    let hours = parseInt(String(dateAggregation)?.replace("h", ""));
    newDate = moment(deepCopy(lastEndDate))
      ?.add(hours, "minutes")
      ?.format("YYYY/MM/DD HH:mm");
  } else if (hourlyList?.includes(dateAggregation)) {
    let hours = parseInt(String(dateAggregation)?.replace("h", ""));
    newDate = moment(deepCopy(lastEndDate))
      ?.add(hours, "hours")
      ?.format("YYYY/MM/DD HH:mm");
  }
  return newDate;
};
export const getTimeIntervalDate = (
  enddate,
  startdate,
  data_source,
  attribute
) => {
  if (data_source === "page" || data_source === "nps") {
    let currentDate = moment(new Date()).format("YYYY/MM/DD H:mm");
    let hourDiff = moment(currentDate).diff(moment(startdate), "hour");

    let diff;
    if (hourDiff < 24) {
      diff = hourDiff;
    } else {
      diff = moment(enddate).diff(moment(startdate), "hour");
    }

    let defaultVal;
    let timeList;
    let obj;

    if (diff == 1) {
      defaultVal = null;
      timeList = ["D"];
    } else if (diff <= 3) {
      defaultVal = null;
      timeList = ["D"];
    } else if (diff <= 5) {
      defaultVal = null;
      timeList = ["D"];
    } else if (diff <= 6) {
      defaultVal = null;
      timeList = ["D"];
    } else if (diff <= 12) {
      defaultVal = null;
      timeList = ["D"];
    } else if (diff < 24) {
      defaultVal = null;
      timeList = ["D"];
    } else if (diff < 2 * 24) {
      defaultVal = null;
      timeList = ["D"];
    } else if (diff < 7 * 24) {
      defaultVal = null;
      timeList = ["D"];
    } else if (diff < 14 * 24) {
      defaultVal = null;
      timeList = ["D"];
    } else if (diff < 29 * 24) {
      defaultVal = null;
      timeList = ["D", "ww"];
    } else if (diff < 90 * 24) {
      defaultVal = "ww";
      timeList = ["ww", "M"];
    } else if (diff < 365 * 24) {
      defaultVal = "M";
      timeList = ["ww", "M"];
    } else if (diff > 365 * 24) {
      defaultVal = "Y";
      timeList = ["ww", "M", "Y"];
    }
    obj = {
      defaultVal,
      timeList,
    };
    return obj;
  } else if (data_source === "ticket") {
    let currentDate = moment(new Date()).format("YYYY/MM/DD H:mm");
    let hourDiff = moment(currentDate).diff(moment(startdate), "hour");

    let diff;
    if (hourDiff < 24) {
      diff = hourDiff;
    } else {
      diff = moment(enddate).diff(moment(startdate), "hour");
    }

    let defaultVal;
    let timeList;
    let obj;
    if (attribute === "FLRBenchmark") {
      defaultVal = 30;
      timeList = [
        5,
        10,
        15,
        30,
        1 * 60,
        2 * 60,
        4 * 60,
        8 * 60,
        16 * 60,
        24 * 60,
      ];
    } else if (attribute === "ResolutionBenchmark") {
      defaultVal = 240;
      timeList = [1 * 60, 2 * 60, 4 * 60, 8 * 60, 16 * 60, 24 * 60, 48 * 60];
    } else {
      if (diff == 1) {
        defaultVal = "1h";
        timeList = ["1h"];
      } else if (diff <= 3) {
        defaultVal = "1h";
        timeList = ["1h", "2h"];
      } else if (diff <= 5) {
        defaultVal = "1h";
        timeList = ["1h", "2h", "3h", "4h"];
      } else if (diff <= 6) {
        defaultVal = "1h";
        timeList = ["1h", "2h", "3h", "4h", "6h"];
      } else if (diff <= 12) {
        defaultVal = "1h";
        timeList = ["1h", "2h", "3h", "4h", "6h", "12h"];
      } else if (diff < 24) {
        defaultVal = "1h";
        timeList = ["1h", "2h", "3h", "4h", "6h"];
      } else if (diff < 2 * 24) {
        defaultVal = "1h";
        timeList = ["1h", "4h", "8h", "12h", "D"];
      } else if (diff < 7 * 24) {
        defaultVal = "D";
        timeList = ["4h", "8h", "12h", "D"];
      } else if (diff < 14 * 24) {
        defaultVal = "D";
        timeList = ["8h", "12h", "D"];
      } else if (diff < 29 * 24) {
        defaultVal = "D";
        timeList = ["D", "ww"];
      } else if (diff < 60 * 24) {
        defaultVal = "ww";
        timeList = ["D", "ww", "M"];
      } else if (diff < 90 * 24) {
        defaultVal = "ww";
        timeList = ["ww", "M", "Y"];
      } else if (diff < 365 * 24) {
        defaultVal = "M";
        timeList = ["ww", "M", "Y"];
      } else if (diff > 365 * 24) {
        defaultVal = "Y";
        timeList = ["ww", "M", "Y"];
      }
    }

    obj = {
      defaultVal,
      timeList,
    };
    return obj;
  } else {
    let currentDate = moment(new Date()).format("YYYY/MM/DD H:mm");
    let hourDiff = moment(currentDate).diff(moment(startdate), "hour");

    let diff;
    if (hourDiff < 24) {
      diff = hourDiff;
    } else {
      diff = moment(enddate).diff(moment(startdate), "hour");
    }

    let defaultVal;
    let timeList;
    let obj;

    if (diff == 1) {
      defaultVal = "1h";
      timeList = ["1h"];
    } else if (diff <= 3) {
      defaultVal = "1h";
      timeList = ["1h", "2h"];
    } else if (diff <= 5) {
      defaultVal = "1h";
      timeList = ["1h", "2h", "3h", "4h"];
    } else if (diff <= 6) {
      defaultVal = "1h";
      timeList = ["1h", "2h", "3h", "4h", "6h"];
    } else if (diff <= 12) {
      defaultVal = "1h";
      timeList = ["1h", "2h", "3h", "4h", "6h", "12h"];
    } else if (diff < 24) {
      defaultVal = "1h";
      timeList = ["1h", "2h", "3h", "4h", "6h"];
    } else if (diff < 2 * 24) {
      defaultVal = "1h";
      timeList = ["1h", "4h", "8h", "12h", "D"];
    } else if (diff < 7 * 24) {
      defaultVal = "D";
      timeList = ["4h", "8h", "12h", "D"];
    } else if (diff < 14 * 24) {
      defaultVal = "D";
      timeList = ["8h", "12h", "D"];
    } else if (diff < 29 * 24) {
      defaultVal = null;
      timeList = ["D", "ww"];
    } else if (diff < 60 * 24) {
      defaultVal = "ww";
      timeList = ["D", "ww", "M"];
    } else if (diff < 90 * 24) {
      defaultVal = "ww";
      timeList = ["ww", "M"];
    } else if (diff < 365 * 24) {
      defaultVal = "M";
      timeList = ["ww", "M"];
    } else if (diff > 365 * 24) {
      defaultVal = "Y";
      timeList = ["ww", "M", "Y"];
    }
    obj = {
      defaultVal,
      timeList,
    };
    return obj;
  }
};

export const getTimeIntervalForDate = (enddate, startdate, chart_type, att) => {
  let diff = moment(enddate).diff(moment(startdate), "hour");

  let defaultVal;
  let timeList;
  let obj;
  if (att === "RecordDate") {
    if (diff < 24) {
      defaultVal = chart_type === "pie" || chart_type === "donut" ? "mm" : null;
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "dd", "dw", "mm", "ww", "qq"];
    } else if (diff < 2 * 24) {
      defaultVal = chart_type === "pie" || chart_type === "donut" ? "mm" : null;
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "dd", "dw", "mm", "ww", "qq"];
    } else if (diff < 7 * 24) {
      defaultVal = chart_type === "pie" || chart_type === "donut" ? "mm" : null;
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "dd", "dw", "mm", "ww", "qq"];
    } else if (diff < 14 * 24) {
      defaultVal = chart_type === "pie" || chart_type === "donut" ? "mm" : null;
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "dd", "dw", "mm", "ww", "qq"];
    } else if (diff <= 31 * 24) {
      defaultVal = chart_type === "pie" || chart_type === "donut" ? "mm" : null;
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "dd", "dw", "mm", "ww", "qq"];
    } else if (diff <= 180 * 24) {
      defaultVal = "ww";
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "dd", "dw", "mm", "ww", "qq"];
    } else if (diff < 180 * 24) {
      defaultVal = "ww";
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "dd", "dw", "mm", "ww", "qq"];
    } else {
      defaultVal = "mm";
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "dd", "dw", "mm", "ww", "qq"];
    }
  } else {
    if (diff < 24) {
      defaultVal = chart_type === "pie" || chart_type === "donut" ? "mm" : null;
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "hh", "dd", "dw", "mm", "ww", "qq"];
    } else if (diff < 2 * 24) {
      defaultVal = chart_type === "pie" || chart_type === "donut" ? "mm" : null;
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "hh", "dd", "dw", "mm", "ww", "qq"];
    } else if (diff < 7 * 24) {
      defaultVal = chart_type === "pie" || chart_type === "donut" ? "mm" : null;
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "hh", "dd", "dw", "mm", "ww", "qq"];
    } else if (diff < 14 * 24) {
      defaultVal = chart_type === "pie" || chart_type === "donut" ? "mm" : null;
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "hh", "dd", "dw", "mm", "ww", "qq"];
    } else if (diff <= 31 * 24) {
      defaultVal = chart_type === "pie" || chart_type === "donut" ? "mm" : null;
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "hh", "dd", "dw", "mm", "ww", "qq"];
    } else if (diff <= 180 * 24) {
      defaultVal = "ww";
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "hh", "dd", "dw", "mm", "ww", "qq"];
    } else if (diff < 180 * 24) {
      defaultVal = "ww";
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "hh", "dd", "dw", "mm", "ww", "qq"];
    } else {
      defaultVal = "mm";
      timeList =
        chart_type === "pie" || chart_type === "donut"
          ? ["mm", "ww", "qq"]
          : [null, "hh", "dd", "dw", "mm", "ww", "qq"];
    }
  }

  obj = {
    defaultVal,
    timeList,
  };
  return obj;
};

export const getBrands = (
  LogicalBrands,
  brand_list,
  singleBrands,
  brand_groups
) => {
  let brandCol = [];
  let brandGroupCol = [];
  if (brand_list && brand_list?.length > 0) {
    // brandCol = singleBrands
    //   ?.filter((o1) => brand_list?.some((o2) => o1?.brand_id == o2?.brand_id))
    //   .map((o) => {
    //     return {
    //       group: false,
    //       name: o?.brand_id,
    //       type: "include",
    //       brand_friendly_name: o?.brand_friendly_name,
    //       competitor: o?.competitor,
    //       competitorList: o?.competitorList,
    //       brand_name: o?.brand_name,
    //       brand_logo: o?.brand_logo,
    //       brand_id: o?.brand_id,
    //     };
    //   });

    // Correct Code, Rearranging issue solved by adding this
    let filteredBrands = brand_list
      ?.filter((o1) => singleBrands?.some((o2) => o1?.brand_id == o2?.brand_id))
      ?.map((o1) => singleBrands?.find((o2) => o1?.brand_id == o2?.brand_id));
    // console.log("filteredBrands : ", filteredBrands);
    brandCol =
      Array.isArray(filteredBrands) &&
      filteredBrands?.map((o) => {
        return {
          group: false,
          name: o?.brand_id,
          type: "include",
          brand_friendly_name: o?.brand_friendly_name,
          competitor: o?.competitor,
          competitorList: o?.competitorList,
          brand_name: o?.brand_name,
          brand_logo: o?.brand_logo,
          brand_id: o?.brand_id,
        };
      });
  }

  if (
    brand_groups &&
    brand_groups?.length > 0 &&
    brand_groups?.[0]?.brand_group_name
  ) {
    // brandGroupCol = LogicalBrands?.filter((o1) =>
    //   brand_groups?.some((o2) => o1?.brand_group_name == o2?.brand_group_name)
    // ).map((o) => {
    //   return {
    //     group: true,
    //     name: o?.brand_group_name,
    //     type: "include",
    //     brand_friendly_name: o?.brand_group_name,
    //     brand_group_name: o?.brand_group_name,
    //     brand_group_list: o?.brand_list,
    //     brand_logo_image: o?.brand_logo_image,
    //   };
    // });

    // Correct Code, Rearranging issue solved by adding this
    let filteredBrandGroups = brand_groups
      ?.filter((o1) =>
        LogicalBrands?.some(
          (o2) => o1?.brand_group_name == o2?.brand_group_name
        )
      )
      ?.map((o1) =>
        LogicalBrands?.find(
          (o2) => o1?.brand_group_name == o2?.brand_group_name
        )
      );
    // console.log("filteredBrandGroups : ", filteredBrandGroups);
    // let old = brand_groups?.filter((o1) =>
    //   LogicalBrands?.some((o2) => o1?.brand_group_name == o2?.brand_group_name)
    // );
    // console.log("old : ", old);
    brandGroupCol =
      Array.isArray(filteredBrandGroups) &&
      filteredBrandGroups?.map((o) => {
        return {
          group: true,
          name: o?.brand_group_name,
          type: "include",
          brand_friendly_name: o?.brand_group_name,
          brand_group_name: o?.brand_group_name,
          brand_group_list: o?.brand_list,
          brand_logo_image: o?.brand_logo_image,
        };
      });
  }

  let finalBrands = {
    attribute: "BrandID",
    type: "varchar",
    columns: brandCol && brandGroupCol ? [...brandCol, ...brandGroupCol] : [],
  };

  return finalBrands?.columns?.length > 0 ? finalBrands : null;
};

export const secondsToDhms = (seconds) => {
  seconds = Number(seconds);
  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor((seconds % (3600 * 24)) / 3600);
  var m = Math.floor((seconds % 3600) / 60);
  var s = Math.floor(seconds % 60);

  var dDisplay = d > 0 ? d + (d == 1 ? " D, " : " D, ") : "";
  var hDisplay = h > 0 ? h + (h == 1 ? " h, " : " h, ") : "";
  var mDisplay = m > 0 ? m + (m == 1 ? " m, " : " m, ") : "";
  var sDisplay = s > 0 ? s + (s == 1 ? " s" : " s") : "";
  return dDisplay + hDisplay + mDisplay + sDisplay;
};
export const isFloat = (n) => {
  return Number(n) === n && n % 1 !== 0;
};
export const kFormatter = (num, roundOfNotFlag = false, kpi = false) => {
  let isNegative = num < 0;
  if (Math.abs(num) >= 1000000000000) {
    return (
      (isNegative ? "-" : "") +
      (Math.abs(num) / 1000000000000).toFixed(1).replace(/\.0$/, "") +
      "T"
    );
  } else if (Math.abs(num) >= 1000000000) {
    return (
      (isNegative ? "-" : "") +
      (Math.abs(num) / 1000000000).toFixed(1).replace(/\.0$/, "") +
      "G"
    );
  } else if (Math.abs(num) >= 1000000) {
    return (
      (isNegative ? "-" : "") +
      (Math.abs(num) / 1000000).toFixed(1).replace(/\.0$/, "") +
      "M"
    );
  } else if (Math.abs(num) >= 1000) {
    return (
      (isNegative ? "-" : "") +
      (Math.abs(num) / 1000).toFixed(1).replace(/\.0$/, "") +
      "k"
    );
  } else if (Math.abs(num)) {
    if (isFloat(num)) {
      if (kpi) {
        if (roundOfNotFlag) {
          return (isNegative ? "-" : "") + Math.abs(num).toFixed(2);
        } else {
          return (
            (isNegative ? "-" : "") +
            Math?.abs(num)?.toFixed(0)?.replace(/\.0$/, "")
          );
        }
      } else {
        return (
          (isNegative ? "-" : "") +
          Math?.abs(num)?.toFixed(1)?.replace(/\.0$/, "")
        );
      }
    } else {
      return num;
    }
  } else return num;
};
export const simpleKFormatterOnly = (num, kCap = false) => {
  if (Math.abs(num) >= 1000000000000) {
    return (Math.abs(num) / 1000000000000).toFixed(1).replace(/\.0$/, "") + "T";
  } else if (Math.abs(num) >= 1000000000) {
    return (Math.abs(num) / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  } else if (Math.abs(num) >= 1000000) {
    return (Math.abs(num) / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  } else if (Math.abs(num) >= 1000) {
    return (
      (Math.abs(num) / 1000).toFixed(1).replace(/\.0$/, "") + (kCap ? "K" : "k")
    );
  } else {
    return num;
  }
};
export const getUTCOffset = () => {
  const d = new Date();
  let utcOffset = d.getTimezoneOffset();
  return utcOffset;
};

export const getDefaultCompBrand = (competitorBrands) => {
  let comp_arr =
    competitorBrands?.length > 0 &&
    competitorBrands[0]?.comp_brand_list?.filter((el, i) => {
      if (i < 5) return el;
    });
  let a = [
    {
      group: false,
      name: competitorBrands?.[0]?.brand_id,
      type: "include",
      brand_name: competitorBrands?.[0]?.brand_name,
      brand_friendly_name: competitorBrands?.[0]?.brand_friendly_name,
      brand_color: competitorBrands?.[0]?.brand_color,
      brand_group_name: null,
      competitor: true,
      competitorList:
        comp_arr?.length > 0 &&
        comp_arr?.map((el, i) => {
          return {
            brand_id: el?.comp_brand_id,
            brand_name: el?.comp_brand_name,
            brand_friendly_name: el?.comp_brand_friendly_name,
            comp_brand_color: el?.comp_brand_color,
          };
        }),
    },
  ];
  return a;
};
export const getSelectedCompBrand = (
  competitorBrands,
  brand_ids,
  comp_brand_list
) => {
  let index = competitorBrands?.findIndex(
    (el) => el?.brand_id == brand_ids?.[0]?.brand_id
  );
  let obj = competitorBrands?.[index];

  let brand_id_arr = comp_brand_list?.map((el) => el?.brand_id);

  let arr = obj?.comp_brand_list?.filter((el) =>
    brand_id_arr.includes(el?.comp_brand_id)
  );

  arr?.map((el) => {
    el.brand_name = el?.comp_brand_name;
    el.brand_id = el?.comp_brand_id;
    el.brand_friendly_name = el?.comp_brand_friendly_name;
    el.comp_brand_color = el?.comp_brand_color;
  });

  let finalObj = [
    {
      group: false,
      name: obj?.brand_id,
      type: "include",
      brand_name: obj?.brand_name,
      brand_friendly_name: obj?.brand_friendly_name,
      brand_group_name: false,
      competitor: true,
      competitorList: arr,
    },
  ];
  return finalObj;
};
export const deepCopy = (oldValue) => {
  let newValue;
  try {
    let strValue = JSON.stringify(oldValue);
    newValue = JSON.parse(strValue);
  } catch (error) {
    newValue = oldValue;
  }

  return newValue;
};
export const getDuplicateWidgets = (
  compBrandList,
  widget,
  singleBrands,
  objForTemporyWordFunctionality
) => {
  if (!compBrandList || !widget) return null;
  if (compBrandList?.length > 0) {
    let duplicateWidgets = [];
    compBrandList?.forEach((br, i) => {
      let newWidgetData = deepCopy(widget);
      let brIndex = -1;
      if (!(br?.brand_friendly_name && br?.brand_friendly_name?.length > 0)) {
        brIndex =
          singleBrands &&
          singleBrands?.findIndex((s) => s?.brand_id === br?.brand_id);
      }
      newWidgetData["com_brand_ids"] = [br];
      newWidgetData.span =
        widget["chart"]["chart_type"] === "post-card" ||
        widget["chart"]["chart_type"] === "author-card"
          ? "full"
          : "half";
      if (i === 0) {
        newWidgetData.originalWidgetName = deepCopy(widget["widget_name"]);
      }
      newWidgetData.widget_name =
        br?.brand_friendly_name && br?.brand_friendly_name?.length > 0
          ? widget["widget_name"] + " (" + br?.brand_friendly_name?.trim() + ")"
          : brIndex > -1 && singleBrands
          ? widget["widget_name"] +
            " (" +
            singleBrands[brIndex]["brand_friendly_name"]?.trim() +
            ")"
          : widget["chart"]["chart_type"];
      newWidgetData.duplicate_for_brands = true;
      if (i !== 0) {
        newWidgetData.widget_id = uuid();
        newWidgetData.childId = widget["widget_id"];
      } else {
        newWidgetData.parentId = widget["widget_id"];
      }
      if (objForTemporyWordFunctionality) {
        let widget_id = widget["widget_id"] + "#" + br?.brand_id;
        let word =
          objForTemporyWordFunctionality?.temporary_words?.[
            objForTemporyWordFunctionality?.template_id
          ]?.[objForTemporyWordFunctionality?.section_id]?.[widget_id]
            ?.exclude_words;
        let temp_exclude_words = word?.length ? word : null;
        newWidgetData.temp_exclude_words = temp_exclude_words;
      }
      if (newWidgetData?.graphData) {
        delete newWidgetData?.graphData;
      }
      if (newWidgetData?.persist_graphdata) {
        delete newWidgetData?.persist_graphdata;
      }
      if (newWidgetData?.deep_dive_on) {
        delete newWidgetData?.deep_dive_on;
      }
      if (newWidgetData?.data) {
        delete newWidgetData?.data;
      }
      duplicateWidgets.push(newWidgetData);
    });
    return duplicateWidgets;
  } else {
    return null;
  }
};
export const getFilterDuplicateWidgets = (
  Section,
  forParticularSection,
  objForTemporyWordFunctionality
) => {
  let sectionObject;
  if (forParticularSection) {
    sectionObject = Section?.map((el, i) => {
      if (i === forParticularSection?.section_index) {
        if (el?.data && el?.data?.length > 0) {
          let sectionWidgetObject = [];
          el?.data &&
            el?.data?.map((e) => {
              if (
                forParticularSection?.widget_id === e?.parentId ||
                forParticularSection?.widget_id === e?.childId
              ) {
                if (!(e?.childId && e?.duplicate_for_brands)) {
                  if (e?.duplicate_for_brands && e?.parentId) {
                    if (
                      forParticularSection &&
                      e?.chart?.["chart_type"] === "wordcloud" &&
                      forParticularSection?.temporary_words
                    ) {
                      let widget_id = e["widget_id"];
                      let word =
                        forParticularSection?.temporary_words?.[
                          forParticularSection?.template_id
                        ]?.[el?.section_id]?.[widget_id]?.exclude_words;
                      let temp_exclude_words = word?.length ? word : null;
                      e.temp_exclude_words = temp_exclude_words;
                    }
                    e["widget_name"] = e?.originalWidgetName;
                    delete e?.duplicate_for_brands;
                    delete e?.parentId;
                    delete e?.childId;
                    delete e?.span;
                    delete e?.originalWidgetName;
                    delete e?.com_brand_ids;
                    if (e?.graphData) {
                      delete e?.graphData;
                    }
                    if (e?.persist_graphdata) {
                      delete e?.persist_graphdata;
                    }
                    if (e?.deep_dive_on) {
                      delete e?.deep_dive_on;
                    }
                    if (e?.data) {
                      delete e?.data;
                    }
                  }
                  sectionWidgetObject.push(e);
                }
              } else {
                return sectionWidgetObject.push(e);
              }
            });
          el.data = sectionWidgetObject;
          el.widgets = sectionWidgetObject;
          return el;
        } else if (el?.widgets && el?.widgets?.length > 0) {
          let sectionWidgetObject = [];
          el?.widgets &&
            el?.widgets?.map((e) => {
              if (
                forParticularSection?.widget_id === e?.parentId ||
                forParticularSection?.widget_id === e?.childId
              ) {
                if (!(e?.childId && e?.duplicate_for_brands)) {
                  if (e?.duplicate_for_brands && e?.parentId) {
                    if (
                      forParticularSection &&
                      e?.chart?.["chart_type"] === "wordcloud"
                    ) {
                      let widget_id = e["widget_id"];
                      let word =
                        forParticularSection?.temporary_words?.[
                          forParticularSection?.template_id
                        ]?.[el?.section_id]?.[widget_id]?.exclude_words;
                      let temp_exclude_words = word?.length ? word : null;
                      e.temp_exclude_words = temp_exclude_words;
                    }
                    e["widget_name"] = e?.originalWidgetName;
                    delete e?.duplicate_for_brands;
                    delete e?.parentId;
                    delete e?.childId;
                    delete e?.span;
                    delete e?.originalWidgetName;
                    delete e?.com_brand_ids;
                    if (e?.graphData) {
                      delete e?.graphData;
                    }
                    if (e?.persist_graphdata) {
                      delete e?.persist_graphdata;
                    }
                    if (e?.deep_dive_on) {
                      delete e?.deep_dive_on;
                    }
                    if (e?.data) {
                      delete e?.data;
                    }
                  }
                  sectionWidgetObject.push(e);
                }
              } else {
                return sectionWidgetObject.push(e);
              }
            });
          el.data = sectionWidgetObject;
          el.widgets = sectionWidgetObject;
          return el;
        }
      } else {
        return el;
      }
    });
  } else {
    sectionObject = Section?.map((el) => {
      if (el?.data && el?.data?.length > 0) {
        let sectionWidgetObject = [];
        el?.data &&
          el?.data?.map((e) => {
            if (!(e?.childId && e?.duplicate_for_brands)) {
              if (e?.duplicate_for_brands && e?.parentId) {
                if (
                  objForTemporyWordFunctionality &&
                  e?.chart?.["chart_type"] === "wordcloud"
                ) {
                  let widget_id = e["widget_id"];
                  let word =
                    objForTemporyWordFunctionality?.temporary_words?.[
                      objForTemporyWordFunctionality?.template_id
                    ]?.[el?.section_id]?.[widget_id]?.exclude_words;
                  let temp_exclude_words = word?.length ? word : null;
                  e.temp_exclude_words = temp_exclude_words;
                }
                e["widget_name"] = e?.originalWidgetName;
                delete e?.duplicate_for_brands;
                delete e?.parentId;
                delete e?.childId;
                delete e?.span;
                delete e?.originalWidgetName;
                delete e?.com_brand_ids;
                if (e?.graphData) {
                  delete e?.graphData;
                }
                if (e?.persist_graphdata) {
                  delete e?.persist_graphdata;
                }
                if (e?.deep_dive_on) {
                  delete e?.deep_dive_on;
                }
                if (e?.data) {
                  delete e?.data;
                }
              }

              sectionWidgetObject.push(e);
            }
          });
        el.data = sectionWidgetObject;
        el.widgets = sectionWidgetObject;
        return el;
      } else if (el?.widgets && el?.widgets?.length > 0) {
        let sectionWidgetObject = [];
        el?.widgets &&
          el?.widgets?.map((e) => {
            if (!(e?.childId && e?.duplicate_for_brands)) {
              if (e?.duplicate_for_brands && e?.parentId) {
                if (
                  objForTemporyWordFunctionality &&
                  e?.chart?.["chart_type"] === "wordcloud"
                ) {
                  let widget_id = e["widget_id"];
                  let word =
                    objForTemporyWordFunctionality?.temporary_words?.[
                      objForTemporyWordFunctionality?.template_id
                    ]?.[el?.section_id]?.[widget_id]?.exclude_words;
                  let temp_exclude_words = word?.length ? word : null;
                  e.temp_exclude_words = temp_exclude_words;
                }
                e["widget_name"] = e?.originalWidgetName;
                delete e?.duplicate_for_brands;
                delete e?.parentId;
                delete e?.childId;
                delete e?.span;
                delete e?.originalWidgetName;
                delete e?.com_brand_ids;
                if (e?.graphData) {
                  delete e?.graphData;
                }
                if (e?.persist_graphdata) {
                  delete e?.persist_graphdata;
                }
                if (e?.deep_dive_on) {
                  delete e?.deep_dive_on;
                }
                if (e?.data) {
                  delete e?.data;
                }
              }
              sectionWidgetObject.push(e);
            }
          });
        el.data = sectionWidgetObject;
        el.widgets = sectionWidgetObject;
        return el;
      }
    });
  }
  return sectionObject;
};

export const getWordCloudSectionsWidgets = (Section) => {
  let sectionObject;
  sectionObject = Section?.map((el) => {
    if (el?.widgets && el?.widgets?.length > 0) {
      let sectionWidgetObject = [];
      el?.widgets &&
        el?.widgets?.map((e) => {
          if (e?.chart?.["chart_type"] === "wordcloud") {
            if (e?.graphData) {
              delete e?.graphData;
            }
            if (e?.persist_graphdata) {
              delete e?.persist_graphdata;
            }
            if (e?.deep_dive_on) {
              delete e?.deep_dive_on;
            }
          }
          sectionWidgetObject.push(e);
        });
      el.data = sectionWidgetObject;
      el.widgets = sectionWidgetObject;
      return el;
    }
  });
  return sectionObject;
};
export const checkForDuplicateWidgets = (Section, forParticularSection) => {
  let response = {
    duplicateExists: false,
    parentExists: false,
  };
  let checkForDuplicateWidgets = false;
  let checkForParentExists = false;
  if (forParticularSection) {
    if (
      Section &&
      Section?.[forParticularSection?.section_index]?.data?.length > 0
    ) {
      Section?.[forParticularSection?.section_index]?.data?.map((el) => {
        if (
          !el?.duplicate_for_brands &&
          el?.chart &&
          (el?.chart?.["chart_type"] === "wordcloud" ||
            el?.chart?.["chart_type"] === "grid" ||
            el?.chart?.["chart_type"] === "post-card" ||
            el?.chart?.["chart_type"] === "author-card") &&
          el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
        ) {
          checkForDuplicateWidgets = true;
        } else if (
          el?.duplicate_for_brands &&
          el?.parentId &&
          el?.chart &&
          (el?.chart?.["chart_type"] === "wordcloud" ||
            el?.chart?.["chart_type"] === "grid" ||
            el?.chart?.["chart_type"] === "post-card" ||
            el?.chart?.["chart_type"] === "author-card") &&
          el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
        ) {
          checkForParentExists = true;
        }
      });
    } else if (
      Section &&
      Section?.[forParticularSection?.section_index]?.widgets?.length > 0
    ) {
      Section?.[forParticularSection?.section_index]?.widgets?.map((el) => {
        if (
          !el?.duplicate_for_brands &&
          el?.chart &&
          (el?.chart?.["chart_type"] === "wordcloud" ||
            el?.chart?.["chart_type"] === "grid" ||
            el?.chart?.["chart_type"] === "post-card" ||
            el?.chart?.["chart_type"] === "author-card") &&
          el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
        ) {
          checkForDuplicateWidgets = true;
        } else if (
          el?.duplicate_for_brands &&
          el?.chart &&
          el?.parentId &&
          (el?.chart?.["chart_type"] === "wordcloud" ||
            el?.chart?.["chart_type"] === "grid" ||
            el?.chart?.["chart_type"] === "post-card" ||
            el?.chart?.["chart_type"] === "author-card") &&
          el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
        ) {
          checkForParentExists = true;
        }
      });
    }
  } else {
    if (Section && Section[0]?.data?.length > 0) {
      Section?.map((sec, secIndex) => {
        sec?.data?.map((el) => {
          if (
            !el?.duplicate_for_brands &&
            el?.chart &&
            (el?.chart?.["chart_type"] === "wordcloud" ||
              el?.chart?.["chart_type"] === "grid" ||
              el?.chart?.["chart_type"] === "post-card" ||
              el?.chart?.["chart_type"] === "author-card") &&
            el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
          ) {
            checkForDuplicateWidgets = true;
          } else if (
            el?.duplicate_for_brands &&
            el?.parentId &&
            el?.chart &&
            (el?.chart?.["chart_type"] === "wordcloud" ||
              el?.chart?.["chart_type"] === "grid" ||
              el?.chart?.["chart_type"] === "post-card" ||
              el?.chart?.["chart_type"] === "author-card") &&
            el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
          ) {
            checkForParentExists = true;
          }
        });
      });
    } else if (Section && Section[0]?.widgets?.length > 0) {
      Section?.map((sec, secIndex) => {
        sec?.widgets?.map((el) => {
          if (
            !el?.duplicate_for_brands &&
            el?.chart &&
            (el?.chart?.["chart_type"] === "wordcloud" ||
              el?.chart?.["chart_type"] === "grid" ||
              el?.chart?.["chart_type"] === "post-card" ||
              el?.chart?.["chart_type"] === "author-card") &&
            el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
          ) {
            checkForDuplicateWidgets = true;
          } else if (
            el?.duplicate_for_brands &&
            el?.chart &&
            el?.parentId &&
            (el?.chart?.["chart_type"] === "wordcloud" ||
              el?.chart?.["chart_type"] === "grid" ||
              el?.chart?.["chart_type"] === "post-card" ||
              el?.chart?.["chart_type"] === "author-card") &&
            el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
          ) {
            checkForParentExists = true;
          }
        });
      });
    }
  }
  response.duplicateExists = checkForDuplicateWidgets;
  response.parentExists = checkForParentExists;
  return response;
};
export const splitSectionWidgets = (
  updatedSection,
  newBrandList,
  brands,
  ignoreWidgetLockFor,
  ignoreSectionComFilterFor
) => {
  let newSection = deepCopy(updatedSection);
  updatedSection?.map((sec, secIndex) => {
    let newDataListForSection = [];
    let secLockedOnBrand =
      sec?.is_locked &&
      sec?.brands?.length > 0 &&
      (sec?.brands?.[0]?.columns
        ? !sec?.brands?.[0]?.columns?.[0]?.competitor
        : !sec?.brands?.[0]?.competitor);
    let comBrandtypeExists =
      sec?.comp_brand_type === false || sec?.comp_brand_type === true
        ? true
        : false;
    if (ignoreSectionComFilterFor?.section_id === sec?.id) {
      comBrandtypeExists = false;
      secLockedOnBrand = false;
    }
    if (!secLockedOnBrand && !comBrandtypeExists && sec?.data?.length > 0) {
      sec?.data?.map((el) => {
        let widgetLockedOnBrand =
          el?.is_locked &&
          el?.brands?.length > 0 &&
          (el?.brands?.[0]?.columns
            ? !el?.brands?.[0]?.columns?.[0]?.competitor
            : !el?.brands?.[0]?.competitor);
        if (
          ignoreWidgetLockFor?.section_index === secIndex &&
          ignoreWidgetLockFor?.widget_id === el?.widget_id
        ) {
          widgetLockedOnBrand = false;
        }
        if (
          !widgetLockedOnBrand &&
          !el?.duplicate_for_brands &&
          (el?.chart?.["chart_type"] === "wordcloud" ||
            el?.chart?.["chart_type"] === "grid" ||
            el?.chart?.["chart_type"] === "post-card" ||
            el?.chart?.["chart_type"] === "author-card") &&
          el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
        ) {
          let duplicateWidgets = getDuplicateWidgets(newBrandList, el, brands);
          if (duplicateWidgets) {
            newDataListForSection = [
              ...newDataListForSection,
              ...duplicateWidgets,
            ];
          } else {
            newDataListForSection.push(el);
          }
        } else {
          newDataListForSection.push(el);
        }
      });
    } else if (
      !secLockedOnBrand &&
      !comBrandtypeExists &&
      sec?.widgets?.length > 0
    ) {
      sec?.widgets?.map((el) => {
        let widgetLockedOnBrand =
          el?.is_locked &&
          el?.brands?.length > 0 &&
          (el?.brands?.[0]?.columns
            ? !el?.brands?.[0]?.columns?.[0]?.competitor
            : !el?.brands?.[0]?.competitor);
        if (
          ignoreWidgetLockFor?.section_index === secIndex &&
          ignoreWidgetLockFor?.widget_id === el?.widget_id
        ) {
          widgetLockedOnBrand = false;
        }
        if (
          !widgetLockedOnBrand &&
          !el?.duplicate_for_brands &&
          (el?.chart?.["chart_type"] === "wordcloud" ||
            el?.chart?.["chart_type"] === "grid" ||
            el?.chart?.["chart_type"] === "post-card" ||
            el?.chart?.["chart_type"] === "author-card") &&
          el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
        ) {
          let duplicateWidgets = getDuplicateWidgets(newBrandList, el, brands);
          if (duplicateWidgets) {
            newDataListForSection = [
              ...newDataListForSection,
              ...duplicateWidgets,
            ];
          } else {
            newDataListForSection.push(el);
          }
        } else {
          newDataListForSection.push(el);
        }
      });
    }
    newSection[secIndex].data =
      secLockedOnBrand || comBrandtypeExists
        ? sec?.data
        : newDataListForSection;
    newSection[secIndex].widgets =
      secLockedOnBrand || comBrandtypeExists
        ? sec?.widgets
        : newDataListForSection;
  });
  return newSection;
};
export const splitSectionWidgetsInShare = (
  updatedSection,
  newBrandList,
  brands
) => {
  let newSection = deepCopy(updatedSection);
  updatedSection?.map((sec, secIndex) => {
    let newDataListForSection = [];
    let secLockedOnBrand =
      sec?.is_locked &&
      (sec?.brand_groups?.length > 0 || sec?.brand_ids?.length > 0);
    let comBrandtypeExists =
      sec?.comp_brand_type === false || sec?.comp_brand_type === true
        ? true
        : false;
    if (!secLockedOnBrand && !comBrandtypeExists && sec?.data?.length > 0) {
      sec?.data?.map((el) => {
        let widgetLockedOnBrand =
          el?.is_locked &&
          (el?.brand_groups?.length > 0 || el?.brand_ids?.length > 0);
        if (
          !widgetLockedOnBrand &&
          !el?.duplicate_for_brands &&
          (el?.chart?.["chart_type"] === "wordcloud" ||
            el?.chart?.["chart_type"] === "grid" ||
            el?.chart?.["chart_type"] === "post-card" ||
            el?.chart?.["chart_type"] === "author-card") &&
          el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
        ) {
          let duplicateWidgets = getDuplicateWidgets(newBrandList, el, brands);
          if (duplicateWidgets) {
            newDataListForSection = [
              ...newDataListForSection,
              ...duplicateWidgets,
            ];
          } else {
            newDataListForSection.push(el);
          }
        } else {
          newDataListForSection.push(el);
        }
      });
    } else if (
      !secLockedOnBrand &&
      !comBrandtypeExists &&
      sec?.widgets?.length > 0
    ) {
      sec?.widgets?.map((el) => {
        let widgetLockedOnBrand =
          el?.is_locked &&
          (el?.brand_groups?.length > 0 || el?.brand_ids?.length > 0);
        if (
          !widgetLockedOnBrand &&
          !el?.duplicate_for_brands &&
          (el?.chart?.["chart_type"] === "wordcloud" ||
            el?.chart?.["chart_type"] === "grid" ||
            el?.chart?.["chart_type"] === "post-card" ||
            el?.chart?.["chart_type"] === "author-card") &&
          el?.chart?.["chart_settings"]?.["duplicate_for_brands"]
        ) {
          let duplicateWidgets = getDuplicateWidgets(newBrandList, el, brands);
          if (duplicateWidgets) {
            newDataListForSection = [
              ...newDataListForSection,
              ...duplicateWidgets,
            ];
          } else {
            newDataListForSection.push(el);
          }
        } else {
          newDataListForSection.push(el);
        }
      });
    }
    newSection[secIndex].data =
      secLockedOnBrand || comBrandtypeExists
        ? sec?.data
        : newDataListForSection;
    newSection[secIndex].widgets =
      secLockedOnBrand || comBrandtypeExists
        ? sec?.widgets
        : newDataListForSection;
  });
  return newSection;
};
export const getGlobalPaneBrandsValue = (
  authParams,
  paneObj,
  pane_template_id,
  quick_filter
) => {
  let paneObject = {
    selectBrands: null,
    panes: paneObj?.panes,
    index: paneObj?.index,
  };
  // let defaultSingleBrand = {
  //   columns: paneObj?.singleBrands ? [paneObj?.singleBrands?.[0]] : [],
  //   attribute: "BrandID",
  //   type: "varchar",
  // };
  let defaultSingleBrand = getBrands(
    paneObj?.brands,
    [paneObj?.singleBrands?.[0]],
    paneObj?.singleBrands,
    null
  );
  // let defaultLogicalBrand = {
  //   columns: paneObj?.brands ? [paneObj?.brands?.[0]] : [],
  //   attribute: "BrandID",
  //   type: "varchar",
  // };
  let defaultLogicalBrand = getBrands(
    paneObj?.brands,
    null,
    paneObj?.singleBrands,
    [paneObj?.brands?.[0]]
  );
  let defaultCompBrand =
    paneObj?.competitorBrands?.length > 0
      ? getDefaultCompBrand(paneObj?.competitorBrands)
      : null;

  if (authParams) {
    if (
      //ticket dashboards
      paneObj?.template_type === "ticket"
    ) {
      if (
        //global single brands
        paneObj?.global_dashboard_single_brands
      ) {
        paneObject.selectBrands = paneObj?.global_dashboard_single_brands;
      } else {
        //clear other pane brands(logical,comp) for ticket dashboards
        paneObject.selectBrands = defaultSingleBrand;
      }
    } else {
      //other dashboards
      //to set default comp brands in competiiton benchmark dashboard
      if (authParams?.brandID) {
        let obj = getBrands(
          paneObj?.brands,
          [{ brand_id: authParams?.brandID }],
          paneObj?.singleBrands,
          null
        );

        paneObject.selectBrands = obj?.columns
          ? obj?.columns
          : [{ brand_id: authParams?.brandID }];
      } else if (
        paneObj?.template_type === "competition" &&
        (!paneObj?.global_dashboard_brands ||
          (paneObj?.global_dashboard_brands &&
            !paneObj?.global_dashboard_brands?.columns?.[0]?.competitor))
      ) {
        if (!authParams?.ppt)
          paneObject.selectBrands = defaultCompBrand
            ? defaultCompBrand
            : defaultSingleBrand;
      } else if (paneObj?.global_dashboard_brands) {
        //to set global normal brands

        if (
          //to not update pane brands if benchmark dashboard is opened
          (paneObj?.global_dashboard_brands?.columns?.[0]?.competitor &&
            paneObj?.template_type === "competition") ||
          paneObj?.template_type !== "competition"
        ) {
          if (
            paneObj?.global_dashboard_brands?.columns?.[0]?.competitor &&
            paneObj?.template_type !== "competition" &&
            !authParams?.ppt
          ) {
            paneObject.selectBrands = paneObj?.global_dashboard_single_brands //if global single brands then add it to panes (formatting is diff)
              ? [paneObj?.global_dashboard_single_brands?.columns]
              : defaultLogicalBrand?.columns?.length && !quick_filter
              ? defaultLogicalBrand
              : defaultSingleBrand?.columns?.length
              ? defaultSingleBrand
              : null;
          } else if (quick_filter) {
            paneObject.selectBrands =
              !paneObj?.global_dashboard_brands?.columns?.[0]?.group &&
              paneObj?.global_dashboard_brands?.columns?.length
                ? {
                    columns: [paneObj?.global_dashboard_brands?.columns?.[0]],
                    attribute: "BrandID",
                    type: "varchar",
                  }
                : paneObj?.global_dashboard_single_brands //if global single brands then add it to panes (formatting is diff)
                ? [paneObj?.global_dashboard_single_brands?.columns]
                : defaultSingleBrand;
          } else {
            paneObject.selectBrands = paneObj?.global_dashboard_brands;
          }
        }
      } else {
        if (paneObj?.global_dashboard_single_brands) {
          //if global single brands then add it to panes (formatting is diff)
          paneObject.selectBrands = [
            paneObj?.global_dashboard_single_brands?.columns,
          ];
        } else {
          paneObject.selectBrands =
            defaultLogicalBrand?.columns?.length && !quick_filter
              ? defaultLogicalBrand
              : defaultSingleBrand?.columns?.length
              ? defaultSingleBrand
              : null;
        }
      }
    }
  } else if (quick_filter) {
    if (
      paneObj?.global_dashboard_brands &&
      paneObj?.global_dashboard_brands?.columns &&
      paneObj?.global_dashboard_brands?.columns?.length > 0 &&
      !paneObj?.global_dashboard_brands?.columns?.[0]?.group &&
      !paneObj?.global_dashboard_brands?.columns?.[0]?.competitor
    ) {
      paneObject.selectBrands = {
        columns: paneObj?.global_dashboard_brands?.columns?.length
          ? [paneObj?.global_dashboard_brands?.columns?.[0]]
          : [],
        attribute: "BrandID",
        type: "varchar",
      };
    } else if (paneObj?.global_dashboard_single_brands) {
      //if global single brands then add it to panes (formatting is diff)
      paneObject.selectBrands = [
        paneObj?.global_dashboard_single_brands?.columns,
      ];
    } else {
      paneObject.selectBrands = defaultSingleBrand;
    }
  } else if (pane_template_id) {
    //on dashbaord reload and dashboard open
    if (
      paneObj?.panes[paneObj?.index]?.template_type === "ticket" ||
      paneObj?.template_type === "ticket"
    ) {
      if (
        paneObj?.global_dashboard_brands ||
        paneObj?.global_dashboard_single_brands
      ) {
        if (paneObj?.global_dashboard_single_brands) {
          paneObject.selectBrands = paneObj?.global_dashboard_single_brands;
        } else if (paneObj?.global_dashboard_brands?.columns?.brand_id) {
          // this belongs to SingleBrand component
          paneObject.selectBrands = paneObj?.global_dashboard_brands;
        } else {
          paneObject.selectBrands = defaultSingleBrand;
        }
      } else {
        paneObject.selectBrands = defaultSingleBrand;
      }
    } else if (paneObj?.global_dashboard_brands) {
      if (
        paneObj?.template_type === "competition" ||
        (paneObj?.template_type
          ? paneObj?.template_type === "competition" &&
            paneObj?.panes &&
            paneObj?.panes[paneObj?.index]?.template_type === "competition"
          : paneObj?.panes &&
            paneObj?.panes[paneObj?.index]?.template_type === "competition")
      ) {
        if (
          paneObj?.global_dashboard_brands?.columns?.[0]?.competitor ||
          paneObj?.global_dashboard_brands?.competitor
        ) {
          paneObject.selectBrands = paneObj?.global_dashboard_brands;
        } else {
          // if (defaultCompBrand) paneObject.selectBrands = defaultCompBrand;
          paneObject.selectBrands = defaultCompBrand
            ? defaultCompBrand
            : defaultSingleBrand;
        }
      } else {
        if (
          paneObj?.global_dashboard_brands?.columns?.[0]?.competitor ||
          paneObj?.global_dashboard_brands?.competitor
        ) {
          paneObject.selectBrands = defaultLogicalBrand?.columns?.length
            ? defaultLogicalBrand
            : defaultSingleBrand?.columns?.length
            ? defaultSingleBrand
            : null;
        } else paneObject.selectBrands = paneObj?.global_dashboard_brands;
      }
    } else if (
      paneObj?.template_type === "competition" ||
      (paneObj?.template_type
        ? paneObj?.template_type === "competition" &&
          paneObj?.panes &&
          paneObj?.panes[paneObj?.index]?.template_type === "competition"
        : paneObj?.panes &&
          paneObj?.panes[paneObj?.index]?.template_type === "competition")
    ) {
      paneObject.selectBrands = defaultCompBrand
        ? defaultCompBrand
        : defaultSingleBrand;
    } else {
      paneObject.selectBrands = defaultLogicalBrand?.columns?.length
        ? defaultLogicalBrand
        : defaultSingleBrand?.columns?.length
        ? defaultSingleBrand
        : null;
    }
  }

  return paneObject;
};

export const getGlobalPPTBrandsValue = (authParams, paneObj) => {
  let paneObject = {
    selectBrands: null,
    panes: paneObj?.panes,
    index: paneObj?.index,
  };
  if (authParams?.brandId) {
    paneObject.selectBrands = authParams?.brandId;
  } else if (authParams?.brandGroup) {
    paneObject.selectBrands = authParams?.brandGroup;
  } else if (authParams?.compBrands) {
    paneObject.selectBrands = authParams?.compBrands;
  }
  return paneObject;
};

export const getGlobalBrands = (
  pane_brands,
  global_dashboard_single_brands,
  global_dashboard_brands,
  template_type
) => {
  let final_brands =
    template_type === "ticket"
      ? global_dashboard_single_brands?.columns
        ? global_dashboard_single_brands?.columns
        : global_dashboard_single_brands
      : pane_brands
      ? pane_brands
      : global_dashboard_brands
      ? template_type === "competition"
        ? global_dashboard_brands?.columns?.[0]?.competitor
          ? global_dashboard_brands?.columns
          : pane_brands
        : template_type !== "competition"
        ? !global_dashboard_brands?.columns?.[0]?.competitor
          ? global_dashboard_brands?.columns
          : pane_brands
        : pane_brands
      : pane_brands;
  return final_brands ? final_brands : null;
};

export const getTemporaryWords = (paneobject) => {
  let temp_exclude_words;
  if (
    paneobject?.temporary_words?.[paneobject?.template_id]?.[
      paneobject?.section_id
    ]?.[paneobject?.widget_id]
  ) {
    temp_exclude_words =
      paneobject?.temporary_words?.[paneobject?.template_id]?.[
        paneobject?.section_id
      ]?.[paneobject?.widget_id]?.exclude_words;
  }
  return temp_exclude_words;
};
export const getCombinedDate = (global_date, filters_date) => {
  let start_date_arr = global_date ? [global_date?.from] : [];
  let end_date_arr = global_date ? [global_date?.to] : [];

  filters_date &&
    filters_date?.map((d) => {
      start_date_arr = [...start_date_arr, d?.from];
    });
  filters_date &&
    filters_date?.map((d) => {
      end_date_arr = [...end_date_arr, d?.to];
    });

  let start = start_date_arr.map((d) => moment(d)),
    maxStartDate = moment.min(start);
  let start_date = moment(maxStartDate).format("YYYY/MM/DD H:mm");

  let end = end_date_arr.map((d) => moment(d)),
    maxEndDate = moment.max(end);
  let end_date = moment(maxEndDate).format("YYYY/MM/DD H:mm");

  let final_date_obj = {
    start_date: start_date,
    end_date: end_date,
  };
  return final_date_obj;
};

export const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

export const getDefaultDuration = (obj) => {
  let twoMonthsDuration = getCustomizedDate(
    obj?.isCommandCenter ? 0 : 6,
    "Days"
  );
  let defaultDuration = {
    from:
      moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
      " " +
      twoMonthsDuration?.time?.startTime,
    to:
      moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
      " " +
      twoMonthsDuration?.time?.endTime,
  };
  return defaultDuration;
};

export const getMtdYtdDuration = (value) => {
  let twoMonthsDuration = getCustomizedDate(value, "short");
  let defaultShortDuration = {
    from:
      moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
      " " +
      twoMonthsDuration?.time?.startTime,
    to:
      moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
      " " +
      twoMonthsDuration?.time?.endTime,
  };
  return defaultShortDuration;
};
// Calculate weeks for a given month and year, every week having 7 days
const calculateWeeks = (month, year) => {
  const weeks = [];
  // Create a moment for the first day of the month.
  const firstDayOfMonth = moment({ year, month, day: 1 });
  const daysInMonth = firstDayOfMonth.daysInMonth();

  let weekNumber = 1;
  // Loop through the days of the month in steps of 7.
  for (let day = 1; day <= daysInMonth; day += 7) {
    const startDate = moment({ year, month, day });
    // Add 6 days to get a 7-day week.
    let endDate = moment(startDate).add(6, "days");
    // If the calculated endDate goes past the month, clamp it to the month's last day.
    if (endDate.month() !== month) {
      endDate = moment({ year, month, day: daysInMonth });
    }

    weeks.push({
      weekNumber,
      startDate,
      endDate,
      displayText: `${startDate.format("DD MMM")} - ${endDate.format(
        "DD MMM"
      )}`,
    });
    if (weekNumber >= 4) break; // only allow 4 weeks currently; remove this if you want 5 weeks.
    weekNumber++;
  }

  return weeks;
};
// Function to return default previous week duration
export const getDefaultPreviousWeekDuration = () => {
  const today = moment();
  // Calculate weeks for the current month
  let weeks = calculateWeeks(today.month(), today.year());

  // Find the week that includes today (using inclusive boundaries)
  let currentWeekIndex = weeks.findIndex((week) =>
    today.isBetween(week.startDate, week.endDate, "day", "[]")
  );

  // If today's week is found and it's not the first week, select the previous week
  if (currentWeekIndex > 0) {
    const prevWeek = weeks[currentWeekIndex - 1];
    return {
      from: prevWeek.startDate.format("YYYY/MM/DD") + " 00:00",
      to: prevWeek.endDate.format("YYYY/MM/DD") + " 23:59",
      displayText: prevWeek.displayText,
    };
  } else {
    // If today is in the first week of the current month, fallback to the last week of the previous month.
    const previousMonth = moment().subtract(1, "month");
    const prevMonthWeeks = calculateWeeks(
      previousMonth.month(),
      previousMonth.year()
    );
    const lastWeek = prevMonthWeeks[prevMonthWeeks.length - 1];
    return {
      from: lastWeek.startDate.format("YYYY/MM/DD") + " 00:00",
      to: lastWeek.endDate.format("YYYY/MM/DD") + " 23:59",
      displayText: lastWeek.displayText,
    };
  }
};
export const getWidgetGraphObject = (rawData) => {
  let graphObject;
  if (rawData?.type === "deepdive_dashboard") {
    let dashboardData = rawData?.deepdiveDashboardData;
    let templateData = rawData?.deepdiveDashboardTemplateData;

    let quickFilterAttribute = ["AccountID", "SettingID"]?.includes(
      templateData?.quick_filter
    )
      ? "AccountID"
      : templateData?.quick_filter
      ? templateData?.quick_filter
      : null;

    let sectionData = templateData?.sections
      ? templateData?.sections?.[rawData?.section_index]
      : null;

    let widgetData = sectionData?.widgets?.[rawData?.widget_index]
      ? sectionData?.widgets?.[rawData?.widget_index]
      : rawData?.data
      ? rawData?.data
      : rawData?.widget;
    let Section_is_locked = sectionData?.is_locked;
    Section_is_locked = !!Section_is_locked;
    let widgets_is_locked = widgetData?.is_locked;
    widgets_is_locked = !!widgets_is_locked;

    let defaultDuration = getDefaultDuration();
    let sectionDateFilter = sectionData
      ? {
          from: sectionData?.start_date ? sectionData?.start_date : null,
          to: sectionData?.end_date ? sectionData?.end_date : null,
        }
      : null;
    let widgetFilterDate = widgetData
      ? {
          from: widgetData?.start_date ? widgetData?.start_date : null,
          to: widgetData?.end_date ? widgetData?.end_date : null,
        }
      : null;

    let paneObj = { temporary_words: rawData?.temporary_words };
    paneObj.template_id = templateData?.template_id;
    paneObj.section_id = sectionData?.section_id;
    paneObj.widget_id = widgetData?.widget_id;
    //for exploded wordcloud by comptitor brands
    if (widgetData?.duplicate_for_brands) {
      paneObj.widget_id = getTemporaryWordWidgetId(widgetData);
    }
    let temp_exclude_words = getTemporaryWords(paneObj);

    let sectionBrands =
      sectionData?.brand_ids || sectionData?.brand_groups
        ? getBrands(
            rawData?.brandlogicalgroup?.length > 0
              ? rawData?.brandlogicalgroup
              : rawData?.brands,
            sectionData?.brand_ids ? sectionData?.brand_ids : null,
            rawData?.brands,
            sectionData?.brand_groups ? sectionData?.brand_groups : null
          )
        : sectionData?.brandFilters
        ? sectionData?.brandFilters
        : null;
    let sectionComprtitorBrandType =
      sectionData?.comp_brand_type === false ||
      sectionData?.comp_brand_type === true
        ? sectionData?.comp_brand_type
        : null;
    let sectionComprtitorBrandTypeExists =
      sectionComprtitorBrandType === false ||
      sectionComprtitorBrandType === true;
    let widgetBrands = widgetData?.brandFilters?.columns
      ? widgetData?.brandFilters
      : getBrands(
          rawData?.brandlogicalgroup?.length > 0
            ? rawData?.brandlogicalgroup
            : rawData?.brands,
          widgetData?.brand_ids,
          rawData?.brands,
          widgetData?.brand_groups
        );

    let finalExcludeWords =
      rawData?.exclude_words && !widgetData?.duplicate_for_brands
        ? widgetData?.exclude_words
          ? [...rawData?.exclude_words, ...widgetData?.exclude_words]
          : [...rawData?.exclude_words]
        : temp_exclude_words &&
          widgetData?.exclude_words &&
          !widgetData?.duplicate_for_brands
        ? [...temp_exclude_words, ...widgetData?.exclude_words]
        : !widgetData?.duplicate_for_brands && widgetData?.exclude_words
        ? [...widgetData?.exclude_words]
        : temp_exclude_words
        ? [...temp_exclude_words]
        : [];

    let updatedOrderBy;
    if (widgetData?.order_by) {
      updatedOrderBy = {
        ...widgetData?.order_by,
        offset: 0,
      };
    }

    let updatedFilter = getDiscardedFilters(rawData);
    // console.log("final step 1", updatedFilter, rawData);
    if (!updatedFilter && quickFilterAttribute !== "AccountID") {
      let obj;
      if (rawData?.profile_filters_list?.length > 0) {
        obj = {
          attribute: "SocialMediaProfiles",
          type: "varchar",
          columns: [
            {
              name: rawData?.profile_filters_list?.[0]?.id
                ? rawData?.profile_filters_list?.[0]?.id
                : null,
              type: "include",
              display_name: rawData?.profile_filters_list?.[0]?.name
                ? rawData?.profile_filters_list?.[0]?.name
                : null,
              profile_channel: rawData?.profile_filters_list?.[0]?.channel
                ? rawData?.profile_filters_list?.[0]?.channel
                : null,
              brand_id: rawData?.profile_filters_list?.[0]?.brand_id
                ? rawData?.profile_filters_list?.[0]?.brand_id
                : null,
            },
          ],
        };
      } else {
        obj = null;
      }
      updatedFilter = obj;
    }

    // calculating brand in case of section comprtiotion brand type exists
    let updatedComBrandList = [];
    if (
      !(Section_is_locked && sectionBrands?.columns) &&
      sectionComprtitorBrandTypeExists
    ) {
      let comBrand = rawData?.global_brands?.columns?.[0]?.competitor
        ? rawData?.global_brands?.columns?.[0]
        : rawData?.global_brands?.[0]?.competitor
        ? rawData?.global_brands?.[0]
        : rawData?.global_brands?.competitor
        ? rawData?.global_brands
        : null;
      if (comBrand?.competitor) {
        if (sectionComprtitorBrandType === false) {
          updatedComBrandList.push({
            brand_id: comBrand?.name,
            brand_name: comBrand?.brand_name,
            brand_friendly_name: comBrand?.brand_friendly_name,
          });
        } else {
          comBrand?.competitorList?.forEach((competitorBrand) => {
            updatedComBrandList.push(competitorBrand);
          });
        }
      } else {
        sectionComprtitorBrandTypeExists = false;
      }
    }
    // this is used for brand filter selectedtion like date aggregation
    let widgetSingleBrandFilter = widgetData?.widgetSingleBrandFilter?.brand_id
      ? [
          {
            brand_id: widgetData?.widgetSingleBrandFilter?.brand_id,
            brand_name: widgetData?.widgetSingleBrandFilter?.brand_name,
            brand_friendly_name:
              widgetData?.widgetSingleBrandFilter?.brand_friendly_name,
          },
        ]
      : null;
    // here calculating the competition_aggregation for the widget
    let competition_aggregation = templateData?.competition_aggregation;

    let updatedWidgetChartSettings = null;
    if (
      competition_aggregation &&
      !sectionComprtitorBrandTypeExists &&
      !(
        widgetData?.chart?.chart_settings?.benchmark_line &&
        widgetData?.chart?.chart_settings?.group_line_agg
      ) &&
      widgetData?.chart?.chart_settings
    ) {
      updatedWidgetChartSettings = widgetData?.chart?.chart_settings
        ? deepCopy(widgetData?.chart)
        : new Object(widgetData?.chart);
      updatedWidgetChartSettings.chart_settings.benchmark_line = true;
      updatedWidgetChartSettings.chart_settings.benchmark_static_value = null;
      updatedWidgetChartSettings.chart_settings.group_line_agg =
        competition_aggregation;
    }
    // here calculating the public_engagement_only for the widget
    let public_engagement_only =
      templateData?.template_type === "competition"
        ? templateData?.public_engagement_only || false
        : false;

    if (
      rawData?.graphConditionConfig?.[`data-source`]?.includes(
        widgetData?.data_source
      ) ||
      widgetData?.x_axis ||
      widgetData?.y_series ||
      widgetData?.chart
    ) {
      graphObject = {
        start_date: widgetData?.is_locked
          ? widgetData?.start_date
            ? widgetData?.start_date
            : widgetFilterDate?.from
            ? widgetFilterDate?.from
            : Section_is_locked
            ? sectionDateFilter?.from
              ? sectionDateFilter?.from
              : rawData?.duration?.from
              ? rawData?.duration?.from
              : defaultDuration?.from
            : rawData?.duration?.from
            ? rawData?.duration?.from
            : defaultDuration?.from
          : Section_is_locked
          ? sectionDateFilter?.from
            ? sectionDateFilter?.from
            : rawData?.duration?.from
            ? rawData?.duration?.from
            : defaultDuration?.from
          : rawData?.duration?.from
          ? rawData?.duration?.from
          : defaultDuration?.from,
        end_date: widgetData?.is_locked
          ? widgetData?.end_date
            ? widgetData?.end_date
            : widgetFilterDate?.to
            ? widgetFilterDate?.to
            : Section_is_locked
            ? sectionDateFilter?.to
              ? sectionDateFilter?.to
              : rawData?.duration?.to
              ? rawData?.duration?.to
              : defaultDuration?.to
            : rawData?.duration?.to
            ? rawData?.duration?.to
            : defaultDuration?.to
          : Section_is_locked
          ? sectionDateFilter?.to
            ? sectionDateFilter?.to
            : rawData?.duration?.to
            ? rawData?.duration?.to
            : defaultDuration?.to
          : rawData?.duration?.to
          ? rawData?.duration?.to
          : defaultDuration?.to,
        brands: widgetSingleBrandFilter
          ? widgetSingleBrandFilter
          : widgets_is_locked
          ? widgetBrands?.columns
            ? widgetBrands?.columns
            : Section_is_locked
            ? sectionBrands?.columns
              ? sectionBrands?.columns
              : widgetData?.duplicate_for_brands
              ? widgetData?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : rawData?.global_brands
              ? rawData?.global_brands
              : rawData?.brandlogicalgroup?.length
              ? rawData?.brandlogicalgroup
              : rawData?.brands
            : widgetData?.duplicate_for_brands
            ? widgetData?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : rawData?.global_brands
            ? rawData?.global_brands
            : rawData?.brandlogicalgroup?.length
            ? rawData?.brandlogicalgroup
            : rawData?.brands
          : Section_is_locked
          ? sectionBrands?.columns
            ? sectionBrands?.columns
            : widgetData?.duplicate_for_brands
            ? widgetData?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : rawData?.global_brands
            ? rawData?.global_brands
            : rawData?.brandlogicalgroup?.length
            ? rawData?.brandlogicalgroup
            : rawData?.brands
          : widgetData?.duplicate_for_brands
          ? widgetData?.com_brand_ids
          : sectionComprtitorBrandTypeExists
          ? updatedComBrandList
          : rawData?.global_brands
          ? rawData?.global_brands
          : rawData?.brandlogicalgroup?.length
          ? rawData?.brandlogicalgroup
          : rawData?.brands,

        order_by: !rawData?.offset_flag ? updatedOrderBy : widgetData?.order_by,
        offset_flag: rawData?.offset_flag,
        filters: rawData?.filter ? rawData?.filter : null,
        x_axis: widgetData?.x_axis,
        // Break down data
        y_axes: widgetData?.y_axes,
        // y axis data
        y_series: widgetData?.y_series,
        widget_name: widgetData?.widget_name,
        chart: updatedWidgetChartSettings
          ? updatedWidgetChartSettings
          : widgetData?.chart,
        comp_brand_list:
          (!widgets_is_locked &&
            !(widgetData?.brand_ids || widgetData?.brand_groups) &&
            widgetData?.duplicate_for_brands) ||
          (!Section_is_locked &&
            !(sectionData?.brand_ids || sectionData?.brand_groups) &&
            widgetData?.duplicate_for_brands)
            ? null
            : widgetData?.comp_brand_list,
        data_source: widgetData?.data_source,
        widget_id: widgetData?.widget_id,
        engine: widgetData?.engine,
        ticket: widgetData?.data_source === "ticket" ? true : false,
        feedback: widgetData?.data_source === "feedback" ? true : false,
        nps: widgetData?.data_source === "nps" ? true : false,
        campaign: widgetData?.data_source === "campaign" ? true : false,
        exclude_words: finalExcludeWords,
        temp_exclude_words: temp_exclude_words,
        profile_filters:
          rawData?.profile_filters_flag && updatedFilter ? updatedFilter : null,
        graphConditionConfig: rawData?.graphConditionConfig,
        filter_by: rawData?.filter_by ? rawData?.filter_by : null,
        filter_by_data: rawData?.filter_by_data
          ? rawData?.filter_by_data
          : null,

        filter_dropdown: rawData?.filter_dropdown
          ? rawData?.filter_dropdown
          : null,
        filter_by_dropdown: rawData?.filter_by_dropdown
          ? rawData?.filter_by_dropdown
          : null,
        filter_by_dropdown_data: rawData?.filter_by_dropdown_data
          ? rawData?.filter_by_dropdown_data
          : null,

        selected_account_list: templateData?.selected_account_list?.length
          ? templateData?.selected_account_list
          : null,
        public_engagement_only: public_engagement_only ? true : false,
        multilevel_breakdown: widgetData?.multilevel_breakdown
          ? widgetData?.multilevel_breakdown
          : null,
        deep_dive_on: widgetData?.deep_dive_on,
        persist_graphdata: widgetData?.persist_graphdata,
      };
    } else {
      graphObject = {
        authParams: rawData?.authParams,
        firstAttr: widgetData?.primary,
        secondAttr: widgetData?.secondary,
        filterObj: rawData?.filter ? rawData?.filter : null,
        splitObj: widgetData?.splits,
        brands: widgets_is_locked
          ? widgetBrands?.columns
            ? widgetBrands?.columns
            : Section_is_locked
            ? sectionBrands?.columns
              ? sectionBrands?.columns
              : rawData?.global_brands
              ? rawData?.global_brands
              : rawData?.brandlogicalgroup?.length
              ? rawData?.brandlogicalgroup
              : rawData?.brands
            : rawData?.global_brands
            ? rawData?.global_brands
            : rawData?.brandlogicalgroup?.length
            ? rawData?.brandlogicalgroup
            : rawData?.brands
          : Section_is_locked
          ? sectionBrands?.columns
            ? sectionBrands?.columns
            : rawData?.global_brands
            ? rawData?.global_brands
            : rawData?.brandlogicalgroup?.length
            ? rawData?.brandlogicalgroup
            : rawData?.brands
          : rawData?.global_brands
          ? rawData?.global_brands
          : rawData?.brandlogicalgroup?.length
          ? rawData?.brandlogicalgroup
          : rawData?.brands,
        base: widgetData?.base,
        duration: widgets_is_locked
          ? widgetFilterDate?.from
            ? widgetFilterDate
            : Section_is_locked
            ? sectionDateFilter?.from
              ? sectionDateFilter
              : rawData?.duration
              ? rawData?.duration
              : defaultDuration
            : rawData?.duration
            ? rawData?.duration
            : defaultDuration
          : Section_is_locked
          ? sectionDateFilter?.from
            ? sectionDateFilter
            : rawData?.duration
            ? rawData?.duration
            : defaultDuration
          : rawData?.duration?.from
          ? rawData?.duration
          : defaultDuration,
        widget_id: widgetData?.widget_id,
        percent: widgetData?.percent,
        exclude_words: finalExcludeWords,
        temp_exclude_words: temp_exclude_words,
        graph_type: widgetData?.graph_type,
        profile_filters:
          rawData?.profile_filters_flag && updatedFilter ? updatedFilter : null,
        graphConditionConfig: rawData?.graphConditionConfig,
        filter_by: rawData?.filter_by ? rawData?.filter_by : null,
        filter_by_data: rawData?.filter_by_data
          ? rawData?.filter_by_data
          : null,

        filter_dropdown: rawData?.filter_dropdown
          ? rawData?.filter_dropdown
          : null,
        filter_by_dropdown: rawData?.filter_by_dropdown
          ? rawData?.filter_by_dropdown
          : null,
        filter_by_dropdown_data: rawData?.filter_by_dropdown_data
          ? rawData?.filter_by_dropdown_data
          : null,
        selected_account_list: templateData?.selected_account_list?.length
          ? templateData?.selected_account_list
          : null,
        public_engagement_only: public_engagement_only ? true : false,
      };
    }

    let global_date = {
      from: graphObject?.start_date,
      to: graphObject?.end_date,
    };
    let filter_date = [];
    // because we already passing start_date or end_date of widget in graphObject Based on locking filter so don't need to pass
    // graphObject?.filters?.filter?.((d) => {
    //   if (d.attribute === "CreatedDate") {
    //     filter_date = [...filter_date, d?.columns];
    //   }
    // });
    let combinedDate = getCombinedDate(global_date, filter_date);

    let pageDataSource = rawData?.graphConditionConfig?.[`default_attrs`]?.page
      ?.map((d) => d?.attribute)
      ?.includes(widgetData?.y_series?.[0]?.attribute)
      ? "page"
      : null;

    // View Case To make date part null for some base widgets
    if (
      graphObject?.graphConditionConfig?.[
        `standared_date_aggregation`
      ]?.includes(graphObject?.widget_id)
    ) {
      graphObject.x_axis.date_part = null;
    }

    let getInterval = getTimeIntervalDate(
      combinedDate?.end_date,
      combinedDate?.start_date,
      pageDataSource ? pageDataSource : graphObject?.data_source,
      graphObject?.x_axis?.attribute
    );

    // update chart settings
    if (rawData?.planned_value >= 0) {
      graphObject.chart.chart_settings.planned_val = rawData?.planned_value;
    }

    if (
      (graphObject?.chart?.chart_type === "grid" &&
        graphObject?.data_source == "ticket" &&
        rawData?.graphConditionConfig &&
        rawData?.graphConditionConfig?.[`date-attributes`]?.includes(
          graphObject?.x_axis?.attribute
        )) ||
      ((graphObject?.x_axis?.date_part === null ||
        graphObject?.x_axis?.date_part === "D") &&
        rawData?.graphConditionConfig?.[`date_agg-chart_type`]?.includes(
          graphObject?.chart?.chart_type
        ) &&
        rawData?.graphConditionConfig &&
        rawData?.graphConditionConfig?.[`date-attributes`]?.includes(
          graphObject?.x_axis?.attribute
        ))
    ) {
      graphObject.x_axis.date_aggregation = getInterval?.defaultVal;
    }
    if (
      (rawData?.graphConditionConfig &&
        graphObject?.chart?.chart_type === "pivot-grid" &&
        graphObject?.data_source === "ticket") ||
      rawData?.graphConditionConfig?.[`date_agg-chart_type`]?.includes(
        graphObject?.chart?.chart_type
      )
    ) {
      if (graphObject?.y_axes && graphObject?.y_axes?.length) {
        graphObject.y_axes = graphObject?.y_axes?.map((y_axis) => {
          if (
            rawData?.graphConditionConfig?.[`date-attributes`]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
          ) {
            y_axis.date_aggregation = getInterval?.defaultVal;
          }
          return y_axis;
        });
      }
    }

    graphObject.isBrandModified =
      rawData?.global_brands ||
      (widgets_is_locked &&
        (widgetBrands?.columns
          ? widgetBrands?.columns?.length
          : widgetBrands?.length)) ||
      (Section_is_locked &&
        (sectionBrands?.columns
          ? sectionBrands?.columns?.length
          : sectionBrands?.length)) ||
      widgetData?.duplicate_for_brands
        ? true
        : false;
    if (
      graphObject?.chart?.chart_type === "wordcloud" &&
      widgetData?.duplicate_for_brands
    ) {
      let indexOfCompWords = widgetData?.comp_exclude_words?.findIndex(
        (el) => el?.[graphObject?.brands?.[0]?.brand_id]
      );
      let parmanentExcluededWords = widgetData?.comp_exclude_words?.[
        indexOfCompWords
      ]?.[graphObject?.brands?.[0]?.brand_id]
        ? widgetData?.comp_exclude_words?.[indexOfCompWords]?.[
            graphObject?.brands?.[0]?.brand_id
          ]
        : [];

      graphObject.exclude_words = finalExcludeWords?.length
        ? [...finalExcludeWords, ...parmanentExcluededWords]
        : parmanentExcluededWords;
    }
  } else if (rawData?.type === "share_dashboard") {
    let Section_is_locked = rawData?.shareTemplateData?.sections
      ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
          ?.is_locked
      : null;
    let widgets_is_locked = rawData?.shareTemplateData?.sections
      ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
          ?.widgets?.[rawData?.widget_index]?.is_locked
      : rawData?.shareTemplateData?.section &&
        rawData?.shareTemplateData?.section?.[0]?.widgets?.[
          rawData?.widget_index
        ]?.is_locked;
    let defaultDuration = getDefaultDuration();
    let widgetData = rawData?.data ? rawData?.data : rawData?.widget;
    let sectionBrands = getBrands(
      rawData?.shareBrands?.brand_groups,
      rawData?.shareTemplateData?.sections?.[rawData?.section_index]?.brand_ids,
      rawData?.shareBrands?.brand_list,
      rawData?.shareTemplateData?.sections?.[rawData?.section_index]
        ?.brand_groups
    );
    let sectionComprtitorBrandType =
      rawData?.shareTemplateData?.sections?.[rawData?.section_index]
        ?.comp_brand_type === false ||
      rawData?.shareTemplateData?.sections?.[rawData?.section_index]
        ?.comp_brand_type === true
        ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
            ?.comp_brand_type
        : null;
    let sectionComprtitorBrandTypeExists =
      sectionComprtitorBrandType === false ||
      sectionComprtitorBrandType === true;

    let widgetBrands = getBrands(
      rawData?.shareBrands?.brand_groups,
      widgetData?.brand_ids,
      rawData?.shareBrands?.brand_list,
      widgetData?.brand_groups
    );
    let defaultBrands = rawData?.shareBrands ? rawData?.shareBrands : null;
    let updatedOrderBy;
    if (widgetData?.order_by) {
      updatedOrderBy = {
        ...widgetData?.order_by,
        offset: 0,
      };
    }

    // calculating brand in case of section comprtiotion brand type exists
    let updatedComBrandList = [];
    if (
      !(Section_is_locked && sectionBrands?.columns) &&
      sectionComprtitorBrandTypeExists
    ) {
      let comBrand = defaultBrands?.brands?.columns?.[0]?.competitor
        ? defaultBrands?.brands?.columns?.[0]
        : defaultBrands?.brands?.[0]?.competitor
        ? defaultBrands?.brands?.[0]
        : defaultBrands?.brands?.competitor
        ? defaultBrands?.brands
        : null;
      let comBrandExists = comBrand?.competitor
        ? true
        : defaultBrands
        ? defaultBrands?.selected_brand_ids?.length &&
          defaultBrands?.selected_comp_brand_ids?.length > 0
        : null;
      if (comBrandExists) {
        if (comBrand) {
          if (sectionComprtitorBrandType === false) {
            updatedComBrandList.push({
              brand_id: comBrand?.name,
              brand_name: comBrand?.brand_name,
              brand_friendly_name: comBrand?.brand_friendly_name,
            });
          } else {
            comBrand?.competitorList?.forEach((competitorBrand) => {
              updatedComBrandList.push(competitorBrand);
            });
          }
        } else {
          if (sectionComprtitorBrandType === false) {
            let parentB = defaultBrands?.selected_brand_ids?.[0];
            updatedComBrandList.push({
              brand_id: parentB?.brand_id,
              brand_name: parentB?.brand_name,
              brand_friendly_name: parentB?.brand_friendly_name,
            });
          } else {
            defaultBrands?.selected_comp_brand_ids?.forEach(
              (competitorBrand) => {
                updatedComBrandList.push(competitorBrand);
              }
            );
          }
        }
      } else {
        sectionComprtitorBrandTypeExists = false;
      }
    }
    let widgetSingleBrandFilter = widgetData?.widgetSingleBrandFilter?.brand_id
      ? [
          {
            brand_id: widgetData?.widgetSingleBrandFilter?.brand_id,
            brand_name: widgetData?.widgetSingleBrandFilter?.brand_name,
            brand_friendly_name:
              widgetData?.widgetSingleBrandFilter?.brand_friendly_name,
          },
        ]
      : null;
    // here calculating the competition_aggregation for the widget
    let competition_aggregation =
      rawData?.shareTemplateData?.competition_aggregation;

    let updatedWidgetChartSettings = null;
    if (
      competition_aggregation &&
      !sectionComprtitorBrandTypeExists &&
      !(
        widgetData?.chart?.chart_settings?.benchmark_line &&
        widgetData?.chart?.chart_settings?.group_line_agg
      ) &&
      widgetData?.chart?.chart_settings
    ) {
      updatedWidgetChartSettings = widgetData?.chart?.chart_settings
        ? deepCopy(widgetData?.chart)
        : new Object(widgetData?.chart);
      updatedWidgetChartSettings.chart_settings.benchmark_line = true;
      updatedWidgetChartSettings.chart_settings.benchmark_static_value = null;
      updatedWidgetChartSettings.chart_settings.group_line_agg =
        competition_aggregation;
    }
    // here calculating the public_engagement_only for the widget
    let public_engagement_only =
      rawData?.shareTemplateData?.template_type === "competition"
        ? rawData?.shareTemplateData?.public_engagement_only || false
        : false;

    if (
      rawData?.graphConditionConfig?.[`data-source`]?.includes(
        widgetData?.data_source
      ) ||
      widgetData?.x_axis ||
      widgetData?.y_series ||
      widgetData?.chart
    ) {
      graphObject = {
        start_date: widgetData?.is_locked
          ? widgetData?.start_date
            ? widgetData?.start_date
            : Section_is_locked
            ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.start_date
              ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                  ?.start_date
              : rawData?.duration?.from
              ? rawData?.duration?.from
              : defaultDuration?.from
            : rawData?.duration?.from
            ? rawData?.duration?.from
            : defaultDuration?.from
          : Section_is_locked
          ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
              ?.start_date
            ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.start_date
            : rawData?.duration?.from
            ? rawData?.duration?.from
            : defaultDuration?.from
          : rawData?.duration?.from
          ? rawData?.duration?.from
          : defaultDuration?.from,
        end_date: widgetData?.is_locked
          ? widgetData?.end_date
            ? widgetData?.end_date
            : Section_is_locked
            ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.end_date
              ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                  ?.end_date
              : rawData?.duration?.to
              ? rawData?.duration?.to
              : defaultDuration?.to
            : rawData?.duration?.to
            ? rawData?.duration?.to
            : defaultDuration?.to
          : Section_is_locked
          ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
              ?.end_date
            ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.end_date
            : rawData?.duration?.to
            ? rawData?.duration?.to
            : defaultDuration?.to
          : rawData?.duration?.to
          ? rawData?.duration?.to
          : defaultDuration?.to,
        brand_list: widgetSingleBrandFilter
          ? widgetSingleBrandFilter
          : widgets_is_locked
          ? widgetData?.brand_ids || widgetData?.brand_groups
            ? widgetBrands?.columns
            : Section_is_locked
            ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.brand_ids ||
              rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.brand_groups
              ? sectionBrands?.columns
              : widgetData?.duplicate_for_brands
              ? widgetData?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : defaultBrands
            : widgetData?.duplicate_for_brands
            ? widgetData?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : defaultBrands
          : Section_is_locked
          ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
              ?.brand_ids ||
            rawData?.shareTemplateData?.sections?.[rawData?.section_index]
              ?.brand_groups
            ? sectionBrands?.columns
            : widgetData?.duplicate_for_brands
            ? widgetData?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : defaultBrands
          : widgetData?.duplicate_for_brands
          ? widgetData?.com_brand_ids
          : sectionComprtitorBrandTypeExists
          ? updatedComBrandList
          : defaultBrands,

        order_by: !rawData?.offset_flag ? updatedOrderBy : widgetData?.order_by,
        offset_flag: rawData?.offset_flag,
        filters: rawData?.filter ? rawData?.filter : null,
        x_axis: widgetData?.x_axis,
        // Break down data
        y_axes: widgetData?.y_axes,
        // y axis data
        y_series: widgetData?.y_series,
        widget_name: widgetData?.widget_name,
        chart: updatedWidgetChartSettings
          ? updatedWidgetChartSettings
          : widgetData?.chart,
        comp_brand_list:
          (!widgets_is_locked &&
            !(widgetData?.brand_ids || widgetData?.brand_groups) &&
            widgetData?.duplicate_for_brands) ||
          (!Section_is_locked &&
            !(
              rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.brand_ids ||
              rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.brand_groups
            ) &&
            widgetData?.duplicate_for_brands)
            ? null
            : widgetData?.comp_brand_list,
        data_source: widgetData?.data_source,
        widget_id: widgetData?.widget_id,
        engine: widgetData?.engine,
        ticket: widgetData?.data_source === "ticket" ? true : false,
        campaign: widgetData?.data_source === "campaign" ? true : false,
        feedback: widgetData?.data_source === "feedback" ? true : false,
        nps: widgetData?.data_source === "nps" ? true : false,
        exclude_words: widgetData?.exclude_words
          ? [...widgetData?.exclude_words]
          : null,
        profile_filters:
          rawData?.profile_filters_flag && rawData?.profile_filters
            ? rawData?.profile_filters
            : null,
        graphConditionConfig: rawData?.graphConditionConfig,
        filter_by: rawData?.filter_by ? rawData?.filter_by : null,
        filter_by_data: rawData?.filter_by_data
          ? rawData?.filter_by_data
          : null,
        complex_filters: rawData?.shareTemplateData?.complex_filters
          ? rawData?.shareTemplateData?.complex_filters
          : null,

        filter_dropdown: rawData?.filter_dropdown
          ? rawData?.filter_dropdown
          : null,
        filter_by_dropdown: rawData?.filter_by_dropdown
          ? rawData?.filter_by_dropdown
          : null,
        filter_by_dropdown_data: rawData?.filter_by_dropdown_data
          ? rawData?.filter_by_dropdown_data
          : null,

        public_engagement_only: public_engagement_only ? true : false,
        multilevel_breakdown: widgetData?.multilevel_breakdown
          ? widgetData?.multilevel_breakdown
          : null,
        deep_dive_on: widgetData?.deep_dive_on,
        persist_graphdata: widgetData?.persist_graphdata,
      };
    } else {
      graphObject = {
        primary_attribute: widgetData?.primary,
        secondary_attribute: widgetData?.secondary,
        filters: rawData?.filter ? rawData?.filter : null,
        splits: widgetData?.splits,
        graph_type: widgetData?.graph_type,
        brand_list: widgets_is_locked
          ? widgetData?.brand_ids || widgetData?.brand_groups
            ? widgetBrands?.columns
            : Section_is_locked
            ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.brand_ids ||
              rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.brand_groups
              ? sectionBrands?.columns
              : defaultBrands
            : defaultBrands
          : Section_is_locked
          ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
              ?.brand_ids ||
            rawData?.shareTemplateData?.sections?.[rawData?.section_index]
              ?.brand_groups
            ? sectionBrands?.columns
            : defaultBrands
          : defaultBrands,

        start_date: widgetData?.is_locked
          ? widgetData?.start_date
            ? widgetData?.start_date
            : Section_is_locked
            ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.start_date
              ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                  ?.start_date
              : rawData?.duration?.from
              ? rawData?.duration?.from
              : defaultDuration?.from
            : rawData?.duration?.from
            ? rawData?.duration?.from
            : defaultDuration?.from
          : Section_is_locked
          ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
              ?.start_date
            ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.start_date
            : rawData?.duration?.from
            ? rawData?.duration?.from
            : defaultDuration?.from
          : rawData?.duration?.from
          ? rawData?.duration?.from
          : defaultDuration?.from,
        end_date: widgetData?.is_locked
          ? widgetData?.end_date
            ? widgetData?.end_date
            : Section_is_locked
            ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.end_date
              ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                  ?.end_date
              : rawData?.duration?.to
              ? rawData?.duration?.to
              : defaultDuration?.to
            : rawData?.duration?.to
            ? rawData?.duration?.to
            : defaultDuration?.to
          : Section_is_locked
          ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
              ?.end_date
            ? rawData?.shareTemplateData?.sections?.[rawData?.section_index]
                ?.end_date
            : rawData?.duration?.to
            ? rawData?.duration?.to
            : defaultDuration?.to
          : rawData?.duration?.to
          ? rawData?.duration?.to
          : defaultDuration?.to,

        base: widgetData?.base,
        widget_id: rawData?.data?.widget_id,
        percent: rawData?.data?.percent,
        exclude_words: widgetData?.exclude_words
          ? [...widgetData?.exclude_words]
          : null,
        profile_filters:
          rawData?.profile_filters_flag && rawData?.profile_filters
            ? rawData?.profile_filters
            : null,
        graphConditionConfig: rawData?.graphConditionConfig,
        filter_by: rawData?.filter_by ? rawData?.filter_by : null,
        filter_by_data: rawData?.filter_by_data
          ? rawData?.filter_by_data
          : null,
        complex_filters: rawData?.shareTemplateData?.complex_filters
          ? rawData?.shareTemplateData?.complex_filters
          : null,

        filter_dropdown: rawData?.filter_dropdown
          ? rawData?.filter_dropdown
          : null,
        filter_by_dropdown: rawData?.filter_by_dropdown
          ? rawData?.filter_by_dropdown
          : null,
        filter_by_dropdown_data: rawData?.filter_by_dropdown_data
          ? rawData?.filter_by_dropdown_data
          : null,
        public_engagement_only: public_engagement_only ? true : false,
      };
    }
    let global_date = {
      from: graphObject?.start_date,
      to: graphObject?.end_date,
    };
    let filter_date = [];
    // because we already passing start_date or end_date of widget in graphObject Based on locking filter so don't need to pass
    // graphObject?.filters?.filter((d) => {
    //   if (d.attribute === "CreatedDate") {
    //     filter_date = [...filter_date, d?.columns];
    //   }
    // });
    let combinedDate = getCombinedDate(global_date, filter_date);

    let pageDataSource = rawData?.graphConditionConfig?.[`default_attrs`]?.page
      ?.map((d) => d?.attribute)
      ?.includes(widgetData?.y_series?.[0]?.attribute)
      ? "page"
      : null;

    // Share Case To make date part null for some base widgets
    if (
      graphObject?.graphConditionConfig?.[
        `standared_date_aggregation`
      ]?.includes(graphObject?.widget_id)
    ) {
      graphObject.x_axis.date_part = null;
    }

    let getInterval = getTimeIntervalDate(
      combinedDate?.end_date,
      combinedDate?.start_date,
      pageDataSource ? pageDataSource : graphObject?.data_source,
      graphObject?.x_axis?.attribute
    );
    if (
      (graphObject?.x_axis?.date_part === null ||
        graphObject?.x_axis?.date_part === "D") &&
      rawData?.graphConditionConfig?.[`date_agg-chart_type`]?.includes(
        graphObject?.chart?.chart_type
      ) &&
      rawData?.graphConditionConfig &&
      rawData?.graphConditionConfig?.[`date-attributes`]?.includes(
        graphObject?.x_axis?.attribute
      )
    ) {
      graphObject.x_axis.date_aggregation = getInterval?.defaultVal;
    }
    if (
      (rawData?.graphConditionConfig &&
        graphObject?.chart?.chart_type === "pivot-grid" &&
        graphObject?.data_source === "ticket") ||
      rawData?.graphConditionConfig?.[`date_agg-chart_type`]?.includes(
        graphObject?.chart?.chart_type
      )
    ) {
      if (graphObject?.y_axes && graphObject?.y_axes?.length) {
        graphObject.y_axes = graphObject?.y_axes?.map((y_axis) => {
          if (
            rawData?.graphConditionConfig?.[`date-attributes`]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part == "D")
          ) {
            y_axis.date_aggregation = getInterval?.defaultVal;
          }
          return y_axis;
        });
      }
    }
    graphObject.isBrandModified =
      (widgets_is_locked && widgetBrands) ||
      (Section_is_locked && sectionBrands) ||
      widgetData?.duplicate_for_brands
        ? true
        : false;

    if (
      graphObject?.chart?.chart_type === "wordcloud" &&
      widgetData?.duplicate_for_brands
    ) {
      let indexOfCompWords = widgetData?.comp_exclude_words?.findIndex(
        (el) => el?.[graphObject?.brand_list?.[0]?.brand_id]
      );
      let parmanentExcluededWords = widgetData?.comp_exclude_words?.[
        indexOfCompWords
      ]?.[graphObject?.brand_list?.[0]?.brand_id]
        ? widgetData?.comp_exclude_words?.[indexOfCompWords]?.[
            graphObject?.brand_list?.[0]?.brand_id
          ]
        : [];

      graphObject.exclude_words = widgetData?.exclude_words?.length
        ? [...widgetData?.exclude_words, ...parmanentExcluededWords]
        : parmanentExcluededWords;
    }
  } else {
    let quickFilterAttribute =
      rawData?.type === "template"
        ? rawData?.sectionObj?.quick_filter_value
          ? ["AccountID", "SettingID"]?.includes(
              rawData?.sectionObj?.quick_filter_value?.attribute
            )
            ? "AccountID"
            : rawData?.sectionObj?.quick_filter_value?.attribute
          : null
        : ["AccountID", "SettingID"]?.includes(
            rawData?.panes?.[rawData?.paneIndex]?.quick_filter
          )
        ? "AccountID"
        : rawData?.panes?.[rawData?.paneIndex]?.quick_filter
        ? rawData?.panes?.[rawData?.paneIndex]?.quick_filter
        : null;

    let Section_is_locked =
      rawData?.type === "template"
        ? rawData?.sectionObj?.is_locked
          ? rawData?.sectionObj?.is_locked
          : null
        : rawData?.panes?.[rawData?.paneIndex]?.sections
        ? rawData?.panes?.[rawData?.paneIndex]?.sections?.[
            rawData?.section_index
          ]?.is_locked
        : null;
    Section_is_locked = Section_is_locked ? Section_is_locked : false;
    let widgets_is_locked =
      rawData?.type === "template"
        ? rawData?.widgetObj?.is_locked
          ? rawData?.widgetObj?.is_locked
          : null
        : rawData?.panes?.[rawData?.paneIndex]?.sections
        ? rawData?.panes?.[rawData?.paneIndex]?.sections?.[
            rawData?.section_index
          ]?.widgets?.[rawData?.widget_index]?.is_locked
        : rawData?.panes?.[rawData?.paneIndex]?.section &&
          rawData?.panes?.[rawData?.paneIndex]?.section?.[0]?.widgets?.[
            rawData?.widget_index
          ]?.is_locked;
    widgets_is_locked = widgets_is_locked ? widgets_is_locked : false;
    let defaultDuration = getDefaultDuration();
    let sectionDateFilter =
      rawData?.type === "template"
        ? rawData?.sectionObj?.duration?.from
          ? rawData?.sectionObj?.duration
          : null
        : rawData?.panes?.[rawData?.paneIndex]?.sections
        ? {
            from: rawData?.panes?.[rawData?.paneIndex]?.sections?.[
              rawData?.section_index
            ]?.start_date
              ? rawData?.panes?.[rawData?.paneIndex]?.sections?.[
                  rawData?.section_index
                ]?.start_date
              : null,
            to: rawData?.panes?.[rawData?.paneIndex]?.sections?.[
              rawData?.section_index
            ]?.end_date
              ? rawData?.panes?.[rawData?.paneIndex]?.sections?.[
                  rawData?.section_index
                ]?.end_date
              : null,
          }
        : rawData?.panes?.[rawData?.paneIndex]?.section
        ? {
            from: rawData?.panes?.[rawData?.paneIndex]?.section?.[0]?.start_date
              ? rawData?.panes?.[rawData?.paneIndex]?.section?.[0]?.start_date
              : null,
            to: rawData?.panes?.[rawData?.paneIndex]?.section?.[0]?.end_date
              ? rawData?.panes?.[rawData?.paneIndex]?.section?.[0]?.end_date
              : null,
          }
        : null;
    let widgetFilterDate =
      rawData?.type === "template"
        ? rawData?.widgetObj
          ? rawData?.widgetObj?.duration?.from
            ? rawData?.widgetObj?.duration
            : []
          : []
        : rawData?.panes?.[rawData?.paneIndex]?.sections
        ? {
            from: rawData?.panes?.[rawData?.paneIndex]?.sections?.[
              rawData?.section_index
            ]?.widgets?.[rawData?.widget_index]?.start_date
              ? rawData?.panes?.[rawData?.paneIndex]?.sections?.[
                  rawData?.section_index
                ]?.widgets?.[rawData?.widget_index]?.start_date
              : null,
            to: rawData?.panes?.[rawData?.paneIndex]?.sections?.[
              rawData?.section_index
            ]?.widgets?.[rawData?.widget_index]?.end_date
              ? rawData?.panes?.[rawData?.paneIndex]?.sections?.[
                  rawData?.section_index
                ]?.widgets?.[rawData?.widget_index]?.end_date
              : null,
          }
        : rawData?.panes?.[rawData?.paneIndex]?.section && {
            from: rawData?.panes?.[rawData?.paneIndex]?.section?.[0]?.widgets?.[
              rawData?.widget_index
            ]?.start_date
              ? rawData?.panes?.[rawData?.paneIndex]?.section?.[0]?.widgets?.[
                  rawData?.widget_index
                ]?.start_date
              : null,
            to: rawData?.panes?.[rawData?.paneIndex]?.section?.[0]?.widgets?.[
              rawData?.widget_index
            ]?.end_date
              ? rawData?.panes?.[rawData?.paneIndex]?.section?.[0]?.widgets?.[
                  rawData?.widget_index
                ]?.end_date
              : null,
          };

    let widgetData = rawData?.data ? rawData?.data : rawData?.widget;
    let paneObj = { temporary_words: rawData?.temporary_words };
    paneObj.template_id = rawData?.panes?.[rawData?.paneIndex]?.template_id;
    paneObj.section_id = rawData?.panes?.[rawData?.paneIndex]?.sections
      ? rawData?.panes?.[rawData?.paneIndex]?.sections?.[rawData?.section_index]
          ?.section_id
      : rawData?.panes?.[rawData?.paneIndex]?.section?.[0]?.section_id;
    paneObj.widget_id = widgetData?.widget_id
      ? widgetData?.widget_id
      : rawData?.panes?.[rawData?.paneIndex]?.sections
      ? rawData?.panes?.[rawData?.paneIndex]?.sections?.[rawData?.section_index]
          ?.widgets?.[rawData?.widget_index]?.widget_id
      : rawData?.panes?.[rawData?.paneIndex]?.section?.[0]?.widgets?.[
          rawData?.widget_index
        ]?.widget_id;
    //for exploded wordcloud by comptitor brands
    if (widgetData.duplicate_for_brands) {
      paneObj.widget_id = getTemporaryWordWidgetId(widgetData);
    }
    let temp_exclude_words = getTemporaryWords(paneObj);

    // if (!widgetData.temp_exclude_words) {
    //   console.log("&&&", temp_exclude_words);
    //   widgetData.temp_exclude_words = temp_exclude_words;
    // }

    let sectionBrands =
      rawData?.sectionObj?.brand_ids || rawData?.sectionObj?.brand_groups
        ? getBrands(
            rawData?.brandlogicalgroup?.length > 0
              ? rawData?.brandlogicalgroup
              : rawData?.brands,
            rawData?.sectionObj?.brand_ids
              ? rawData?.sectionObj?.brand_ids
              : null,
            rawData?.sectionObj?.singleBrands,
            rawData?.sectionObj?.brand_groups
              ? rawData?.sectionObj?.brand_groups
              : null
          )
        : rawData?.sectionObj?.brandFilters
        ? rawData?.sectionObj?.brandFilters
        : getBrands(
            rawData?.brandlogicalgroup?.length > 0
              ? rawData?.brandlogicalgroup
              : rawData?.brands,
            rawData?.panes?.[rawData?.paneIndex]?.sections?.[
              rawData?.section_index
            ]?.brand_ids,
            rawData?.brands,
            rawData?.panes?.[rawData?.paneIndex]?.sections?.[
              rawData?.section_index
            ]?.brand_groups
          );
    let sectionComprtitorBrandType = rawData?.sectionObj
      ? rawData?.sectionObj?.comp_brand_type === false ||
        rawData?.sectionObj?.comp_brand_type === true
        ? rawData?.sectionObj?.comp_brand_type
        : null
      : rawData?.panes?.[rawData?.paneIndex]?.sections?.[rawData?.section_index]
          ?.comp_brand_type === false ||
        rawData?.panes?.[rawData?.paneIndex]?.sections?.[rawData?.section_index]
          ?.comp_brand_type === true
      ? rawData?.panes?.[rawData?.paneIndex]?.sections?.[rawData?.section_index]
          ?.comp_brand_type
      : null;
    let sectionComprtitorBrandTypeExists =
      sectionComprtitorBrandType === false ||
      sectionComprtitorBrandType === true;
    let widgetBrands = widgetData?.brandFilters?.columns
      ? widgetData?.brandFilters
      : getBrands(
          rawData?.brandlogicalgroup?.length > 0
            ? rawData?.brandlogicalgroup
            : rawData?.brands,
          widgetData?.brand_ids,
          rawData?.brands,
          widgetData?.brand_groups
        );

    let finalExcludeWords =
      rawData?.exclude_words && !widgetData?.duplicate_for_brands
        ? widgetData?.exclude_words
          ? [...rawData?.exclude_words, ...widgetData?.exclude_words]
          : [...rawData?.exclude_words]
        : temp_exclude_words &&
          widgetData?.exclude_words &&
          !widgetData?.duplicate_for_brands
        ? [...temp_exclude_words, ...widgetData?.exclude_words]
        : !widgetData?.duplicate_for_brands && widgetData?.exclude_words
        ? [...widgetData?.exclude_words]
        : temp_exclude_words
        ? [...temp_exclude_words]
        : [];

    let updatedOrderBy;
    if (widgetData?.order_by) {
      updatedOrderBy = {
        ...widgetData?.order_by,
        offset: 0,
      };
    }

    // console.log("main rawData", rawData);

    let updatedFilter = getDiscardedFilters(rawData);
    // console.log("final step 1", updatedFilter, rawData);
    if (!updatedFilter && quickFilterAttribute !== "AccountID") {
      let obj;
      if (rawData?.profile_filters_list?.length > 0) {
        obj = {
          attribute: "SocialMediaProfiles",
          type: "varchar",
          columns: [
            {
              name: rawData?.profile_filters_list?.[0]?.id
                ? rawData?.profile_filters_list?.[0]?.id
                : null,
              type: "include",
              display_name: rawData?.profile_filters_list?.[0]?.name
                ? rawData?.profile_filters_list?.[0]?.name
                : null,
              profile_channel: rawData?.profile_filters_list?.[0]?.channel
                ? rawData?.profile_filters_list?.[0]?.channel
                : null,
              brand_id: rawData?.profile_filters_list?.[0]?.brand_id
                ? rawData?.profile_filters_list?.[0]?.brand_id
                : null,
            },
          ],
        };
      } else {
        obj = null;
      }
      updatedFilter = obj;
    }
    // console.log("final step ", rawData,rawData?.global_brands);

    // calculating brand in case of section comprtiotion brand type exists
    let updatedComBrandList = [];
    if (
      !(Section_is_locked && sectionBrands?.columns) &&
      sectionComprtitorBrandTypeExists
    ) {
      let comBrand = rawData?.global_brands?.columns?.[0]?.competitor
        ? rawData?.global_brands?.columns?.[0]
        : rawData?.global_brands?.[0]?.competitor
        ? rawData?.global_brands?.[0]
        : rawData?.global_brands?.competitor
        ? rawData?.global_brands
        : null;
      if (comBrand?.competitor) {
        if (sectionComprtitorBrandType === false) {
          updatedComBrandList.push({
            brand_id: comBrand?.name,
            brand_name: comBrand?.brand_name,
            brand_friendly_name: comBrand?.brand_friendly_name,
          });
        } else {
          comBrand?.competitorList?.forEach((competitorBrand) => {
            updatedComBrandList.push(competitorBrand);
          });
        }
      } else {
        sectionComprtitorBrandTypeExists = false;
      }
    }
    // this is used for brand filter selectedtion like date aggregation
    let widgetSingleBrandFilter = widgetData?.widgetSingleBrandFilter?.brand_id
      ? [
          {
            brand_id: widgetData?.widgetSingleBrandFilter?.brand_id,
            brand_name: widgetData?.widgetSingleBrandFilter?.brand_name,
            brand_friendly_name:
              widgetData?.widgetSingleBrandFilter?.brand_friendly_name,
          },
        ]
      : null;
    // here calculating the competition_aggregation for the widget
    let competition_aggregation =
      rawData?.type === "template"
        ? rawData?.competition_aggregation
        : rawData?.panes?.[rawData?.paneIndex]?.competition_aggregation;

    let updatedWidgetChartSettings = null;
    if (
      competition_aggregation &&
      !sectionComprtitorBrandTypeExists &&
      !(
        widgetData?.chart?.chart_settings?.benchmark_line &&
        widgetData?.chart?.chart_settings?.group_line_agg
      ) &&
      widgetData?.chart?.chart_settings
    ) {
      updatedWidgetChartSettings = widgetData?.chart?.chart_settings
        ? deepCopy(widgetData?.chart)
        : new Object(widgetData?.chart);
      updatedWidgetChartSettings.chart_settings.benchmark_line = true;
      updatedWidgetChartSettings.chart_settings.benchmark_static_value = null;
      updatedWidgetChartSettings.chart_settings.group_line_agg =
        competition_aggregation;
    }
    // here calculating the public_engagement_only for the widget
    let public_engagement_only =
      rawData?.type === "template"
        ? rawData?.template_type === "competition"
          ? rawData?.public_engagement_only || false
          : false
        : rawData?.isScheduleReportOpen // for now static true sending for schedule report
        ? rawData?.panes?.[rawData?.paneIndex]?.template_type === "competition"
          ? true
          : false
        : rawData?.panes?.[rawData?.paneIndex]?.template_type === "competition"
        ? rawData?.panes?.[rawData?.paneIndex]?.public_engagement_only || false
        : false;

    if (
      rawData?.graphConditionConfig?.[`data-source`]?.includes(
        widgetData?.data_source
      ) ||
      widgetData?.x_axis ||
      widgetData?.y_series ||
      widgetData?.chart
    ) {
      graphObject = {
        start_date: widgetData?.is_locked
          ? widgetData?.start_date
            ? widgetData?.start_date
            : widgetFilterDate?.from
            ? widgetFilterDate?.from
            : Section_is_locked
            ? sectionDateFilter?.from
              ? sectionDateFilter?.from
              : rawData?.duration?.from
              ? rawData?.duration?.from
              : defaultDuration?.from
            : rawData?.duration?.from
            ? rawData?.duration?.from
            : defaultDuration?.from
          : Section_is_locked
          ? sectionDateFilter?.from
            ? sectionDateFilter?.from
            : rawData?.duration?.from
            ? rawData?.duration?.from
            : defaultDuration?.from
          : rawData?.duration?.from
          ? rawData?.duration?.from
          : defaultDuration?.from,
        end_date: widgetData?.is_locked
          ? widgetData?.end_date
            ? widgetData?.end_date
            : widgetFilterDate?.to
            ? widgetFilterDate?.to
            : Section_is_locked
            ? sectionDateFilter?.to
              ? sectionDateFilter?.to
              : rawData?.duration?.to
              ? rawData?.duration?.to
              : defaultDuration?.to
            : rawData?.duration?.to
            ? rawData?.duration?.to
            : defaultDuration?.to
          : Section_is_locked
          ? sectionDateFilter?.to
            ? sectionDateFilter?.to
            : rawData?.duration?.to
            ? rawData?.duration?.to
            : defaultDuration?.to
          : rawData?.duration?.to
          ? rawData?.duration?.to
          : defaultDuration?.to,
        brands: widgetSingleBrandFilter
          ? widgetSingleBrandFilter
          : widgets_is_locked
          ? widgetBrands?.columns
            ? widgetBrands?.columns
            : Section_is_locked
            ? sectionBrands?.columns
              ? sectionBrands?.columns
              : widgetData?.duplicate_for_brands
              ? widgetData?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : rawData?.global_brands
              ? rawData?.global_brands
              : rawData?.brandlogicalgroup?.length
              ? rawData?.brandlogicalgroup
              : rawData?.brands
            : widgetData?.duplicate_for_brands
            ? widgetData?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : rawData?.global_brands
            ? rawData?.global_brands
            : rawData?.brandlogicalgroup?.length
            ? rawData?.brandlogicalgroup
            : rawData?.brands
          : Section_is_locked
          ? sectionBrands?.columns
            ? sectionBrands?.columns
            : widgetData?.duplicate_for_brands
            ? widgetData?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : rawData?.global_brands
            ? rawData?.global_brands
            : rawData?.brandlogicalgroup?.length
            ? rawData?.brandlogicalgroup
            : rawData?.brands
          : widgetData?.duplicate_for_brands
          ? widgetData?.com_brand_ids
          : sectionComprtitorBrandTypeExists
          ? updatedComBrandList
          : rawData?.global_brands
          ? rawData?.global_brands
          : rawData?.brandlogicalgroup?.length
          ? rawData?.brandlogicalgroup
          : rawData?.brands,

        order_by: !rawData?.offset_flag ? updatedOrderBy : widgetData?.order_by,
        offset_flag: rawData?.offset_flag,
        filters: rawData?.filter ? rawData?.filter : null,
        x_axis: widgetData?.x_axis,
        // Break down data
        y_axes: widgetData?.y_axes,
        // y axis data
        y_series: widgetData?.y_series,
        widget_name: widgetData?.widget_name,
        chart: updatedWidgetChartSettings
          ? updatedWidgetChartSettings
          : widgetData?.chart,
        comp_brand_list:
          (!widgets_is_locked &&
            !(widgetData?.brand_ids || widgetData?.brand_groups) &&
            widgetData?.duplicate_for_brands) ||
          (!Section_is_locked &&
            !(
              rawData?.panes?.[rawData?.paneIndex]?.sections?.[
                rawData?.section_index
              ]?.brand_ids ||
              rawData?.panes?.[rawData?.paneIndex]?.sections?.[
                rawData?.section_index
              ]?.brand_groups
            ) &&
            widgetData?.duplicate_for_brands)
            ? null
            : widgetData?.comp_brand_list,
        data_source: widgetData?.data_source,
        widget_id: widgetData?.widget_id,
        engine: widgetData?.engine,
        ticket: widgetData?.data_source === "ticket" ? true : false,
        feedback: widgetData?.data_source === "feedback" ? true : false,
        nps: widgetData?.data_source === "nps" ? true : false,
        campaign: widgetData?.data_source === "campaign" ? true : false,
        exclude_words: finalExcludeWords,
        temp_exclude_words: temp_exclude_words,
        profile_filters:
          rawData?.profile_filters_flag && updatedFilter ? updatedFilter : null,
        graphConditionConfig: rawData?.graphConditionConfig,
        filter_by: rawData?.filter_by ? rawData?.filter_by : null,
        filter_by_data: rawData?.filter_by_data
          ? rawData?.filter_by_data
          : null,
        complex_filters: rawData?.panes?.[rawData?.paneIndex]?.complex_filters
          ? rawData?.panes?.[rawData?.paneIndex]?.complex_filters
          : null,

        filter_dropdown: rawData?.filter_dropdown
          ? rawData?.filter_dropdown
          : null,
        filter_by_dropdown: rawData?.filter_by_dropdown
          ? rawData?.filter_by_dropdown
          : null,
        filter_by_dropdown_data: rawData?.filter_by_dropdown_data
          ? rawData?.filter_by_dropdown_data
          : null,
        selected_account_list: rawData?.panes?.[rawData?.paneIndex]
          ?.selected_account_list?.length
          ? rawData?.panes?.[rawData?.paneIndex]?.selected_account_list
          : null,
        public_engagement_only: public_engagement_only ? true : false,
        multilevel_breakdown: widgetData?.multilevel_breakdown
          ? widgetData?.multilevel_breakdown
          : null,
        deep_dive_on: widgetData?.deep_dive_on,
        persist_graphdata: widgetData?.persist_graphdata,
      };
    } else {
      graphObject = {
        authParams: rawData?.authParams,
        firstAttr: widgetData?.primary,
        secondAttr: widgetData?.secondary,
        filterObj: rawData?.filter ? rawData?.filter : null,
        splitObj: widgetData?.splits,
        brands: widgets_is_locked
          ? widgetBrands?.columns
            ? widgetBrands?.columns
            : Section_is_locked
            ? sectionBrands?.columns
              ? sectionBrands?.columns
              : rawData?.global_brands
              ? rawData?.global_brands
              : rawData?.brandlogicalgroup?.length
              ? rawData?.brandlogicalgroup
              : rawData?.brands
            : rawData?.global_brands
            ? rawData?.global_brands
            : rawData?.brandlogicalgroup?.length
            ? rawData?.brandlogicalgroup
            : rawData?.brands
          : Section_is_locked
          ? sectionBrands?.columns
            ? sectionBrands?.columns
            : rawData?.global_brands
            ? rawData?.global_brands
            : rawData?.brandlogicalgroup?.length
            ? rawData?.brandlogicalgroup
            : rawData?.brands
          : rawData?.global_brands
          ? rawData?.global_brands
          : rawData?.brandlogicalgroup?.length
          ? rawData?.brandlogicalgroup
          : rawData?.brands,
        base: widgetData?.base,
        duration: widgets_is_locked
          ? widgetFilterDate?.from
            ? widgetFilterDate
            : Section_is_locked
            ? sectionDateFilter?.from
              ? sectionDateFilter
              : rawData?.duration
              ? rawData?.duration
              : defaultDuration
            : rawData?.duration
            ? rawData?.duration
            : defaultDuration
          : Section_is_locked
          ? sectionDateFilter?.from
            ? sectionDateFilter
            : rawData?.duration
            ? rawData?.duration
            : defaultDuration
          : rawData?.duration?.from
          ? rawData?.duration
          : defaultDuration,
        widget_id: widgetData?.widget_id,
        percent: widgetData?.percent,
        exclude_words: finalExcludeWords,
        temp_exclude_words: temp_exclude_words,
        graph_type: widgetData?.graph_type,
        profile_filters:
          rawData?.profile_filters_flag && updatedFilter ? updatedFilter : null,
        graphConditionConfig: rawData?.graphConditionConfig,
        filter_by: rawData?.filter_by ? rawData?.filter_by : null,
        filter_by_data: rawData?.filter_by_data
          ? rawData?.filter_by_data
          : null,
        complex_filters: rawData?.panes?.[rawData?.paneIndex]?.complex_filters
          ? rawData?.panes?.[rawData?.paneIndex]?.complex_filters
          : null,

        filter_dropdown: rawData?.filter_dropdown
          ? rawData?.filter_dropdown
          : null,
        filter_by_dropdown: rawData?.filter_by_dropdown
          ? rawData?.filter_by_dropdown
          : null,
        filter_by_dropdown_data: rawData?.filter_by_dropdown_data
          ? rawData?.filter_by_dropdown_data
          : null,

        selected_account_list: rawData?.panes?.[rawData?.paneIndex]
          ?.selected_account_list?.length
          ? rawData?.panes?.[rawData?.paneIndex]?.selected_account_list
          : null,
        public_engagement_only: public_engagement_only ? true : false,
      };
    }

    let global_date = {
      from: graphObject?.start_date,
      to: graphObject?.end_date,
    };
    let filter_date = [];
    // because we already passing start_date or end_date of widget in graphObject Based on locking filter so don't need to pass
    // graphObject?.filters?.filter?.((d) => {
    //   if (d.attribute === "CreatedDate") {
    //     filter_date = [...filter_date, d?.columns];
    //   }
    // });
    let combinedDate = getCombinedDate(global_date, filter_date);

    let pageDataSource = rawData?.graphConditionConfig?.[`default_attrs`]?.page
      ?.map((d) => d?.attribute)
      ?.includes(widgetData?.y_series?.[0]?.attribute)
      ? "page"
      : null;

    // View Case To make date part null for some base widgets
    if (
      graphObject?.graphConditionConfig?.[
        `standared_date_aggregation`
      ]?.includes(graphObject?.widget_id)
    ) {
      graphObject.x_axis.date_part = null;
    }

    let getInterval = getTimeIntervalDate(
      combinedDate?.end_date,
      combinedDate?.start_date,
      pageDataSource ? pageDataSource : graphObject?.data_source,
      graphObject?.x_axis?.attribute
    );

    // update chart settings
    if (rawData?.planned_value >= 0) {
      graphObject.chart.chart_settings.planned_val = rawData?.planned_value;
    }

    if (
      (graphObject?.chart?.chart_type === "grid" &&
        graphObject?.data_source == "ticket" &&
        rawData?.graphConditionConfig &&
        rawData?.graphConditionConfig?.[`date-attributes`]?.includes(
          graphObject?.x_axis?.attribute
        )) ||
      ((graphObject?.x_axis?.date_part === null ||
        graphObject?.x_axis?.date_part === "D") &&
        rawData?.graphConditionConfig?.[`date_agg-chart_type`]?.includes(
          graphObject?.chart?.chart_type
        ) &&
        rawData?.graphConditionConfig &&
        rawData?.graphConditionConfig?.[`date-attributes`]?.includes(
          graphObject?.x_axis?.attribute
        ))
    ) {
      graphObject.x_axis.date_aggregation = getInterval?.defaultVal;
    }
    if (
      (rawData?.graphConditionConfig &&
        graphObject?.chart?.chart_type === "pivot-grid" &&
        graphObject?.data_source === "ticket") ||
      rawData?.graphConditionConfig?.[`date_agg-chart_type`]?.includes(
        graphObject?.chart?.chart_type
      )
    ) {
      if (graphObject?.y_axes && graphObject?.y_axes?.length) {
        graphObject.y_axes = graphObject?.y_axes?.map((y_axis) => {
          if (
            rawData?.graphConditionConfig?.[`date-attributes`]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
          ) {
            y_axis.date_aggregation = getInterval?.defaultVal;
          }
          return y_axis;
        });
      }
    }

    graphObject.isBrandModified =
      rawData?.global_brands ||
      (widgets_is_locked &&
        (widgetBrands?.columns
          ? widgetBrands?.columns?.length
          : widgetBrands?.length)) ||
      (Section_is_locked &&
        (sectionBrands?.columns
          ? sectionBrands?.columns?.length
          : sectionBrands?.length)) ||
      widgetData?.duplicate_for_brands
        ? true
        : false;
    if (
      graphObject?.chart?.chart_type === "wordcloud" &&
      widgetData?.duplicate_for_brands
    ) {
      let indexOfCompWords = widgetData?.comp_exclude_words?.findIndex(
        (el) => el?.[graphObject?.brands?.[0]?.brand_id]
      );
      let parmanentExcluededWords = widgetData?.comp_exclude_words?.[
        indexOfCompWords
      ]?.[graphObject?.brands?.[0]?.brand_id]
        ? widgetData?.comp_exclude_words?.[indexOfCompWords]?.[
            graphObject?.brands?.[0]?.brand_id
          ]
        : [];

      graphObject.exclude_words = finalExcludeWords?.length
        ? [...finalExcludeWords, ...parmanentExcluededWords]
        : parmanentExcluededWords;
    }
  }
  return graphObject;
};

export const addDashboardCalledApiList = (widget) => {
  if (widget?.isDeepdiveDashboard) {
    let updatedDeepDiveDashboardApiCalledList =
      global.deepDiveDashboardApiCalledList
        ? [...global.deepDiveDashboardApiCalledList]
        : widget?.deepdiveDashboardTemplateData?.dashboard_called_api_list;
    let oldList = updatedDeepDiveDashboardApiCalledList
      ? updatedDeepDiveDashboardApiCalledList
      : [];
    let widgetId =
      widget?.widget_id + "#" + widget?.section_id + "#" + widget?.widget_index;
    let updatedArray = [];
    updatedArray = [...oldList, widgetId];
    global.deepDiveDashboardApiCalledList = updatedArray;
    return updatedArray;
  } else if (widget?.shareTemplateData) {
    // let updatedShareTemplateData = widget?.shareTemplateData;
    let updatedShareTemplateApiCalledList = global.shareTemplateApiCalledList
      ? [...global.shareTemplateApiCalledList]
      : widget?.shareTemplateData?.dashboard_called_api_list;

    let oldList = updatedShareTemplateApiCalledList
      ? updatedShareTemplateApiCalledList
      : [];
    let widgetId =
      widget?.widget_id + "#" + widget?.section_id + "#" + widget?.widget_index;
    let updatedArray = [];
    updatedArray = [...oldList, widgetId];

    // let shareTemplateDataObj = {
    //   ...updatedShareTemplateData,
    //   dashboard_called_api_list: updatedArray,
    // };
    // global.shareTemplateData = shareTemplateDataObj;

    global.shareTemplateApiCalledList = updatedArray;

    return updatedArray;
  } else if (widget?.templateFilter) {
    // console.log("Add Edit")
    // let updatedTemplateDetails = widget?.template_details;

    let updatedTemplateDetailsApiCalledList =
      global.templateDetailsApiCalledList
        ? [...global.templateDetailsApiCalledList]
        : widget?.template_details?.dashboard_called_api_list;

    let oldList = updatedTemplateDetailsApiCalledList
      ? updatedTemplateDetailsApiCalledList
      : [];
    let widgetId =
      widget?.widget_id + "#" + widget?.section_id + "#" + widget?.widget_index;
    let updatedArray = [];
    updatedArray = [...oldList, widgetId];

    // let templateDetailsObj = {
    //   ...updatedTemplateDetails,
    //   dashboard_called_api_list: updatedArray,
    // };
    // global.templateDetails = templateDetailsObj;

    global.templateDetailsApiCalledList = updatedArray;

    return updatedArray;
  } else {
    // console.log("Add View");
    let updatedPanes = global.panes ? [...global.panes] : [...widget?.panes];
    let oldList = updatedPanes?.[widget?.pane_index]?.dashboard_called_api_list
      ? updatedPanes?.[widget?.pane_index]?.dashboard_called_api_list
      : [];
    let widgetId =
      widget?.widget_id + "#" + widget?.section_id + "#" + widget?.widget_index;
    let updatedArray = [];
    updatedArray = [...oldList, widgetId];
    return updatedArray;
  }
};

export const deleteDashboardCalledApiList = (widget) => {
  if (widget?.isDeepdiveDashboard) {
    let updatedDeepDiveDashboardApiCalledList =
      global.deepDiveDashboardApiCalledList
        ? [...global.deepDiveDashboardApiCalledList]
        : widget?.deepdiveDashboardTemplateData?.dashboard_called_api_list;

    let widgetId =
      widget?.widget_id + "#" + widget?.section_id + "#" + widget?.widget_index;
    let updatedArray = updatedDeepDiveDashboardApiCalledList?.filter(
      (d) => d !== widgetId
    );
    global.deepDiveDashboardApiCalledList = updatedArray;
    return updatedArray;
  } else if (widget?.shareTemplateData) {
    let updatedShareTemplateApiCalledList = global.shareTemplateApiCalledList
      ? [...global.shareTemplateApiCalledList]
      : widget?.shareTemplateData?.dashboard_called_api_list;

    // let dashboardCalledList = updatedShareTemplateCalledList;
    let widgetId =
      widget?.widget_id + "#" + widget?.section_id + "#" + widget?.widget_index;
    let updatedArray = updatedShareTemplateApiCalledList?.filter(
      (d) => d !== widgetId
    );

    // let shareTemplateDataObj = {
    //   ...updatedShareTemplateData,
    //   dashboard_called_api_list: updatedArray,
    // };
    // global.shareTemplateData = shareTemplateDataObj;

    global.shareTemplateApiCalledList = updatedArray;

    return updatedArray;
  } else if (widget?.templateFilter) {
    // console.log("edit delete");
    let updatedTemplateDetailsApiCalledList =
      global.templateDetailsApiCalledList
        ? [...global.templateDetailsApiCalledList]
        : widget?.template_details?.dashboard_called_api_list;

    // let dashboardCalledList = updatedTemplateDetailsApiCalledList;
    let widgetId =
      widget?.widget_id + "#" + widget?.section_id + "#" + widget?.widget_index;
    let updatedArray = updatedTemplateDetailsApiCalledList?.filter(
      (d) => d !== widgetId
    );

    // let templateDetailsObj = {
    //   ...updatedTemplateDetails,
    //   dashboard_called_api_list: updatedArray,
    // };
    // global.templateDetails = templateDetailsObj;

    global.templateDetailsApiCalledList = updatedArray;

    return updatedArray;
  } else {
    // console.log("view delete");
    let updatedPanes = global.panes ? [...global.panes] : [...widget?.panes];
    let dashboardCalledList =
      updatedPanes?.[widget?.pane_index]?.dashboard_called_api_list;
    let widgetId =
      widget?.widget_id + "#" + widget?.section_id + "#" + widget?.widget_index;
    let updatedArray = dashboardCalledList?.filter((d) => d !== widgetId);
    return updatedArray;
  }
};

export const clearHighChartopData = (widget, widget_id) => {
  let updateOpData = global.options ? { ...global.options } : {};
  let sectionIndex = widget?.section_index ? widget?.section_index : 0;
  if (updateOpData?.[widget_id + sectionIndex + widget?.widget_index]) {
    delete updateOpData[widget_id + sectionIndex + widget?.widget_index];
  } else {
    let checkId = widget_id + sectionIndex + widget?.widget_index;
    Object.keys(updateOpData)?.map((el, i) => {
      if (el?.slice(0, -1).includes(checkId)) {
        delete updateOpData[el];
      }
    });
  }
  return updateOpData;
};

export const getTemporaryWordWidgetId = (widget_metadata) => {
  let widget_id = widget_metadata?.parentId
    ? widget_metadata?.parentId +
      "#" +
      widget_metadata?.com_brand_ids?.[0]?.brand_id
    : widget_metadata?.childId +
      "#" +
      widget_metadata?.com_brand_ids?.[0]?.brand_id;
  return widget_id;
};
export const clearGlobalvariables = () => {
  global.panes = null;
  global.Section = null;
  global.template_details = null;
};

export const getGlobalFilterAndFilterCountObject = (
  type,
  selectedPane,
  graphConditionConfig
) => {
  let finalFilters = [];

  if (!selectedPane) {
    return { filters: finalFilters, count: finalFilters?.length };
  }
  if (type === "view_dashboard") {
    // let quickFilterAttribute =
    //   selectedPane?.quick_filter === "AccountID"
    //     ? "SettingID"
    //     : selectedPane?.quick_filter === "Category"
    //     ? "CategoryID"
    //     : selectedPane?.quick_filter;
    // quickFilterAttribute = graphConditionConfig?.[
    //   `quick-filter-keys`
    // ]?.includes(quickFilterAttribute)
    //   ? quickFilterAttribute
    //   : null;
    // let quick_filter = selectedPane?.quick_filter_value
    //   ? [selectedPane?.quick_filter_value]
    //   : [];
    // quickFilterAttribute && selectedPane?.profiles?.length
    //   ? [
    //       {
    //         attribute: quickFilterAttribute,
    //         type: "varchar",
    //         columns: [
    //           {
    //             name:
    //               selectedPane?.quick_filter === "Category"
    //                 ? (selectedPane?.profiles?.[0]?.id).toString()
    //                 : (selectedPane?.profiles?.[0]?.id).toString(),
    //             type: "include",
    //           },
    //         ],
    //       },
    //     ]
    //   : [];
    let hidden_filter = selectedPane?.hidden_filter
      ? [selectedPane?.hidden_filter]
      : [];
    try {
      finalFilters = selectedPane?.filters?.length
        ? selectedPane?.filters?.filter((d) => d?.columns[0]?.name !== null)
        : [];
    } catch (error) {
      finalFilters = [];
    }
    // // To check hidden filters already present in filters list
    // let hidden_filter_present = finalFilters
    //   ?.map((d) => d?.columns?.[0]?.name)
    //   ?.includes(selectedPane?.hidden_filter?.columns?.[0]?.name) ;

    // // To Add Hidden filters, If Private Conversation include or True
    // if (
    //   !hidden_filter_present &&
    //   selectedPane?.hidden_filter?.attribute
    // ) {
    //   finalFilters = [...finalFilters, ...hidden_filter];
    // }

    // let saved_similar_quick_filter_obj = getSimilarStaticFilter(
    //   [],
    //   finalFilters,
    //   quick_filter
    // );

    // let saved_similar_hidden_filter_obj = getSimilarStaticFilter(
    //   hidden_filter,
    //   selectedPane?.filters,
    //   []
    // );

    // if (selectedPane?.hidden_filter || selectedPane?.quick_filter) {
    //   finalFilters = removeHiddenAndQuickFilters(
    //     selectedPane?.quick_filter,
    //     selectedPane?.hidden_filter,
    //     finalFilters
    //   );
    // }

    if (hidden_filter?.length) {
      finalFilters = [...finalFilters, ...hidden_filter];
    }

    // let saved_similar_quick_filter = saved_similar_quick_filter_obj?.filter;
    // if (saved_similar_quick_filter?.length) {
    //   finalFilters = [...finalFilters, ...saved_similar_quick_filter];
    // }
    // let saved_similar_hidden_filter = saved_similar_hidden_filter_obj?.filter;
    // if (saved_similar_hidden_filter?.length) {
    //   finalFilters = [...finalFilters, ...saved_similar_hidden_filter];
    // }

    // To Merge Hidden Filters and Private Conversarion Channel filters
    finalFilters = mergeSimilarAttributeInTooltip(
      finalFilters ? finalFilters : [],
      selectedPane?.hidden_filter ? selectedPane?.hidden_filter : [],
      selectedPane?.saved_filters ? selectedPane?.saved_filters : []
    );
    // if (selectedPane?.hidden_filter?.attribute && finalFilters?.length) {
    //   finalFilters?.map((d) => {
    //     if (d?.attribute === selectedPane?.hidden_filter?.attribute) {
    //       let columns = [];
    //       d.columns?.map((c) => {
    //         if (c?.name !== selectedPane?.hidden_filter?.columns?.[0]?.name) {
    //           columns.push(c);
    //         }
    //       });
    //       columns.push(selectedPane?.hidden_filter?.columns?.[0]);
    //       d.columns = columns;
    //     }
    //     return d;
    //   });
    // }

    // // To check hidden filters already present in filters list
    // let hidden_filter_present = finalFilters
    //   ?.map((d) => d?.attribute)
    //   ?.includes(selectedPane?.hidden_filter?.attribute);

    // // To Add Hidden filters, If Private Conversation include or True
    // if (
    //   !hidden_filter_present &&
    //   selectedPane?.hidden_filter?.attribute &&
    //   selectedPane?.private_conversation
    // ) {
    //   finalFilters = [...finalFilters, selectedPane?.hidden_filter];
    // }
  } else if (type === "edit_dashboard") {
    // let quick_filter = selectedPane?.quick_filter_value
    //   ? [selectedPane?.quick_filter_value]
    //   : [];

    finalFilters = selectedPane?.templateFilters?.length
      ? selectedPane?.templateFilters?.filter(
          (d) => d?.columns[0]?.name !== null
        )
      : [];
    let hidden_filter = selectedPane?.hidden_filter
      ? [selectedPane?.hidden_filter]
      : [];
    // let saved_similar_quick_filter_obj = getSimilarStaticFilter(
    //   [],
    //   finalFilters,
    //   quick_filter
    // );
    // let saved_similar_hidden_filter_obj = getSimilarStaticFilter(
    //   hidden_filter,
    //   finalFilters,
    //   []
    // );

    // if (selectedPane?.hidden_filter || selectedPane?.quick_filter) {
    //   finalFilters = removeHiddenAndQuickFilters(
    //     selectedPane?.quick_filter,
    //     selectedPane?.hidden_filter,
    //     finalFilters
    //   );
    // }

    // let saved_similar_quick_filter = saved_similar_quick_filter_obj?.filter;
    // if (saved_similar_quick_filter?.length) {
    //   finalFilters = [...finalFilters, ...saved_similar_quick_filter];
    // }
    // let saved_similar_hidden_filter = saved_similar_hidden_filter_obj?.filter;
    // if (saved_similar_hidden_filter?.length) {
    //   finalFilters = [...finalFilters, ...saved_similar_hidden_filter];
    // }
    if (hidden_filter?.length) {
      finalFilters = [...finalFilters, ...hidden_filter];
    }
    // To Merge Hidden Filters and Private Conversarion Channel filters
    finalFilters = mergeSimilarAttributeInTooltip(
      finalFilters ? finalFilters : [],
      selectedPane?.hidden_filter ? selectedPane?.hidden_filter : [],
      selectedPane?.saved_filters ? selectedPane?.saved_filters : []
    );
    // To check hidden filters already present in filters list
    // let hidden_filter_present = finalFilters
    //   ?.map((d) => d?.attribute)
    //   ?.includes(selectedPane?.hidden_filter?.attribute);

    // // To Add Hidden filters, If Private Conversation include or True
    // if (
    //   !hidden_filter_present &&
    //   selectedPane?.hidden_filter?.attribute &&
    //   selectedPane?.private_conversation
    // ) {
    //   finalFilters = [...finalFilters, selectedPane?.hidden_filter];
    // }
    // console.log("edit finalFilters", finalFilters);
  } else if (type === "share_dashboard") {
    // let quickFilterAttribute =
    //   selectedPane?.quick_filter === "AccountID"
    //     ? "SettingID"
    //     : selectedPane?.quick_filter === "Category"
    //     ? "CategoryID"
    //     : selectedPane?.quick_filter;
    // quickFilterAttribute = graphConditionConfig?.[
    //   `quick-filter-keys`
    // ]?.includes(quickFilterAttribute)
    //   ? quickFilterAttribute
    //   : null;
    // let quick_filter = selectedPane?.quick_filter_value
    //   ? [selectedPane?.quick_filter_value]
    //   : [];

    // quickFilterAttribute && selectedPane?.profiles?.length
    //   ? [
    //       {
    //         attribute: quickFilterAttribute,
    //         type: "varchar",
    //         columns: [
    //           {
    //             name:
    //               selectedPane?.quick_filter === "Category"
    //                 ? (selectedPane?.profiles?.[0]?.id).toString()
    //                 : (selectedPane?.profiles?.[0]?.id).toString(),
    //             type: "include",
    //           },
    //         ],
    //       },
    //     ]
    //   : [];

    finalFilters = selectedPane?.filters?.length
      ? selectedPane?.filters?.filter((d) => d?.columns[0]?.name !== null)
      : [];
    let hidden_filter = selectedPane?.hidden_filter
      ? [selectedPane?.hidden_filter]
      : [];
    // let saved_similar_quick_filter_obj = getSimilarStaticFilter(
    //   [],
    //   finalFilters,
    //   quick_filter
    // );
    // let saved_similar_hidden_filter_obj = getSimilarStaticFilter(
    //   hidden_filter,
    //   selectedPane?.filters,
    //   []
    // );
    // if (selectedPane?.hidden_filter || selectedPane?.quick_filter) {
    //   finalFilters = removeHiddenAndQuickFilters(
    //     selectedPane?.quick_filter,
    //     selectedPane?.hidden_filter,
    //     finalFilters
    //   );
    // }

    // let saved_similar_quick_filter = saved_similar_quick_filter_obj?.filter;
    // if (saved_similar_quick_filter?.length) {
    //   finalFilters = [...finalFilters, ...saved_similar_quick_filter];
    // }
    // let saved_similar_hidden_filter = saved_similar_hidden_filter_obj?.filter;
    // if (saved_similar_hidden_filter?.length) {
    //   finalFilters = [...finalFilters, ...saved_similar_hidden_filter];
    // }
    if (hidden_filter?.length) {
      finalFilters = [...finalFilters, ...hidden_filter];
    }

    // To Merge Hidden Filters and Private Conversarion Channel filters
    finalFilters = mergeSimilarAttributeInTooltip(
      finalFilters ? finalFilters : [],
      selectedPane?.hidden_filter ? selectedPane?.hidden_filter : [],
      selectedPane?.saved_filters ? selectedPane?.saved_filters : []
    );
    // if (selectedPane?.hidden_filter?.attribute && finalFilters?.length) {
    //   finalFilters?.map((d) => {
    //     if (d?.attribute === selectedPane?.hidden_filter?.attribute) {
    //       let columns = [];
    //       d.columns?.map((c) => {
    //         if (c?.name !== selectedPane?.hidden_filter?.columns?.[0]?.name) {
    //           columns.push(c);
    //         }
    //       });
    //       columns.push(selectedPane?.hidden_filter?.columns?.[0]);
    //       d.columns = columns;
    //     }
    //     return d;
    //   });
    // }
    // To check hidden filters already present in filters list
    // let hidden_filter_present = finalFilters
    //   ?.map((d) => d?.attribute)
    //   ?.includes(selectedPane?.hidden_filter?.attribute);

    // // To Add Hidden filters, If Private Conversation include or True
    // if (
    //   !hidden_filter_present &&
    //   selectedPane?.hidden_filter?.attribute &&
    //   selectedPane?.private_conversation
    // ) {
    //   finalFilters = [...finalFilters, selectedPane?.hidden_filter];
    // }
  } else if (type === "pdf_schedule") {
    // let quick_filter = selectedPane?.quick_filter_value
    //   ? [selectedPane?.quick_filter_value]
    //   : [];

    let hidden_filter = selectedPane?.hidden_filter
      ? [selectedPane?.hidden_filter]
      : [];
    finalFilters =
      selectedPane?.filters && selectedPane?.filters?.length > 0
        ? selectedPane?.filters?.filter((d) => d?.columns[0]?.name !== null)
        : [];

    if (hidden_filter?.length) {
      finalFilters = [...finalFilters, ...hidden_filter];
    }

    // To Merge Hidden Filters and Private Conversarion Channel filters
    finalFilters = mergeSimilarAttributeInTooltip(
      finalFilters ? finalFilters : [],
      selectedPane?.hidden_filter ? selectedPane?.hidden_filter : [],
      selectedPane?.saved_filters ? selectedPane?.saved_filters : []
    );
  }
  return { filters: finalFilters, count: finalFilters?.length };
};

export const getTemplateListBasicObject = (
  authParams,
  panes,
  index,
  pageSize,
  graphConditionConfig,
  schedulePath
) => {
  let basicObj;
  if (schedulePath) {
    basicObj = {
      authParams: authParams,
      search_text:
        window.location.pathname === "/schedule"
          ? ""
          : panes?.[index]?.dashboard_template_filters?.search_text?.trim()
          ? panes?.[index]?.dashboard_template_filters?.search_text?.trim()
          : "",
      pill:
        window.location.pathname === "/schedule"
          ? "All Dashboards"
          : panes?.[index]?.dashboard_template_filters?.pill
          ? panes?.[index]?.dashboard_template_filters?.pill
          : "All Dashboards",
      offset:
        window.location.pathname === "/schedule"
          ? 0
          : panes?.[index]?.dashboard_template_filters?.offset
          ? panes?.[index]?.dashboard_template_filters?.offset
          : 0,
      no_of_rows: pageSize,
      sort_expression:
        window.location.pathname === "/schedule"
          ? "usage_count"
          : panes?.[index]?.dashboard_template_filters?.sort_expression
          ? panes?.[index]?.dashboard_template_filters?.sort_expression
          : graphConditionConfig?.[`static-categories`] ===
            authParams?.category_id
          ? "template_name"
          : "usage_count",
      sort_order:
        window.location.pathname === "/schedule"
          ? "desc"
          : panes?.[index]?.dashboard_template_filters?.sort_order
          ? panes?.[index]?.dashboard_template_filters?.sort_order
          : graphConditionConfig?.[`static-categories`] ===
            authParams?.category_id
          ? "asc"
          : "desc",
      filter_vals:
        window.location.pathname === "/schedule"
          ? []
          : panes?.[index]?.dashboard_template_filters?.filter_vals
          ? panes?.[index]?.dashboard_template_filters?.filter_vals
          : [],
      type:
        window.location.pathname === "/schedule"
          ? "report"
          : panes?.[index]?.dashboard_template_filters?.type
          ? panes?.[index]?.dashboard_template_filters?.type
          : "dashboard",
    };
  } else {
    basicObj = {
      authParams: authParams,
      search_text: panes?.[
        index
      ]?.dashboard_template_filters?.search_text?.trim()
        ? panes?.[index]?.dashboard_template_filters?.search_text?.trim()
        : "",
      pill: panes?.[index]?.dashboard_template_filters?.pill
        ? panes?.[index]?.dashboard_template_filters?.pill
        : "All Dashboards",
      offset: panes?.[index]?.dashboard_template_filters?.offset
        ? panes?.[index]?.dashboard_template_filters?.offset
        : 0,
      no_of_rows: pageSize,
      sort_expression: panes?.[index]?.dashboard_template_filters
        ?.sort_expression
        ? panes?.[index]?.dashboard_template_filters?.sort_expression
        : graphConditionConfig?.[`static-categories`] ===
          authParams?.category_id
        ? "template_name"
        : "usage_count",
      sort_order: panes?.[index]?.dashboard_template_filters?.sort_order
        ? panes?.[index]?.dashboard_template_filters?.sort_order
        : graphConditionConfig?.[`static-categories`] ===
          authParams?.category_id
        ? "asc"
        : "desc",
      filter_vals: panes?.[index]?.dashboard_template_filters?.filter_vals
        ? panes?.[index]?.dashboard_template_filters?.filter_vals
        : [],
      type: panes?.[index]?.dashboard_template_filters?.type
        ? panes?.[index]?.dashboard_template_filters?.type
        : "dashboard",
    };
  }
  return basicObj;
};

export const getTemplateListDashboardObject = (
  authParams,
  pageSize,
  graphConditionConfig
) => {
  let dashboardObj = {
    search_text: "",
    pill: "All Dashboards",
    offset: 0,
    no_of_rows: pageSize,
    sort_expression:
      graphConditionConfig?.[`static-categories`] === authParams?.category_id
        ? "template_name"
        : "usage_count",
    sort_order:
      graphConditionConfig?.[`static-categories`] === authParams?.category_id
        ? "asc"
        : "desc",
    type: "dashboard",
    filter_vals: [],
  };
  return dashboardObj;
};

export const getWidgetLibraryListObject = (obj) => {
  let widgetLibraryListObject;
  if (obj?.widgetLibraryFilter) {
    widgetLibraryListObject = {
      authParams: obj?.authParams,
      search_text: obj?.searchTextEmpty
        ? ""
        : obj?.widgetLibraryFilter?.search_text
        ? obj?.widgetLibraryFilter?.search_text
        : "",
      pill: obj?.tabName
        ? obj?.tabName
        : obj?.widgetLibraryFilter?.pill
        ? obj?.widgetLibraryFilter?.pill
        : "All Widgets",
      offset: obj?.pageNo ? obj?.pageNo : 0,
      no_of_rows: obj?.widgetLibraryFilter?.no_of_rows
        ? obj?.widgetLibraryFilter?.no_of_rows
        : 12,
      sort_expression: obj?.sortExpression
        ? obj?.sortExpression
        : obj?.widgetLibraryFilter?.sort_expression
        ? obj?.widgetLibraryFilter?.sort_expression
        : obj?.tabKey === "3"
        ? "widget_name"
        : "created_date",
      sort_order: obj?.sortOrder
        ? obj?.sortOrder
        : obj?.widgetLibraryFilter?.sort_order
        ? obj?.widgetLibraryFilter?.sort_order
        : "desc",
      chart_type: obj?.chartTypeNameEmpty
        ? ""
        : obj?.chartTypeName
        ? obj?.chartTypeName
        : obj?.widgetLibraryFilter?.chart_type
        ? obj?.widgetLibraryFilter?.chart_type
        : "",
      attribute: obj?.attributeNameEmpty
        ? ""
        : obj?.attributeName
        ? obj?.attributeName
        : obj?.widgetLibraryFilter?.attribute
        ? obj?.widgetLibraryFilter?.attribute
        : "",
      type:
        obj?.login_access_type === 1
          ? "base-widget"
          : obj?.tabKey === "3"
          ? "base-widget"
          : "widget-maker",
    };
  } else {
    widgetLibraryListObject = {
      authParams: obj?.authParams,
      search_text: "",
      pill: "All Widgets",
      offset: 0,
      no_of_rows: 12,
      sort_expression: obj?.tabKey === "3" ? "widget_name" : "created_date",
      sort_order: "desc",
      chart_type: "",
      attribute: "",
      type:
        obj?.login_access_type === 1
          ? "base-widget"
          : obj?.tabKey === "3"
          ? "base-widget"
          : "widget-maker",
    };
  }

  return widgetLibraryListObject;
};

export const getDiscardedFilters = (rawData) => {
  let obj;
  let updatedColumns = [];

  if (rawData?.profile_filters_list) {
    // console.log("delete data here", rawData)
    rawData?.profile_filters_list?.map((d) => {
      rawData?.profile_filters?.columns?.map((c) => {
        if (c?.name === d?.id && c?.profile_channel === d?.channel) {
          updatedColumns = [...updatedColumns, c];
        }
      });
    });
    // console.log("check updatedColumns", updatedColumns)

    if (updatedColumns?.length) {
      obj = {
        attribute: "SocialMediaProfiles",
        type: "varchar",
        columns: updatedColumns,
      };
    } else {
      obj = null;
    }

    // console.log("final obj", obj);
  }
  return obj;
};

export const getDefaultGlobalBrand = (graphObject) => {
  let brands = graphObject?.brands?.columns
    ? graphObject?.brands?.columns
    : graphObject?.brands;

  let single_brands = [];
  let brandsGroupName = [];
  if (graphObject?.brands) {
    if (brands && brands?.[0]?.brand_group_name) {
      brandsGroupName = [
        {
          brand_group_name: brands?.[0]?.brand_group_name,
        },
      ];
    } else {
      single_brands?.push({
        brand_id: brands && brands?.[0]?.brand_id && brands?.[0]?.brand_id,
        brand_name:
          brands && brands?.[0]?.brand_name && brands?.[0]?.brand_name,
      });
    }
  }
  return brandsGroupName?.length ? brandsGroupName : single_brands;
};

export const getWidgetMakerFlag = (widgetGraphConfig, wm_api_flag) => {
  let y_series_index = 0;
  let final_flag = false;
  let empty_fields = [];
  if (
    widgetGraphConfig?.chart_type === "combination" ||
    widgetGraphConfig?.chart_type === "bar" ||
    widgetGraphConfig?.chart_type === "area" ||
    widgetGraphConfig?.chart_type === "line" ||
    widgetGraphConfig?.chart_type === "horizontal-bar" ||
    widgetGraphConfig?.chart_type === "wordcloud"
  ) {
    let y_series_array = Object.keys(widgetGraphConfig?.y_axis).map(
      (key) => widgetGraphConfig?.y_axis[key]
    );

    y_series_index = y_series_array?.findIndex((el) => !el?.attribute);
    let series_length_flag =
      widgetGraphConfig?.chart_type === "combination"
        ? y_series_array?.length > 2
          ? true
          : false
        : y_series_array?.length > 1
        ? true
        : false;
    if (series_length_flag) {
      if (!widgetGraphConfig?.y_axis?.y_series_1?.attribute) {
        empty_fields?.push("y_series_1");
      }
      if (!widgetGraphConfig?.y_axis?.y_series_2?.attribute) {
        empty_fields?.push("y_series_2");
      }
      if (!widgetGraphConfig?.x_axis?.attribute) {
        empty_fields?.push("x_axis");
      }
    }
    if (y_series_index > 0) {
      empty_fields?.push("y_series_" + (y_series_index + 1));
    }

    if (
      wm_api_flag ||
      y_series_index > 0 ||
      (series_length_flag &&
        !widgetGraphConfig?.y_axis?.y_series_1?.attribute) ||
      (series_length_flag &&
        !widgetGraphConfig?.y_axis?.y_series_2?.attribute) ||
      (series_length_flag && !widgetGraphConfig?.x_axis?.attribute)
    ) {
      final_flag = true;
    }
  }

  return { flag: final_flag, value: empty_fields };
};

export const getEmptyFieldNotification = () => {
  return callNotification(
    "Please add attribute to the asterisk(*) marked field(s)",
    "alert"
  );
};

export const getByDefaultProfileFilters = (profileFilterList) => {
  let obj;
  if (profileFilterList?.length > 0) {
    obj = {
      attribute: "SocialMediaProfiles",
      type: "varchar",
      columns: [
        {
          name: profileFilterList?.[0]?.id ? profileFilterList?.[0]?.id : null,
          type: "include",
          display_name: profileFilterList?.[0]?.name
            ? profileFilterList?.[0]?.name
            : null,
          profile_channel: profileFilterList?.[0]?.channel
            ? profileFilterList?.[0]?.channel
            : null,
          brand_id: profileFilterList?.[0]?.brand_id
            ? profileFilterList?.[0]?.brand_id
            : null,
        },
      ],
    };
  }
  return obj;
};

export const getPrivateConversationFilters = (
  comp_hidden_filter,
  global_filters,
  saved_filters
) => {
  comp_hidden_filter = comp_hidden_filter?.length
    ? deepCopy(comp_hidden_filter)
    : [];
  global_filters = global_filters?.length ? deepCopy(global_filters) : [];
  saved_filters = saved_filters?.length ? deepCopy(saved_filters) : [];

  let filters = [];
  let global_attribute_array = global_filters?.map((el) => {
    return el?.attribute;
  });
  //check in static filters if global filters contain static filter attribute, if not add it, if yes update it
  comp_hidden_filter?.map((el, i) => {
    if (!global_attribute_array?.includes(el?.attribute)) {
      filters.push(comp_hidden_filter?.[i]);
    } else {
      // let index = global_filters?.findIndex(
      //   (item) => item?.attribute === el?.attribute
      // );
      // global_filters[index] = el;

      if (global_filters?.length && saved_filters?.length) {
        global_filters?.map((g) => {
          saved_filters?.map((d, i) => {
            if (d?.attribute === el?.attribute) {
              d?.columns?.map((c) => {
                if (!d?.columns?.map((d) => d?.name)?.includes(c?.name)) {
                  g?.columns.push(c);
                }
              });
            }
          });

          if (g?.attribute === el?.attribute) {
            el?.columns?.map((c) => {
              if (!g?.columns?.map((d) => d?.name)?.includes(c?.name)) {
                g?.columns.unshift(c);
              }
            });
          }
        });
      } else if (global_filters?.length) {
        global_filters?.map((g) => {
          if (g?.attribute === el?.attribute) {
            el?.columns?.map((c) => {
              if (!g?.columns?.map((d) => d?.name)?.includes(c?.name)) {
                g?.columns.unshift(c);
              }
            });
          }
        });
      }
    }
  });

  return [...filters, ...global_filters];
};
export const removePrivateConversationFilters = (
  comp_hidden_filter,
  global_filters,
  saved_filters
) => {
  comp_hidden_filter = comp_hidden_filter?.length
    ? deepCopy(comp_hidden_filter)
    : [];
  global_filters = global_filters?.length ? deepCopy(global_filters) : [];
  saved_filters = saved_filters?.length ? deepCopy(saved_filters) : [];

  // console.log(
  //   "comp_hidden_filter",
  //   deepCopy(comp_hidden_filter),
  //   "global_filters",
  //   deepCopy(global_filters),
  //   "saved_filters",
  //   deepCopy(saved_filters)
  // );
  let mergedFilters = [...global_filters];

  global_filters?.map((g) => {
    comp_hidden_filter?.map((comp) => {
      if (g?.attribute === comp?.attribute) {
        comp?.columns?.map((c) => {
          if (!g?.columns?.map((d) => d?.name)?.includes(c?.name)) {
            g.columns.push(c);
          }
        });
        if (!mergedFilters?.map((d) => d?.attribute)?.includes(g?.attribute)) {
          mergedFilters = [...mergedFilters, g];
        }
      } else {
        if (
          !mergedFilters?.map((d) => d?.attribute)?.includes(comp?.attribute)
        ) {
          mergedFilters = [...mergedFilters, comp];
        }
        if (!mergedFilters?.map((d) => d?.attribute)?.includes(g?.attribute)) {
          mergedFilters = [...mergedFilters, g];
        }
      }
    });
    // if (saved_filters?.length) {
    //   saved_filters?.map((s) => {
    //     if (g?.attribute === s?.attribute) {
    //       s?.columns?.map((c) => {
    //         if (!g?.columns?.map((d) => d?.name)?.includes(c?.name)) {
    //           g.columns.push(c);
    //         }
    //       });
    //       if (
    //         !mergedFilters?.map((d) => d?.attribute)?.includes(g?.attribute)
    //       ) {
    //         mergedFilters = [...mergedFilters, g];
    //       }
    //     } else {
    //       if (
    //         !mergedFilters?.map((d) => d?.attribute)?.includes(s?.attribute)
    //       ) {
    //         mergedFilters = [...mergedFilters, s];
    //       }
    //       if (
    //         !mergedFilters?.map((d) => d?.attribute)?.includes(g?.attribute)
    //       ) {
    //         mergedFilters = [...mergedFilters, g];
    //       }
    //     }
    //   });
    // }
  });
  // console.log(
  //   "Start mergedFilters",
  //   mergedFilters,
  //   "comp_hidden_filter",
  //   comp_hidden_filter
  // );

  let filterData = [];
  comp_hidden_filter?.map((comp) => {
    mergedFilters?.map((m) => {
      if (comp?.attribute === m?.attribute) {
        // let updatedColumn = [...m?.columns];
        comp?.columns?.map((cCol) => {
          if (m?.columns?.map((d) => d?.name)?.includes(cCol?.name)) {
            m.columns = m?.columns?.filter(
              (d) =>
                d?.name !== cCol?.name ||
                (d?.name === cCol?.name && d?.type !== cCol?.type)
            );
          }
          // console.log("Inside updatedColumn", deepCopy(updatedColumn));
        });

        // console.log("updatedColumn", updatedColumn);
        // m.columns = updatedColumn;
        if (
          !filterData?.map((d) => d?.attribute)?.includes(m?.attribute) &&
          m?.columns?.length
        ) {
          filterData.push(m);
        }
      } else if (
        !comp_hidden_filter?.map((d) => d?.attribute)?.includes(m?.attribute) &&
        !filterData?.map((d) => d?.attribute)?.includes(m?.attribute)
      ) {
        // console.log("Inside else if", m);
        filterData.push(m);
      }
    });
  });

  // console.log("Updated filterData", filterData);
  return [...filterData];
};

export const removeSavedFilters = (
  global_filters,
  saved_filters,
  comp_hidden_filter,
  private_conversation
) => {
  global_filters = global_filters?.length ? deepCopy(global_filters) : [];
  saved_filters = saved_filters?.length ? deepCopy(saved_filters) : [];
  comp_hidden_filter = comp_hidden_filter?.length
    ? deepCopy(comp_hidden_filter)
    : [];
  // console.log(
  //   "global_filters",
  //   deepCopy(global_filters),
  //   "saved_filters",
  //   deepCopy(saved_filters),
  //   "comp_hidden_filter ",
  //   deepCopy(comp_hidden_filter),
  //   "private_conversation ",
  //   private_conversation
  // );

  let filterData = [];
  if (comp_hidden_filter?.length && private_conversation) {
    if (global_filters?.length) {
      getRemainingFilter(global_filters, comp_hidden_filter, filterData);
    }

    if (filterData?.length === 0 && saved_filters?.length) {
      filterData = [...saved_filters];
    } else if (saved_filters?.length === 0 && filterData?.length) {
      filterData = [...filterData];
    } else if (filterData?.length >= saved_filters?.length) {
      getRemainingFilter(filterData, saved_filters, filterData);
    } else if (filterData?.length) {
      getRemainingFilter(saved_filters, filterData, filterData);
    }
  } else if (comp_hidden_filter?.length && !private_conversation) {
    if (global_filters?.length >= comp_hidden_filter?.length) {
      getRemainingFilter(global_filters, comp_hidden_filter, filterData);
    } else {
      getRemainingFilter(comp_hidden_filter, global_filters, filterData);
    }

    if (filterData?.length === 0 && saved_filters?.length) {
      filterData = [...saved_filters];
    } else if (saved_filters?.length === 0 && filterData?.length) {
      filterData = [...filterData];
    } else if (filterData?.length >= saved_filters?.length) {
      getRemainingFilter(filterData, saved_filters, filterData);
    } else if (filterData?.length) {
      getRemainingFilter(saved_filters, filterData, filterData);
    }
  } else if (!comp_hidden_filter?.length) {
    if (global_filters?.length === 0 && saved_filters?.length) {
      filterData = [...saved_filters];
    } else if (saved_filters?.length === 0 && global_filters?.length) {
      filterData = [...global_filters];
    } else if (global_filters?.length >= saved_filters?.length) {
      getRemainingFilter(global_filters, saved_filters, filterData);
    } else if (global_filters?.length) {
      getRemainingFilter(saved_filters, global_filters, filterData);
    }
  }

  filterData = filterData?.filter((d) =>
    isArray(d?.columns) ? d?.columns?.length : Object?.keys(d?.columns)?.length
  );
  // console.log("Updated filterData ", filterData);
  return [...filterData];
};

export const getRemainingFilter = (
  highLengthFilters,
  lowLengthFilters,
  filterData
) => {
  lowLengthFilters?.map((s) => {
    highLengthFilters?.map((g) => {
      if (
        s?.attribute === g?.attribute &&
        isArray(s?.columns?.[0]?.name) &&
        isArray(g?.columns?.[0]?.name)
      ) {
        let array1 = highLengthFilters?.find(
          (d) => d?.attribute === s?.attribute
        );
        let array2 = lowLengthFilters?.find(
          (d) => d?.attribute === s?.attribute
        );
        let result = deleteSimilarObjects([array1], [array2]);
        result = result?.map((d) => {
          d.columns = d?.columns
            ?.map((col) => {
              if (col?.name?.length) {
                return col;
              } else {
                return null;
              }
            })
            .filter((d) => d);
          return d;
        });

        if (
          filterData
            ?.map((d) => d?.attribute)
            ?.includes(s?.attribute || g?.attribute)
        ) {
          filterData?.map((f) => {
            if (
              f?.attribute === s?.attribute ||
              f?.attribute === g?.attribute
            ) {
              f.columns = result?.[0]?.columns;
            }
          });
        } else {
          filterData.push(result?.[0]);
        }
      } else if (
        s?.attribute === g?.attribute &&
        s?.columns?.from &&
        g?.columns?.from
      ) {
        if (
          g?.columns?.from !== s?.columns?.from ||
          g?.columns?.to !== s?.columns?.to
        ) {
          filterData.push(g);
        } else {
          g.columns = [];
          filterData.push(g);
        }
      } else if (s?.attribute === g?.attribute) {
        s?.columns?.map((sCol) => {
          if (g?.columns?.map((d) => d?.name)?.includes(sCol?.name)) {
            g.columns = g?.columns?.filter(
              (d) =>
                d?.name !== sCol?.name ||
                (d?.name === sCol?.name && d?.type !== sCol?.type)
            );
          }
        });
        if (
          !filterData?.map((d) => d?.attribute)?.includes(g?.attribute) &&
          g?.columns?.length
        ) {
          // console.log("Inside if g ", g);
          filterData.push(g);
        }
      } else if (
        !lowLengthFilters?.map((d) => d?.attribute)?.includes(g?.attribute) &&
        !filterData?.map((d) => d?.attribute)?.includes(g?.attribute)
      ) {
        filterData.push(g);
      }
    });
  });
  // console.log("Final filterData", filterData);
  return filterData;
};

export const deleteSimilarObjects = (array1, array2) => {
  // console.log("array1", array1, "array2", array2);
  const namesByType = {};
  array2?.forEach((obj) => {
    obj?.columns?.forEach((col) => {
      if (!namesByType?.[col?.type]) {
        namesByType[col.type] = new Set();
      }
      isArray(col?.name) &&
        col?.name?.forEach((name) => namesByType?.[col.type]?.add(name));
    });
  });
  // console.log("namesByType", namesByType);

  // Loop through array1 and delete same name values
  const result = array1?.map((obj) => {
    const updatedColumns = obj?.columns?.map((col) => {
      if (namesByType?.[col?.type]) {
        let namesByTypeLength = [...namesByType[col?.type]];
        let uniqueNames = [];
        if (col?.name?.length >= namesByTypeLength?.length) {
          uniqueNames = col?.name?.filter(
            (name) => !namesByType[col?.type]?.has(name)
          );
        } else {
          uniqueNames = namesByTypeLength?.filter(
            (name) => !col?.name?.includes(name)
          );
        }
        return { ...col, name: uniqueNames };
      }
      return col;
    });
    array2?.[0]?.columns?.map((col) => {
      if (updatedColumns?.map((d) => d?.type)?.includes(col?.type)) {
        // console.log("Inside If", col);
      } else {
        // console.log("Inside Else", col);
        updatedColumns.push(col);
      }
    });
    // console.log("Final updatedColumns", updatedColumns);
    return { ...obj, columns: updatedColumns };
  });

  // console.log("result", result);
  return result;
};

// export const removePrivateConversationFilters1 = (
//   comp_hidden_filter,
//   global_filters,
//   saved_filters
// ) => {
//   comp_hidden_filter = comp_hidden_filter?.length
//     ? deepCopy(comp_hidden_filter)
//     : [];
//   global_filters = global_filters?.length ? deepCopy(global_filters) : [];
//   saved_filters = saved_filters?.length ? deepCopy(saved_filters) : [];

//   console.log("comp_hidden_filter", deepCopy(comp_hidden_filter));
//   console.log("global_filters", deepCopy(global_filters));
//   console.log("saved_filters", deepCopy(saved_filters));

//   let filters = [];
//   let add_saved_filter = [];
//   let comp_attribute_array = comp_hidden_filter?.map((el) => {
//     return el?.attribute;
//   });
//   let saved_filters_array = saved_filters?.map((el) => {
//     return el?.attribute;
//   });
//   global_filters?.map((el, i) => {
//     if (!comp_attribute_array?.includes(el?.attribute)) {
//       filters.push(el);
//     }
//     if (comp_attribute_array?.includes(el?.attribute)) {
//       let findObject = comp_hidden_filter?.find(
//         (d) => d?.attribute === el?.attribute
//       );

//       if (
//         el?.attribute === findObject?.attribute &&
//         el?.columns?.length !== findObject?.columns?.length
//       ) {
//         el.columns = el?.columns?.filter(
//           (d, i) => d?.name !== findObject?.columns?.[0]?.name
//         );
//         filters.push(el);
//       }
//     }
//     if (
//       comp_attribute_array?.includes(el?.attribute) &&
//       saved_filters_array?.includes(el?.attribute)
//     ) {
//       add_saved_filter.push(el?.attribute);
//     }
//   });
//   if (add_saved_filter?.length) {
//     saved_filters?.map((el) => {
//       if (add_saved_filter?.includes(el?.attribute)) {
//         if (!filters?.map((d) => d?.attribute)?.includes(el?.attribute)) {
//           filters.push(el);
//         }
//       }
//     });
//   }

//   console.log("Remove filters", filters);
//   return [...filters];
// };

export const removeHiddenAndQuickFilters = (
  quick_filter,
  hidden_filter,
  filters
) => {
  let final_quickFilter =
    quick_filter === "Category"
      ? "CategoryID"
      : quick_filter === "AccountID"
      ? "SettingID"
      : quick_filter;
  let finalFilters =
    quick_filter || hidden_filter
      ? filters?.filter(
          (el) =>
            el?.attribute !== final_quickFilter &&
            el?.attribute !== hidden_filter?.attribute
        )
      : filters;

  return finalFilters;
};

export const mergeSimilarAttributeInTooltip = (AllFilters) => {
  let finalFilters = [];

  for (let i = 0; i < AllFilters.length; i++) {
    const currentFilter = AllFilters[i];

    // Handling for followerscount attribute
    if (currentFilter.attribute.toLowerCase() === "followerscount") {
      const existingIndex = finalFilters.findIndex(
        (filter) =>
          filter.attribute.toLowerCase() === "followerscount" &&
          filter.columns.from === currentFilter.columns.from &&
          filter.columns.to === currentFilter.columns.to
      );

      if (existingIndex === -1) {
        finalFilters.push(currentFilter);
      }
      continue; // Skip further processing for this attribute
    } else if (currentFilter.attribute === "new_page_followers_count") {
      const existingIndex = finalFilters.findIndex(
        (filter) =>
          filter.attribute === "new_page_followers_count" &&
          filter.columns.from === currentFilter.columns.from &&
          filter.columns.to === currentFilter.columns.to
      );

      if (existingIndex === -1) {
        finalFilters.push(currentFilter);
      }
      continue; // Skip further processing for this attribute
    }

    // General handling for other attributes
    const existingIndex = finalFilters.findIndex(
      (filter) =>
        filter.attribute?.toLowerCase() ===
        currentFilter.attribute?.toLowerCase()
    );

    if (existingIndex !== -1) {
      let existingFilter = finalFilters[existingIndex];
      let existingColumns = existingFilter.columns;
      let newColumns = currentFilter.columns;

      if (!Array.isArray(existingColumns)) existingColumns = [existingColumns];
      if (!Array.isArray(newColumns)) newColumns = [newColumns];

      newColumns.forEach((el) => {
        if (existingColumns.findIndex((e) => e.name === el.name) === -1) {
          existingColumns.push(el);
        }
      });

      finalFilters[existingIndex].columns = existingColumns;
    } else {
      finalFilters.push(currentFilter);
    }
  }

  return finalFilters;
};

export const getSimilarStaticFilter = (
  hidden_filter,
  filters,
  quick_filter
) => {
  // if (filters?.length && comp_hidden_filter?.length && hidden_filter?.length) {
  //   let filter = [];
  //   for (let i = 0; i < filters?.length; i++) {
  //     for (let j = 0; j < comp_hidden_filter?.length; j++) {
  //       if (
  //         filters?.[i]?.attribute === comp_hidden_filter?.[j]?.attribute &&
  //         comp_hidden_filter?.[j]?.attribute === hidden_filter?.[0]?.attribute
  //       ) {
  //         if (
  //           (filters?.[i]?.columns?.length === 1 &&
  //             hidden_filter?.[0]?.columns?.[0]?.name !=
  //               filters?.[i]?.columns?.[0]?.name) ||
  //           filters?.[j]?.columns?.length > 1
  //         ) {
  //           filter.push(filters?.[j]);
  //         }
  //       }
  //     }
  //   }
  //   return {
  //     value: true,
  //     filter: filter,
  //   };
  // }
  if (filters?.length && hidden_filter?.length) {
    let filter = [];
    for (let j = 0; j < filters?.length; j++) {
      if (filters?.[j]?.attribute === hidden_filter?.[0]?.attribute) {
        if (
          (filters?.[j]?.columns?.length === 1 &&
            hidden_filter?.[0]?.columns?.[0]?.name !=
              filters?.[j]?.columns?.[0]?.name) ||
          filters?.[j]?.columns?.length > 1
        ) {
          filter.push(filters?.[j]);
        }
      }
    }
    return {
      value: true,
      filter: filter,
    };
  } else if (filters?.length && quick_filter?.length) {
    let filter = [];
    for (let j = 0; j < filters?.length; j++) {
      if (filters?.[j]?.attribute === quick_filter?.[0]?.attribute) {
        if (
          (filters?.[j]?.columns?.length === 1 &&
            quick_filter?.[0]?.columns?.[0]?.name !=
              filters?.[j]?.columns?.[0]?.name) ||
          filters?.[j]?.columns?.length > 1
        ) {
          filter.push(filters?.[j]);
        }
      }
    }
    return {
      value: true,
      filter: filter,
    };
  } else return { value: false, filter: [] };
};

export const getFormattedBrandsForApi = (isBrandModified, brands) => {
  let brandsGroupName = [];
  let single_brands = [];
  if (!isBrandModified) {
    brandsGroupName =
      brands && brands?.[0]?.brand_group_name
        ? [
            {
              brand_group_name: brands?.[0]?.brand_group_name,
            },
          ]
        : single_brands?.push({
            brand_id:
              brands &&
              brands?.[0]?.brand_id &&
              (brands?.[0]?.brand_id
                ? brands?.[0]?.brand_id
                : brands?.[0]?.name),
            brand_name:
              brands && brands?.[0]?.brand_name && brands?.[0]?.brand_name,
          });
  } else {
    if (brands && brands?.[0]?.competitor) {
      single_brands.push({
        brand_id: brands?.[0]?.name,
        brand_name: brands?.[0]?.brand_name,
      });
    } else {
      brands &&
        brands?.forEach((el) => {
          if (el?.group || el?.brand_group_name) {
            brandsGroupName.push({
              brand_group_name: el?.brand_group_name,
            });
          }
        });

      brands?.forEach((el) => {
        if (!el?.group) {
          single_brands.push({
            brand_id: el?.brand_id ? el?.brand_id : el?.name,
            brand_name: el?.brand_name
              ? el?.brand_name
              : el?.brand_friendly_name,
          });
        }
      });
    }
  }
  return { brandsGroupName: brandsGroupName, single_brands: single_brands };
};

// export const getSimilarStaticFilterOld = (
//   hidden_filter,
//   comp_hidden_filter,
//   saved_filters,
//   quick_filter
// ) => {
//   if (
//     comp_hidden_filter?.length &&
//     hidden_filter?.length &&
//     saved_filters?.length
//   ) {
//     for (let i = 0; i < saved_filters?.length; i++) {
//       for (let j = 0; j < comp_hidden_filter?.length; j++) {
//         if (
//           saved_filters?.[i]?.attribute ===
//             comp_hidden_filter?.[j]?.attribute &&
//           comp_hidden_filter?.[j]?.attribute === hidden_filter?.[0]?.attribute
//         ) {
//           return {
//             value: true,
//             filter: [saved_filters?.[i], comp_hidden_filter?.[j]],
//           };
//         }
//       }
//     }
//   } else if (hidden_filter?.length && saved_filters?.length) {
//     for (let j = 0; j < saved_filters?.length; j++) {
//       if (saved_filters?.[j]?.attribute === hidden_filter?.[0]?.attribute) {
//         return { value: true, filter: [saved_filters?.[j]] };
//       }
//     }
//   } else if (quick_filter?.length && saved_filters?.length) {
//     for (let j = 0; j < saved_filters?.length; j++) {
//       if (saved_filters?.[j]?.attribute === quick_filter?.[0]?.attribute) {
//         return { value: true, filter: [saved_filters?.[j]] };
//       }
//     }
//   } else if (comp_hidden_filter?.length && hidden_filter?.length) {
//     for (let j = 0; j < comp_hidden_filter?.length; j++) {
//       if (
//         comp_hidden_filter?.[j]?.attribute === hidden_filter?.[0]?.attribute ||
//         saved_filters?.[j]?.attribute === quick_filter?.[0]?.attribute
//       ) {
//         return { value: true, filter: [comp_hidden_filter?.[j]] };
//       }
//     }
//   } else if (comp_hidden_filter?.length && saved_filters?.length) {
//     for (let i = 0; i < saved_filters?.length; i++) {
//       for (let j = 0; j < comp_hidden_filter?.length; j++) {
//         if (
//           saved_filters?.[i]?.attribute === comp_hidden_filter?.[j]?.attribute
//         ) {
//           return {
//             value: true,
//             filter: [saved_filters?.[i], comp_hidden_filter?.[j]],
//           };
//         }
//       }
//     }
//   }
//   return { value: false, filter: [] };
// };

export const getWindowLocationPath = () => {
  return window.location.pathname?.split("/")?.[1];
};

export const getUniqueBrandList = (brandList) => {
  let uniqueBrandIds = [];
  let uniqueBrandList = [];
  uniqueBrandList =
    brandList?.length > 0
      ? brandList?.filter((br, index) => {
          let isDuplicate = uniqueBrandIds?.includes(br?.brand_id);
          if (!isDuplicate) {
            uniqueBrandIds?.push(br?.brand_id);
            return true;
          } else {
            return false;
          }
        })
      : [];
  return uniqueBrandList;
};

export const formatDuration = (
  seconds = 0,
  timeStyle = "long",
  level = 6,
  separator = ","
) => {
  /*
    seconds : received value in seconds
    timeStyle : It's is defined style for info like : 'seconds','secs','s'
                It should be "long","medium" and "short"
    level : it is defined, how many levels used in final duration format
  */
  // Optimized code here
  if (!Number?.isInteger(seconds)) return seconds;
  if (
    seconds == null ||
    seconds == undefined ||
    seconds == "" ||
    seconds == "0"
  ) {
    return (
      "0" +
      (timeStyle === "short" ? "s" : timeStyle === "medium" ? "sec" : "second")
    );
  }
  let mobject = moment.duration(seconds, "seconds");
  const units =
    timeStyle === "short"
      ? [
          { label: "Y", duration: parseInt(mobject?.years()) },
          { label: "M", duration: parseInt(mobject?.months()) },
          { label: "D", duration: parseInt(mobject?.days()) },
          { label: "h", duration: parseInt(mobject?.hours()) },
          { label: "m", duration: parseInt(mobject?.minutes()) },
          { label: "s", duration: parseInt(mobject?.seconds()) },
        ]
      : timeStyle === "medium"
      ? [
          { label: "yr", duration: parseInt(mobject?.years()) },
          { label: "mon", duration: parseInt(mobject?.months()) },
          { label: "day", duration: parseInt(mobject?.days()) },
          { label: "hr", duration: parseInt(mobject?.hours()) },
          { label: "min", duration: parseInt(mobject?.minutes()) },
          { label: "sec", duration: parseInt(mobject?.seconds()) },
        ]
      : [
          { label: "year", duration: parseInt(mobject?.years()) },
          { label: "month", duration: parseInt(mobject?.months()) },
          { label: "day", duration: parseInt(mobject?.days()) },
          { label: "hour", duration: parseInt(mobject?.hours()) },
          { label: "minute", duration: parseInt(mobject?.minutes()) },
          { label: "second", duration: parseInt(mobject?.seconds()) },
        ];
  let durationArray = [];
  let finalDuration = "";
  let valueExists = false;
  for (let i = 0; i < units?.length; i++) {
    let unit = units[i]?.label;
    let value = units[i]?.duration;
    if (value == 0 && !valueExists) {
      continue;
    } else {
      valueExists = true;
    }

    if (
      !(
        value === 0 &&
        (unit?.startsWith("s") ||
          unit?.startsWith("sec") ||
          unit?.startsWith("second"))
      )
    ) {
      if (finalDuration) finalDuration += ", ";
      if (value > 1 && timeStyle !== "short") {
        unit += "s";
      }
      finalDuration += String(value) + "" + unit;
    }
  }

  durationArray = finalDuration?.split(",");
  let calLen = durationArray?.length;
  if (durationArray?.length > level) {
    calLen = level;
  }
  for (let i = calLen - 1; i >= 0; i--) {
    if (String(durationArray[i])?.trim()?.startsWith("0")) {
      calLen = i;
      continue;
    }
    break;
  }
  durationArray.length = calLen;
  finalDuration = durationArray?.join(separator);

  return finalDuration;
};

export const formatQuickFilters = (data, response = null) => {
  if (!data) return [];
  const ids = data?.split("&");
  const quickFiltersList = response?.data?.result || [];
  const details = ids?.map((id) => {
    let selectedObj;
    if (quickFiltersList && Array.isArray(quickFiltersList)) {
      selectedObj = quickFiltersList?.find(
        (obj) => obj?.id === id || parseInt(obj?.id) === parseInt(id)
      );
    }
    const obj = {
      name: id?.toString(),
      type: "include",
      ...((selectedObj?.name || selectedObj?.display_name) && {
        display_name: selectedObj?.name || selectedObj?.display_name,
      }),
      ...(selectedObj?.profile_icon_url && {
        profile_icon_url: selectedObj?.profile_icon_url,
      }),
      ...(selectedObj?.channel && {
        channel: selectedObj?.channel,
      }),
      ...(selectedObj?.status && {
        status: selectedObj?.status,
      }),
    };
    return obj;
  });
  return details;
};

export const getUpdatedDataSourceForExcel = (
  dataSource,
  graphConditionConfig
) => {
  let updatedDataSource = [];
  updatedDataSource = dataSource?.map((d) => {
    let obj = { ...d };
    d &&
      typeof d === "object" &&
      Object.entries(d)?.map((n) => {
        if (n[0] === "Review Ratings" || n[0] === "Ratings") {
          n[1] = n[1] + " ⭐";
          obj[n[0]] = n[1];
          return n;
        } else if (n[1]?.value >= 0) {
          if (n[1]?.percent_change) {
            n[1] = n[1]?.value + " / " + n[1]?.percent_change + "%";
          } else if (n[1]?.percent_change === 0) {
            n[1] = n[1]?.value + " / " + "NA";
          } else if (!n[1]?.percent_change) {
            n[1] = n[1]?.value;
          }
          obj[n[0]] = n[1];
          return n;
        } else if (
          typeof n[1] === "string" &&
          (n[1]?.includes("|$|") ||
            n[1]?.includes("|G|") ||
            n[1]?.includes("|C|"))
        ) {
          let channelImage = n[1]?.split("|$|")?.[0]?.trim();
          let ProfileName = n[1]?.split("|$|")?.[1]?.trim();
          let genderName = n[1]?.split("|G|")?.[1]?.trim();
          let countryName = n[1]?.split("|C|")?.[1]?.trim();
          n[1] =
            n[1]?.includes("|$|") && channelImage !== ProfileName
              ? `${channelImage} | ${ProfileName}`
              : n[1]?.includes("|$|")
              ? `${ProfileName}`
              : n[1]?.includes("|G|")
              ? `${genderName}`
              : n[1]?.includes("|C|")
              ? `${countryName}`
              : n[1];
          obj[n[0]] = n[1];
        } else if (n[0] === "Average TAT" || n[0] === "Average FLR") {
          n[1] = secondsToDhms(n[1]);
          obj[n[0]] = n[1];
          return n;
        } else {
          return n;
        }
      });
    return obj;
  });
  return updatedDataSource;
};

export const getRadiusAttributeValue = (
  graphConditions,
  chart_type,
  axis_attribute
) => {
  let radiusAttributeValue =
    graphConditions?.[chart_type]?.order_by?.include &&
    graphConditions?.[chart_type]?.order_by?.include?.length > 0
      ? graphConditions?.[chart_type]?.order_by?.exclude?.[
          axis_attribute?.toLowerCase()
        ]
        ? !graphConditions?.[chart_type]?.order_by?.exclude?.[
            axis_attribute?.toLowerCase()
          ]
          ? graphConditions?.[chart_type]?.order_by?.include?.find(
              (attr) =>
                !graphConditions?.[chart_type]?.order_by?.exclude?.[
                  axis_attribute?.toLowerCase()
                ]?.includes(attr?.value)
            )
          : graphConditions?.[chart_type]?.order_by?.include?.[0]?.value
        : graphConditions?.[chart_type]?.order_by?.include?.[0]?.value
      : null;
  return radiusAttributeValue;
};

export const calculatePercentages = (numbers) => {
  const total = numbers?.reduce((acc, num) => acc + num, 0);
  const percentages = numbers?.map(
    (num) => ((num / total) * 100).toFixed(2) + "%"
  );
  return percentages;
};

export const createCommaSeparatedTags = (tags, totalLen = 0) => {
  const seen = new Set();
  let tagsArr = tags;
  let newTags = [];
  let duplicatedExists = false;
  let maxLimitReached = false;
  let maxLimit = 20;
  let count = totalLen;
  tagsArr?.forEach((item) => {
    if (item?.includes(",")) {
      // split on commas, trim, and ignore empty strings
      const splitItems = item
        ?.split(",")
        ?.map((t) => t?.trim())
        ?.filter((t) => t !== "");

      splitItems?.forEach((splitItem) => {
        const key = splitItem?.toLowerCase();
        if (!seen.has(key)) {
          seen.add(key);
          if (count <= maxLimit - 1) {
            newTags.push(splitItem);
            count += 1;
          } else {
            maxLimitReached = true;
          }
        } else {
          duplicatedExists = true;
        }
      });
    } else {
      const key = item?.trim()?.toLowerCase();
      if (!seen.has(key)) {
        seen.add(key);
        if (count <= maxLimit - 1) {
          newTags.push(item?.trim());
          count += 1;
        } else {
          maxLimitReached = true;
        }
      } else {
        duplicatedExists = true;
      }
    }
  });
  if (duplicatedExists) {
    callNotification("Removed duplicate entries.", "info");
  }
  if (maxLimitReached) {
    callNotification("You can only add upto 20 keywords.", "info");
  }
  while (newTags?.length > 0 && newTags[newTags.length - 1]?.trim() == "") {
    newTags.pop();
  }

  return newTags;
};

export const getExcludedWords = (all, active) => {
  let result = [];
  function processGroupArray(array) {
    array?.forEach((item) => {
      let brandGroup = all?.find((group) => group?.brand_group === item);
      if (brandGroup) {
        brandGroup?.excluded_word?.forEach((word) => {
          result.push({ name: brandGroup?.brand_group, value: word });
        });
      }
    });
  }

  function processBrandArray(array) {
    array?.forEach((item) => {
      let brandGroup = all?.find(
        (group) => +group?.brand_id === item?.brand_id
      );
      if (brandGroup) {
        brandGroup?.excluded_word?.forEach((word) => {
          result.push({
            brand_id: brandGroup?.brand_id,
            value: word,
            name: brandGroup?.brand_friendly_name || brandGroup?.brand_name,
          });
        });
      }
    });
  }

  if (active?.groups?.length > 0) {
    processGroupArray(active?.groups);
  } else if (active?.brands?.length > 0) {
    processBrandArray(active?.brands);
  }
  return result;
};

const sanitizeText = (text) => {
  if (!text) return text;
  // Remove only dangerous control characters, preserve legitimate Unicode
  // Keep: \t (tab), \n (newline), \r (carriage return)
  return text
    .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F]/g, "")
    .trim();
};

export const convertMarkdownToHtml = (rawText = "", highlight = "") => {
  if (!rawText) return "";

  // Utility to decode common HTML entities
  const decodeHtmlEntities = (str) =>
    str
      .replace(/&nbsp;/g, " ")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");

  // Step 1: Decode escaped newlines and HTML entities
  let decoded = decodeHtmlEntities(rawText).replace(/\\r\\n|\\n|\\r/g, "\n");

  // Step 2: Split HTML and text content using regex
  const segments = decoded.split(/(<[^>]+>)/g); // Split between tags and text

  const regex = new RegExp(
    `([#@][a-z0-9_$&+,:;=?@|'<>.-^*()%!]+${
      highlight ? `|${highlight}` : ""
    }|[\uD83C-\uDBFF\uDC00-\uDFFF])`,
    "gi"
  );

  // Step 4: Process segments safely
  const processed = segments
    .map((segment) => {
      // If it's an HTML tag, return as is
      if (segment.startsWith("<") && segment.endsWith(">")) return segment;

      // Else, highlight matched patterns
      return segment.replace(regex, (match) => {
        const isExact =
          highlight && match.toLowerCase() === highlight.toLowerCase();
        const cls = isExact ? "highlight-keyword-text" : "text-color-primary";
        return `<span class="${cls}">${match}</span>`;
      });
    })
    .join("")
    .replace(/\n/g, "<br>"); // Convert line breaks to <br>

  // Step 5: Return final HTML
  return (
    <span
      className="html-content"
      dangerouslySetInnerHTML={{ __html: processed }}
    />
  );
};

// Content type detection configurations with Unicode support
const CONTENT_TYPE_PATTERNS = {
  email: {
    headers: /(From:|To:|Cc:|Bcc:|Subject:|Sent:|Date:|Reply-To:)/i,
    addresses: {
      anglebracket: /<[^<>]*@[^<>]+\.[a-zA-Z]{2,}[^<>]*>/g, // Must contain @ and valid domain
      multiple: /@[a-z0-9.-]+\.[a-z]{2,}/gi,
      threshold: 2, // Consider as email if 2+ email addresses found
    },
    signatures:
      /(Team [A-Z]|Assistant Professor|Department of|Best Regards|Kind Regards|Sincerely)/i,
    threadMarkers: /(wrote:|On .* wrote:)/i,
  },
  social: {
    mentions:
      /[@][a-z0-9_\u4e00-\u9fff\uac00-\ud7af]+(?![a-z0-9._-]*\.(?:com|org|net|edu|gov|mil|co|in|uk|de|fr|jp|au|ca|br|mx|es|it|nl|se|no|dk|fi|be|ch|at|pl|cz|hu|ru|cn|kr|tw|sg|hk|th|my|id|ph|vn|nz|za|ae|sa|eg|tr|gr|pt|ro|bg|hr|si|sk|lt|lv|ee|mt|cy|lu|is|mc|ad|sm|va|li|fo|gl|im|je|gg|ax))/gi,
    hashtags: /[#][a-z0-9_\u4e00-\u9fff\uac00-\ud7af]+/gi, // Includes CJK and Korean characters
    emojis: /[\uD83C-\uDBFF\uDC00-\uDFFF]/g,
  },
  professional: {
    signatures: /(CEO|CTO|Manager|Director|President|Vice President)/i,
    companies: /(Inc\.|LLC|Ltd\.|Corp\.|Company|Corporation)/i,
  },
};

// Enhanced HTML escape utility with optional parsing
const escapeHtmlChars = (text, allowSafeParsing = false) => {
  if (!text) return text;

  if (allowSafeParsing) {
    // First preserve safe HTML tags like <br>
    const safeTags = ["<br>", "<br/>", "<br />"];
    const placeholders = safeTags.map((_, index) => `__SAFE_TAG_${index}__`);
    let processedText = text;

    // Replace safe tags with placeholders
    safeTags.forEach((tag, index) => {
      const regex = new RegExp(
        tag.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
        "gi"
      );
      processedText = processedText.replace(regex, placeholders[index]);
    });

    // Escape dangerous HTML characters
    const escapeMap = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#x27;",
      "/": "&#x2F;",
    };
    processedText = processedText.replace(
      /[&<>"'/]/g,
      (char) => escapeMap[char]
    );

    // Restore safe tags
    safeTags.forEach((tag, index) => {
      const placeholderRegex = new RegExp(placeholders[index], "g");
      processedText = processedText.replace(placeholderRegex, tag);
    });

    // Parse the safe HTML
    try {
      return parse(processedText);
    } catch (error) {
      console.warn("Failed to parse escaped HTML:", error);
      return processedText;
    }
  } else {
    // Original behavior - just escape without parsing
    const escapeMap = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#x27;",
      "/": "&#x2F;",
    };
    return text.replace(/[&<>"'/]/g, (char) => escapeMap[char]);
  }
};

// Intelligent content type classifier
const classifyContentType = (text) => {
  if (!text) return "plain";

  const checks = {
    hasEmailHeaders: CONTENT_TYPE_PATTERNS.email.headers.test(text),
    hasAngleBracketEmails:
      CONTENT_TYPE_PATTERNS.email.addresses.anglebracket.test(text),
    emailCount: (
      text.match(CONTENT_TYPE_PATTERNS.email.addresses.multiple) || []
    ).length,
    hasEmailSignatures: CONTENT_TYPE_PATTERNS.email.signatures.test(text),
    hasThreadMarkers: CONTENT_TYPE_PATTERNS.email.threadMarkers.test(text),
    hasProfessionalSignatures:
      CONTENT_TYPE_PATTERNS.professional.signatures.test(text),
    hasCompanyMarkers: CONTENT_TYPE_PATTERNS.professional.companies.test(text),
  };

  // Email content detection with multiple criteria
  if (
    checks.hasEmailHeaders ||
    checks.hasAngleBracketEmails ||
    checks.emailCount >= CONTENT_TYPE_PATTERNS.email.addresses.threshold ||
    checks.hasEmailSignatures ||
    checks.hasThreadMarkers ||
    (checks.hasProfessionalSignatures && checks.emailCount > 0)
  ) {
    return "email";
  }

  // Social media content
  if (
    CONTENT_TYPE_PATTERNS.social.mentions.test(text) ||
    CONTENT_TYPE_PATTERNS.social.hashtags.test(text)
  ) {
    return "social";
  }

  return "plain";
};

// Safe parsing function with enhanced error handling
const safeHtmlParse = (htmlString, contentType = "plain") => {
  if (!htmlString) return htmlString;

  try {
    // For email content, escape dangerous chars but allow safe parsing of <br> tags
    if (contentType === "email") {
      return escapeHtmlChars(htmlString, true);
    }

    // Check for problematic patterns that could cause parsing errors
    if (htmlString.includes("<") && htmlString.includes(">")) {
      const emailPattern = /<[^>]*@[^>]*>/g;
      const invalidTagPattern =
        /<[^>]*[\.@#$%^&*()+=\[\]{}|\\:";'?/><,][^>]*>/g;

      if (emailPattern.test(htmlString) || invalidTagPattern.test(htmlString)) {
        // Use safe parsing that preserves <br> tags
        return escapeHtmlChars(htmlString, true);
      }
    }

    // Try to parse as HTML only if it looks like valid HTML
    return parse(htmlString);
  } catch (error) {
    console.warn(`HTML parsing failed for ${contentType} content:`, error);
    // Fallback with safe parsing enabled
    return escapeHtmlChars(htmlString, true);
  }
};

export const getTextWithWrapHtml = (
  text = "",
  cssClassForText = "",
  highlightWord = "",
  direction = "ltr",
  needToShowScrollableContent = false
) => {
  try {
    // console.log("Rendering text:", text);
    // Sanitize the input text
    let sanitizedText = sanitizeText(text);
    if (needToShowScrollableContent) {
      return convertMarkdownToHtml(sanitizedText, highlightWord);
    }
    // Handle \r\n characters - convert them to proper line breaks
    sanitizedText = sanitizedText
      .replace(/\\r\\n/g, "\n") // Handle escaped \r\n
      .replace(/\\n/g, "\n") // Handle escaped \n
      .replace(/\\r/g, "\n") // Handle escaped \r
      .replace(/\r\n/g, "\n") // Handle actual \r\n
      .replace(/\r/g, "\n"); // Handle actual \r
    // const regex = /([#@][a-z0-9_$&+,:;=?@|'<>.-^*()%!]*)/gi;
    // const parts = text?.split(regex);

    // Dynamically create the regex pattern to match both @ or # words and the specific highlight word
    // Construct a regex to match hashtags, mentions, and the exact phrase for highlightWord only if it’s provided

    // first one
    // Classify content type using generalized detection
    const contentType = classifyContentType(sanitizedText);
    // console.log("Content classified as:", contentType);

    // Handle email content with simple text rendering
    if (contentType === "email") {
      return (
        <span className={cssClassForText}>
          {sanitizedText?.split("\n").map((line, index) => (
            <span key={index}>
              {line}
              {index < sanitizedText?.split("\n")?.length - 1 && <br />}
            </span>
          ))}
        </span>
      );
    }

    // Create dynamic regex based on content type and highlight requirements
    const buildContentRegex = (type, highlightTerm) => {
      const patterns = [];

      if (type === "social" || type === "plain") {
        // Add hashtag pattern with Unicode support (includes CJK and Korean)
        patterns.push("[#][a-z0-9_\\u4e00-\\u9fff\\uac00-\\ud7af]+");

        // Add mention pattern (excludes email domains with comprehensive TLD list)
        // Use non-capturing group (?:...) instead of capturing group to avoid undefined splits
        patterns.push(
          "[@][a-z0-9_\\u4e00-\\u9fff\\uac00-\\ud7af]+(?![a-z0-9._-]*\\.(?:com|org|net|edu|gov|mil|co|in|uk|de|fr|jp|au|ca|br|mx|es|it|nl|se|no|dk|fi|be|ch|at|pl|cz|hu|ru|cn|kr|tw|sg|hk|th|my|id|ph|vn|nz|za|ae|sa|eg|tr|gr|pt|ro|bg|hr|si|sk|lt|lv|ee|mt|cy|lu|is|mc|ad|sm|va|li|fo|gl|im|je|gg|ax))"
        );

        // Add emoji pattern
        patterns.push("[\\uD83C-\\uDBFF\\uDC00-\\uDFFF]");
      }

      // Add highlight word if provided (escape special regex characters)
      if (highlightTerm) {
        const escapedTerm = highlightTerm.replace(
          /[.*+?^${}()|[\]\\]/g,
          "\\$&"
        );
        patterns.push(escapedTerm);
      }

      return patterns.length > 0
        ? new RegExp(`(${patterns.join("|")})`, "gi")
        : null;
    };

    const regex = buildContentRegex(contentType, highlightWord);

    // Handle content based on type and regex
    if (!regex) {
      // No patterns to match, render as simple text
      return (
        <span className={cssClassForText}>
          {sanitizedText?.split("\n").map((line, index) => (
            <span key={index}>
              {line}
              {index < sanitizedText?.split("\n")?.length - 1 && <br />}
            </span>
          ))}
        </span>
      );
    }

    const parts = String(sanitizedText)
      ?.split(regex)
      ?.filter((part) => part !== undefined && part !== null);

    return (
      <span className={cssClassForText}>
        {parts?.map((part, index) => {
          if (part?.match(regex)) {
            // Apply different styling based on content type and match type
            const isHighlightWord =
              highlightWord &&
              part?.toLowerCase() === highlightWord?.toLowerCase();

            const getPartClassName = (part, isHighlight, contentType) => {
              if (isHighlight) return "highlight-keyword-text";
              if (contentType === "social") {
                if (part.startsWith("#")) return "hashtag-text";
                if (part.startsWith("@")) return "mention-text";
              }
              return "text-color-primary";
            };

            return (
              <span
                key={index}
                className={getPartClassName(part, isHighlightWord, contentType)}
                dir={
                  direction === "rtl" && part.startsWith("@")
                    ? "ltr"
                    : undefined
                }
              >
                {part
                  ? safeHtmlParse(part.replace(/\n/g, "<br>"), contentType)
                  : part}
              </span>
            );
          } else {
            // Render non-matching parts with appropriate parsing
            return safeHtmlParse(
              part ? part.replace(/\n/g, "<br>") : part,
              contentType
            );
          }
        })}
      </span>
    );
  } catch (error) {
    console.error("Critical error in getTextWithWrapHtml:", error);
    // Ultimate fallback: return simple text
    return (
      <span className={cssClassForText}>
        {text ? String(text).replace(/[\r\n]/g, " ") : ""}
      </span>
    );
  }
};
export const isScontentLinkExpire = (mediaUrl, channelType) => {
  let isExpired = false;
  try {
    if (
      mediaUrl &&
      mediaUrl.indexOf("s3.amazonaws") == -1 &&
      mediaUrl.indexOf("images.locobuzz.com") == -1
    ) {
      const tokens = mediaUrl.split("&");
      const HexDecimalCode = tokens.filter((x) => x.includes("oe="));
      if (
        HexDecimalCode != null &&
        HexDecimalCode.length > 0 &&
        HexDecimalCode[0].startsWith("oe=")
      ) {
        let DecimalEpoch = 0;
        if (HexDecimalCode.length > 0) {
          const HexDecimalTime = HexDecimalCode[0].replace("oe=", "");
          DecimalEpoch = parseInt(HexDecimalTime, 16);
        }
        // DateTimeOffset.Now.ToUnixTimeSeconds()
        if (moment().unix() > DecimalEpoch && DecimalEpoch > 0) {
          isExpired = true;
        }
      }
    }
  } catch (exception) {
    return false;
  }

  return isExpired;
};

export const getunMaskedText = (row, info) => {
  //use this

  if (!row || Object.keys(row)?.length === 0) {
    return null;
  }

  let text = "";

  if (typeof info?.caption === "string") {
    text += info?.caption;
  }

  if (
    typeof info?.description === "string" &&
    row?.ChannelGroupId !== 1 &&
    row?.ChannelName !== "Twitter"
  ) {
    text += info?.description;
  }

  if (
    typeof info?.title === "string" &&
    typeof info?.description === "string" &&
    typeof info?.title === "string" &&
    info?.description !== info?.title
  ) {
    text += info?.title;
  }

  let mentionId = "";

  if ("PostBrandID" in row) {
    mentionId = `${row?.PostBrandID}/${row?.channel_type}/${row?.PostContentID} `;
  }

  return mentionId + text;
};

export const getPinnedTemplateDetails = (filterTemplates, pinnedFiltersIds) => {
  const pinnedTemplateDetails = filterTemplates?.filter((item) => {
    return pinnedFiltersIds?.includes(item?.filter_template_id);
  });

  return pinnedTemplateDetails;
};

export const isDeepEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true;
  if (
    typeof obj1 !== "object" ||
    typeof obj2 !== "object" ||
    obj1 === null ||
    obj2 === null
  )
    return false;

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (let key of keys1) {
    if (!keys2.includes(key) || !isDeepEqual(obj1[key], obj2[key]))
      return false;
  }

  return true;
};

// Function to check if saved array is a subset of filters array
export const isSubset = (filters, saved) => {
  return saved.every((savedItem) =>
    filters.some((filterItem) => isDeepEqual(filterItem, savedItem))
  );
};

export const isObjectEqual = (obj1, obj2) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export const updateFilters = (filters, saved) => {
  if (isSubset(filters, saved)) {
    // Remove saved items from filters
    filters = filters.filter(
      (filterItem) =>
        !saved.some((savedItem) => isDeepEqual(filterItem, savedItem))
    );
  } else {
    // Add saved items to filters
    filters = [...filters, ...saved];
  }
  return filters;
};

export const removeHiddenFromSaved = (saved, hidden) => {
  // Create a set to track indices to remove
  const indicesToRemove = new Set();

  hidden.forEach((hiddenItem) => {
    saved.forEach((savedItem, savedIndex) => {
      if (
        savedItem?.attribute?.toLowerCase() ===
        hiddenItem?.attribute?.toLowerCase()
      ) {
        if (
          hiddenItem?.attribute.toLowerCase() === "followerscount" ||
          hiddenItem?.attribute.toLowerCase() === "new_page_followers_count"
        ) {
          // Compare columns for 'followerscount'
          if (
            savedItem?.columns?.from === hiddenItem?.columns?.from &&
            savedItem?.columns?.to === hiddenItem?.columns?.to
          ) {
            indicesToRemove.add(savedIndex);
          }
        } else if (hiddenItem?.attribute?.toLowerCase() === "bio") {
          let matchFound = hiddenItem?.columns?.every((hiddenColumn) => {
            return savedItem?.columns?.some(
              (savedColumn) =>
                JSON.stringify(savedColumn.name) ===
                  JSON.stringify(hiddenColumn.name) &&
                savedColumn.type === hiddenColumn.type
            );
          });

          if (matchFound) {
            indicesToRemove.add(savedIndex);
          }
        } else if (hiddenItem?.attribute?.toLowerCase() === "simplifiedtext") {
          let matchFound = hiddenItem?.columns?.every((hiddenColumn) => {
            return savedItem?.columns?.some(
              (savedColumn) =>
                JSON.stringify(savedColumn.name) ===
                  JSON.stringify(hiddenColumn.name) &&
                savedColumn.type === hiddenColumn.type
            );
          });

          if (matchFound) {
            indicesToRemove.add(savedIndex);
          }
        } else if (hiddenItem?.attribute?.toLowerCase() === "opinions") {
          let matchFound = hiddenItem?.columns?.every((hiddenColumn) => {
            return savedItem?.columns?.some(
              (savedColumn) =>
                JSON.stringify(savedColumn.name) ===
                  JSON.stringify(hiddenColumn.name) &&
                savedColumn.type === hiddenColumn.type
            );
          });

          if (matchFound) {
            indicesToRemove.add(savedIndex);
          }
        } else if (hiddenItem?.attribute?.toLowerCase() === "opinion_v2") {
          let matchFound = hiddenItem?.columns?.every((hiddenColumn) => {
            return savedItem?.columns?.some(
              (savedColumn) =>
                JSON.stringify(savedColumn.name) ===
                  JSON.stringify(hiddenColumn.name) &&
                savedColumn.type === hiddenColumn.type
            );
          });

          if (matchFound) {
            indicesToRemove.add(savedIndex);
          }
        } else if (hiddenItem?.attribute?.toLowerCase() === "aspect_groups") {
          let matchFound = hiddenItem?.columns?.every((hiddenColumn) => {
            return savedItem?.columns?.some(
              (savedColumn) =>
                JSON.stringify(savedColumn.name) ===
                  JSON.stringify(hiddenColumn.name) &&
                savedColumn.type === hiddenColumn.type
            );
          });

          if (matchFound) {
            indicesToRemove.add(savedIndex);
          }
        } else if (hiddenItem?.attribute?.toLowerCase() === "aspect_v2") {
          let matchFound = hiddenItem?.columns?.every((hiddenColumn) => {
            return savedItem?.columns?.some(
              (savedColumn) =>
                JSON.stringify(savedColumn.name) ===
                  JSON.stringify(hiddenColumn.name) &&
                savedColumn.type === hiddenColumn.type
            );
          });

          if (matchFound) {
            indicesToRemove.add(savedIndex);
          }
        } else if (hiddenItem?.attribute?.toLowerCase() === "aspects") {
          let matchFound = hiddenItem?.columns?.every((hiddenColumn) => {
            return savedItem?.columns?.some(
              (savedColumn) =>
                JSON.stringify(savedColumn.name) ===
                  JSON.stringify(hiddenColumn.name) &&
                savedColumn.type === hiddenColumn.type
            );
          });

          if (matchFound) {
            indicesToRemove.add(savedIndex);
          }
        } else if (hiddenItem?.attribute?.toLowerCase() === "opinion_group") {
          let matchFound = hiddenItem?.columns?.every((hiddenColumn) => {
            return savedItem?.columns?.some(
              (savedColumn) =>
                JSON.stringify(savedColumn.name) ===
                  JSON.stringify(hiddenColumn.name) &&
                savedColumn.type === hiddenColumn.type
            );
          });

          if (matchFound) {
            indicesToRemove.add(savedIndex);
          }
        } else if (hiddenItem?.attribute?.toLowerCase() === "hashtags") {
          let matchFound = hiddenItem?.columns?.every((hiddenColumn) => {
            return savedItem?.columns?.some(
              (savedColumn) =>
                JSON.stringify(savedColumn.name) ===
                  JSON.stringify(hiddenColumn.name) &&
                savedColumn.type === hiddenColumn.type
            );
          });

          if (matchFound) {
            indicesToRemove.add(savedIndex);
          }
        } else if (hiddenItem?.attribute?.toLowerCase() === "tagcloud") {
          let matchFound = hiddenItem?.columns?.every((hiddenColumn) => {
            return savedItem?.columns?.some(
              (savedColumn) =>
                JSON.stringify(savedColumn.name) ===
                  JSON.stringify(hiddenColumn.name) &&
                savedColumn.type === hiddenColumn.type
            );
          });

          if (matchFound) {
            indicesToRemove.add(savedIndex);
          }
        } else {
          // Handle other attributes
          let columnsToRemove = [];
          if (Array.isArray(hiddenItem?.columns)) {
            hiddenItem?.columns.forEach((hiddenColumn) => {
              const columnIndex = savedItem?.columns?.findIndex(
                (savedColumn) =>
                  savedColumn?.name === hiddenColumn?.name &&
                  savedColumn.type === hiddenColumn.type
              );
              if (columnIndex > -1) {
                columnsToRemove.push(columnIndex);
              }
            });
          }

          // Remove matched columns
          if (columnsToRemove.length > 0) {
            columnsToRemove
              .sort((a, b) => b - a)
              .forEach((index) => savedItem?.columns?.splice(index, 1));

            // If no columns are left, mark the whole object for removal
            if (savedItem?.columns?.length === 0) {
              indicesToRemove.add(savedIndex);
            }
          }
        }
      }
    });
  });

  // Remove items from saved array based on indices
  saved = saved.filter((_, index) => !indicesToRemove.has(index));

  return saved;
};

export const mergeArrays = (arr1, arr2) => {
  const mergedArray = [...arr1];

  arr2.forEach((item2) => {
    const index = mergedArray.findIndex(
      (item1) =>
        item1.attribute?.toLowerCase() === item2.attribute?.toLowerCase()
    );

    if (item2.attribute?.toLowerCase() === "followerscount") {
      const followersIndex = mergedArray.findIndex(
        (item) => item.attribute?.toLowerCase() === "followerscount"
      );
      if (followersIndex > -1) {
        // Check if the existing item is the same as the new item
        const existingItem = mergedArray[followersIndex];
        if (
          JSON.stringify(existingItem.columns) !== JSON.stringify(item2.columns)
        ) {
          mergedArray.push(item2);
        }
      } else {
        mergedArray.push(item2);
      }
    } else if (item2.attribute === "new_page_followers_count") {
      const followersIndex = mergedArray.findIndex(
        (item) => item.attribute === "new_page_followers_count"
      );
      if (followersIndex > -1) {
        // Check if the existing item is the same as the new item
        const existingItem = mergedArray[followersIndex];
        if (
          JSON.stringify(existingItem.columns) !== JSON.stringify(item2.columns)
        ) {
          mergedArray.push(item2);
        }
      } else {
        mergedArray.push(item2);
      }
    } else if (item2.attribute === "bio") {
      const bioIndex = mergedArray.findIndex(
        (item) => item.attribute === "bio"
      );
      if (bioIndex > -1) {
        const existingBio = mergedArray[bioIndex];
        const match = existingBio.columns.every(
          (col1, index) =>
            JSON.stringify(col1.name) ===
              JSON.stringify(item2.columns[index]?.name) &&
            col1.type === item2.columns[index]?.type
        );
        if (!match) {
          mergedArray.push(item2);
        }
      } else {
        mergedArray.push(item2);
      }
    } else if (item2.attribute?.toLowerCase() === "simplifiedtext") {
      const simplifiedtextIndex = mergedArray.findIndex(
        (item) => item.attribute?.toLowerCase() === "simplifiedtext"
      );
      if (simplifiedtextIndex > -1) {
        const existingText = mergedArray[simplifiedtextIndex];
        const match = existingText?.columns.every(
          (col1, index) =>
            JSON.stringify(col1.name) ===
              JSON.stringify(item2.columns[index]?.name) &&
            col1.type === item2.columns[index]?.type
        );
        if (!match) {
          mergedArray.push(item2);
        }
      } else {
        mergedArray.push(item2);
      }
    } else if (item2.attribute === "Opinions") {
      const opinionsIndex = mergedArray.findIndex(
        (item) => item.attribute === "Opinions"
      );
      if (opinionsIndex > -1) {
        const existingOpinion = mergedArray[opinionsIndex];
        const match = existingOpinion?.columns.every(
          (col1, index) =>
            JSON.stringify(col1.name) ===
              JSON.stringify(item2.columns[index]?.name) &&
            col1.type === item2.columns[index]?.type
        );
        if (!match) {
          mergedArray.push(item2);
        }
      } else {
        mergedArray.push(item2);
      }
    } else if (item2.attribute?.toLowerCase() === "opinion_v2") {
      const opinionv2Index = mergedArray.findIndex(
        (item) => item.attribute?.toLowerCase() === "opinion_v2"
      );
      if (opinionv2Index > -1) {
        const existingOpinionv2 = mergedArray[opinionv2Index];
        const match = existingOpinionv2?.columns.every(
          (col1, index) =>
            JSON.stringify(col1.name) ===
              JSON.stringify(item2.columns[index]?.name) &&
            col1.type === item2.columns[index]?.type
        );
        if (!match) {
          mergedArray.push(item2);
        }
      } else {
        mergedArray.push(item2);
      }
    } else if (item2.attribute === "aspect_groups") {
      const aspectIndex = mergedArray.findIndex(
        (item) => item.attribute === "aspect_groups"
      );
      if (aspectIndex > -1) {
        const existingOpinionv2 = mergedArray[aspectIndex];
        const match = existingOpinionv2?.columns.every(
          (col1, index) =>
            JSON.stringify(col1.name) ===
              JSON.stringify(item2.columns[index]?.name) &&
            col1.type === item2.columns[index]?.type
        );
        if (!match) {
          mergedArray.push(item2);
        }
      } else {
        mergedArray.push(item2);
      }
    } else if (item2.attribute === "aspect_v2") {
      const aspectIndex = mergedArray.findIndex(
        (item) => item.attribute === "aspect_v2"
      );
      if (aspectIndex > -1) {
        const existingOpinionv2 = mergedArray[aspectIndex];
        const match = existingOpinionv2?.columns.every(
          (col1, index) =>
            JSON.stringify(col1.name) ===
              JSON.stringify(item2.columns[index]?.name) &&
            col1.type === item2.columns[index]?.type
        );
        if (!match) {
          mergedArray.push(item2);
        }
      } else {
        mergedArray.push(item2);
      }
    } else if (item2.attribute === "Aspects") {
      const aspectIndex = mergedArray.findIndex(
        (item) => item.attribute === "Aspects"
      );
      if (aspectIndex > -1) {
        const existingOpinionv2 = mergedArray[aspectIndex];
        const match = existingOpinionv2?.columns.every(
          (col1, index) =>
            JSON.stringify(col1.name) ===
              JSON.stringify(item2.columns[index]?.name) &&
            col1.type === item2.columns[index]?.type
        );
        if (!match) {
          mergedArray.push(item2);
        }
      } else {
        mergedArray.push(item2);
      }
    } else if (item2.attribute === "opinion_group") {
      const opinionIndex = mergedArray.findIndex(
        (item) => item.attribute === "opinion_group"
      );
      if (opinionIndex > -1) {
        const existingOpinionv2 = mergedArray[opinionIndex];
        const match = existingOpinionv2?.columns.every(
          (col1, index) =>
            JSON.stringify(col1.name) ===
              JSON.stringify(item2.columns[index]?.name) &&
            col1.type === item2.columns[index]?.type
        );
        if (!match) {
          mergedArray.push(item2);
        }
      } else {
        mergedArray.push(item2);
      }
    } else if (item2.attribute === "Hashtags") {
      const hashtagsIndex = mergedArray.findIndex(
        (item) => item.attribute === "Hashtags"
      );
      if (hashtagsIndex > -1) {
        const existingOpinionv2 = mergedArray[hashtagsIndex];
        const match = existingOpinionv2?.columns.every(
          (col1, index) =>
            JSON.stringify(col1.name) ===
              JSON.stringify(item2.columns[index]?.name) &&
            col1.type === item2.columns[index]?.type
        );
        if (!match) {
          mergedArray.push(item2);
        }
      } else {
        mergedArray.push(item2);
      }
    } else if (item2.attribute === "TagCloud") {
      const tagcloudIndex = mergedArray.findIndex(
        (item) => item.attribute === "TagCloud"
      );
      if (tagcloudIndex > -1) {
        const existingOpinionv2 = mergedArray[tagcloudIndex];
        const match = existingOpinionv2?.columns.every(
          (col1, index) =>
            JSON.stringify(col1.name) ===
              JSON.stringify(item2.columns[index]?.name) &&
            col1.type === item2.columns[index]?.type
        );
        if (!match) {
          mergedArray.push(item2);
        }
      } else {
        mergedArray.push(item2);
      }
    } else if (index > -1) {
      const mergedColumns = [...mergedArray[index].columns];

      item2.columns.forEach((column2) => {
        const exists = mergedColumns.some(
          (column1) =>
            column1.name === column2.name && column1.type === column2.type
        );

        if (!exists) {
          mergedColumns.push(column2);
        }
      });

      mergedArray[index].columns = mergedColumns;
    } else {
      mergedArray.push(item2);
    }
  });

  return mergedArray;
};

export const isSameFilterDiffTypes = (filtersA, filtersB) => {
  for (const filterB of filtersB) {
    const filterA = filtersA.find(
      (filter) =>
        filter.attribute?.toLowerCase() === filterB.attribute?.toLowerCase()
    );
    try {
      if (filterA) {
        if (
          filterB.attribute.toLowerCase() === "followerscount" &&
          filterA.attribute.toLowerCase() === "followerscount"
        ) {
          return true;
        } else if (
          filterB.attribute === "new_page_followers_count" &&
          filterA.attribute === "new_page_followers_count"
        ) {
          return true;
        } else if (filterB.attribute === "bio" && filterA.attribute === "bio") {
          return true;
        } else if (
          filterB.attribute?.toLowerCase() === "simplifiedtext" &&
          filterA.attribute?.toLowerCase() === "simplifiedtext"
        ) {
          return true;
        } else if (
          filterB.attribute === "Opinions" &&
          filterA.attribute === "Opinions"
        ) {
          return true;
        } else if (
          filterB.attribute?.toLowerCase() === "opinion_v2" &&
          filterA.attribute?.toLowerCase() === "opinion_v2"
        ) {
          return true;
        } else if (
          filterB.attribute === "aspect_groups" &&
          filterA.attribute === "aspect_groups"
        ) {
          return true;
        } else if (
          filterB.attribute === "aspect_v2" &&
          filterA.attribute === "aspect_v2"
        ) {
          return true;
        } else if (
          filterB.attribute === "Aspects" &&
          filterA.attribute === "Aspects"
        ) {
          return true;
        } else if (
          filterB.attribute === "opinion_group" &&
          filterA.attribute === "opinion_group"
        ) {
          return true;
        } else if (
          filterB.attribute === "Hashtags" &&
          filterA.attribute === "Hashtags"
        ) {
          return true;
        } else if (
          filterB.attribute === "TagCloud" &&
          filterA.attribute === "TagCloud"
        ) {
          return true;
        } else {
          for (const columnB of filterB.columns) {
            const columnA = filterA.columns.find(
              (column) => column.name === columnB.name
            );
            if (columnA && columnA.type !== columnB.type) {
              return true;
            }
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  return false;
};
// If magnitude value in positive then it will calculate lighter color
// else calculate darker color
const calculateNewShadeOfColor = (hexColor, magnitude) => {
  hexColor = hexColor?.replace(`#`, ``);
  if (hexColor?.length < 6) {
    for (let i = hexColor?.length; i < 6; i++) {
      hexColor += "0";
    }
  }
  if (hexColor?.length === 6) {
    const decimalColor = parseInt(hexColor, 16);
    let r = (decimalColor >> 16) + magnitude;
    r > 255 && (r = 255);
    r < 0 && (r = 0);
    let g = (decimalColor & 0x0000ff) + magnitude;
    g > 255 && (g = 255);
    g < 0 && (g = 0);
    let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
    b > 255 && (b = 255);
    b < 0 && (b = 0);
    return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
  } else {
    return "#" + hexColor;
  }
};
export const newColorShadeInHex6 = (hexColor, magnitude, isDark = true) => {
  if (!isDark) {
    magnitude = -1 * magnitude;
  }
  let newColor = calculateNewShadeOfColor(hexColor, magnitude);
  newColor = newColor?.replace(`#`, ``);
  if (newColor?.length < 6) {
    for (let i = newColor?.length; i < 6; i++) {
      newColor += "0";
    }
  }
  return "#" + newColor;
};
export const hexToGrayscale = (hex) => {
  // Remove the leading # if present
  hex = hex.replace(/^#/, "");

  // Convert hex to RGB
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Calculate luminance (simple average method)
  let luminance = Math.round((r + g + b) / 3);

  // Convert luminance to hex
  let grayscale = luminance.toString(16).padStart(2, "0");

  // Return the grayscale color in hex format
  return `#${grayscale}${grayscale}${grayscale}`;
};

export const addChannelAndBrand = (myArr, filterData) => {
  // Iterate through each object in myArr
  myArr?.length &&
    myArr?.forEach((myObj) => {
      // Find the matching filterData object with the same attribute
      const matchingFilter = filterData?.find(
        (filter) => filter?.attribute === myObj?.attribute
      );

      if (matchingFilter) {
        myObj?.columns?.forEach((column) => {
          // Find the index of the display_name in the filter's values array
          const index = matchingFilter?.values?.indexOf(column?.display_name);

          if (index !== -1) {
            // If a match is found, get the corresponding id object from filterData
            const idObject = matchingFilter?.id?.[index];

            // Append channel_group_id and brand_id to the myObj column object
            if (idObject) {
              column.channel_group_id = idObject?.channel_group_id || null;
              column.brand_id = idObject?.brand_id || null;
            }
          }
        });
      }
    });

  return myArr;
};

export const trimDecimal = (input) => {
  // Ensure the input is a string
  let numStr = input?.toString();

  // Check if there is a decimal point
  if (numStr?.includes(".")) {
    // Remove any commas if present (only if there is a decimal point)
    numStr = numStr.replace(/,/g, "");

    // Split the string at the decimal point
    let [integerPart, decimalPart] = numStr.split(".");

    // Trim the decimal part to two digits
    decimalPart = decimalPart?.slice(0, 2);

    // Construct the final number string with trimmed decimals
    let finalStr = `${integerPart}.${decimalPart}`;

    // If the original input was a number, return in toLocaleString format
    return parseFloat(finalStr)?.toLocaleString();
  }

  // If no decimal point, return the input as is (commas retained)
  return input;
};

export const generateTimeOptions = () => {
  const times = [];
  let hour = 1;
  let minute = 0;

  while (hour <= 23 || minute <= 30) {
    const ampm = hour >= 12 ? "PM" : "AM";
    const displayHour = hour % 12 === 0 ? 12 : hour % 12;
    const displayMinute = minute === 0 ? "00" : "30";
    times.push(`${displayHour}:${displayMinute} ${ampm}`);

    if (minute === 30) {
      hour += 1;
      minute = 0;
    } else {
      minute = 30;
    }

    if (hour === 24) break;
  }
  return times;
};

export const generateExcelData = (
  graphConditionConfig,
  widgetMetadata,
  excelData,
  allAttributes
) => {
  const globalChartColor = [
    "#6060FF",
    "#9D48FF",
    "#FF00FF",
    "#DFAAAA",
    "#29CFCF",
    "#FF7D6C",
    "#FF7D6C",
    "#CD97FF",
    "#FFD58B",
    "#75FF75",
    "#FFC0CB",
    "#C66060",
    "#A5A5DC",
    "#00A669",
    "#00A669",
    "#9898FF",
    "#EEEE52",
    "#FF83F7",
    "#3FE7AC",
    "#B600AA",
    "#39A7E4",
    "#6600DA",
    "#FFB940",
    "#FF4040",
    "#24E224",
    "#FFDB4D",
    "#CE9ECE",
    "#1C9F00",
    "#FFC1B9",
    "#FF9C73",
    "#5656B2",
    "#FF6E31",
    "#9FE9E9",
  ];
  if (
    widgetMetadata?.chart?.chart_type === "bar" ||
    widgetMetadata?.chart?.chart_type === "lollipop"
  ) {
    let graphObject = { single: [], xaxis: null, yaxis: null };
    graphObject.xaxis =
      widgetMetadata?.x_axis?.trace_name ||
      allAttributes[widgetMetadata?.x_axis?.attribute] ||
      widgetMetadata?.x_axis?.attribute;
    graphObject.yaxis =
      widgetMetadata?.y_series?.[0]?.trace_name ||
      widgetMetadata?.y_axis?.y_series_1?.trace_name;
    if (
      widgetMetadata?.graphData?.data?.[widgetMetadata?.chart?.chart_type]?.[0]
        ?.y_axis ||
      excelData?.[0]?.y_axis
    ) {
      widgetMetadata.chart.original_chart_type =
        widgetMetadata.chart.chart_type; // storing original chart type to replace later in combination condition after procesing
      widgetMetadata.chart.chart_type = "combination";
      widgetMetadata.turnedcombination = true; // identifier that its type changed for procesing
      return generateExcelData(
        graphConditionConfig,
        widgetMetadata,
        excelData,
        allAttributes
      );
    }
    graphObject.single[0] =
      widgetMetadata?.graphData?.data?.[widgetMetadata?.chart?.chart_type][0]
        ?.data?.[0] || excelData?.[0]?.data?.[0];
    if (graphObject?.single[0]?.data) {
      let j = 0;
      let noOfIterationInColors = 0;
      let lengthOfColors = globalChartColor?.length;
      let yAxisData = graphObject?.single?.map((e) => {
        return e?.data?.map((el, i) => {
          let dataColor;
          if (
            el?.color !== undefined &&
            el?.color !== "#000000" &&
            el?.color !== null
          ) {
            dataColor = el?.color;
          } else {
            if (j >= lengthOfColors) {
              noOfIterationInColors = parseInt(j / lengthOfColors);
              let rem = parseInt(j % lengthOfColors);
              dataColor =
                noOfIterationInColors > 0
                  ? newColorShadeInHex6(
                      globalChartColor[rem],
                      parseInt(noOfIterationInColors * 5)
                    )
                  : globalChartColor[j];
            } else {
              dataColor = globalChartColor[j];
            }
            j++;
          }
          let lighterColor = widgetMetadata?.chart?.chart_settings
            ?.gradient_color
            ? newColorShadeInHex6(dataColor, 60)
            : null;
          let darkerColor = dataColor;
          return {
            name: el?.name,
            data: el?.y,
            color: graphObject?.chartGradientColor
              ? {
                  linearGradient: {
                    x1: 0,
                    x2: 0,
                    y1: 0,
                    y2: 1,
                  },
                  stops: [
                    [0, darkerColor],
                    [1, lighterColor],
                  ],
                }
              : dataColor,
            attribute: el?.attribute,
            connectorColor: darkerColor,
          };
        });
      });

      let multiData = yAxisData[0];
      let tempMultidata = [];
      let showPercentChart =
        widgetMetadata?.chart?.chart_settings?.chart_percent;
      if (showPercentChart) {
        // storing in separate array for percent chart
        multiData.forEach((data) => {
          tempMultidata.push(data);
          const perCentKeys = {
            ...data,
            name: `${data.name} Percent`, // created new key with Percent as suffix
          };
          tempMultidata.push(perCentKeys);
        });
        let percentage = multiData.map((data) => {
          return {
            ...data,
            percent: [],
          };
        });
        for (let i = 0; i < multiData[0].data.length; i++) {
          let total = multiData.reduce((acc, cur) => acc + cur.data[i], 0);
          multiData.forEach((item, index) => {
            let percent = ((item.data[i] / total) * 100).toFixed(1) + "%";
            percentage[index].percent.push(percent);
          });
        }
        let newArr = [];
        let percInd = 0;
        for (let i = 0; i < tempMultidata.length; i++) {
          if (i % 2 == 0) {
            newArr.push(tempMultidata[i]);
          } else {
            let data = percentage[percInd].percent;
            tempMultidata[i].data = data;
            newArr.push(tempMultidata[i]);
            percInd++;
          }
        }
        multiData = newArr;
        //to add percent column at the end of excel
        const percentItems = multiData.filter((item) =>
          item?.name?.includes("Percent")
        );
        const nonPercentItems = multiData.filter(
          (item) => !item?.name?.includes("Percent")
        );
        multiData = [...nonPercentItems, ...percentItems];
      }

      let columns = [
        {
          title: graphObject?.xaxis,
          dataIndex: graphObject?.xaxis,
        },
      ];
      let datasource = [];
      let lengthOfMultiData = multiData?.length;
      let lengthOfColumns = lengthOfMultiData + 1;
      for (let i = 0; i < lengthOfColumns; i++) {
        if (i == 0) {
          graphObject?.single[0]?.x?.forEach((xElem, x_index) => {
            datasource[x_index] = { [columns[i]?.title]: xElem };
          });
        } else {
          columns[i] = {
            title: multiData[i - 1]?.name,
            dataIndex: multiData[i - 1]?.name,
          };
          multiData[i - 1]?.data?.forEach((data, data_index) => {
            datasource[data_index] = {
              ...datasource[data_index],
              [columns[i]?.title]: false
                ? SecondstoHumanReadable(data)
                : isNaN(Number(data))
                ? data?.toString().includes("NaN")
                  ? Number(0)
                  : data
                : Number(data), // data
            };
          });
        }
      }

      return { columns, datasource };
    } else {
      let columns = [
        {
          title: graphObject?.xaxis,
          dataIndex: graphObject?.xaxis,
        },
        {
          title: graphObject?.yaxis,
          dataIndex: graphObject?.yaxis,
        },
        {
          title: graphObject?.yaxis + " Percent",
          dataIndex: graphObject?.yaxis + " Percent",
        },
      ];

      let percentNums = graphObject?.single[0]?.y;
      let percentages = calculatePercentages(percentNums);

      let datasource = graphObject?.single[0]?.y?.map((yElem, i) => {
        return {
          [columns[0]?.title]: graphObject?.single[0]?.x[i],
          [columns[1]?.title]: false
            ? SecondstoHumanReadable(yElem)
            : isNaN(Number(yElem))
            ? yElem?.toString().includes("NaN")
              ? Number(0)
              : yElem
            : Number(yElem), // yElem
          [columns[2]?.title]: percentages[i],
        };
      });
      return { columns, datasource };
    }
  } else if (widgetMetadata?.chart?.chart_type === "wordcloud") {
    let graphObject = {};
    graphObject.xaxis = widgetMetadata?.x_axis?.trace_name;
    graphObject.yaxis =
      widgetMetadata?.y_series?.[0]?.trace_name ||
      widgetMetadata?.y_axis?.y_series_1?.trace_name;
    graphObject.single =
      widgetMetadata?.graphData?.data?.[widgetMetadata?.chart?.chart_type][0]
        ?.data || excelData?.[0]?.data;
    let columns = [
      {
        title: graphObject?.xaxis,
        dataIndex: graphObject?.xaxis,
      },
      {
        title: graphObject?.yaxis,
        dataIndex: graphObject?.yaxis,
      },
    ];

    let datasource = graphObject?.single?.map((el, i) => {
      return {
        [columns[0]?.title]: el?.text,
        [columns[1]?.title]:
          el?.value?.toLocaleString() + " | " + el?.percent + "%",
      };
    });
    return { columns, datasource };
  } else if (
    widgetMetadata?.chart?.chart_type === "pie" ||
    widgetMetadata?.chart?.chart_type === "donut"
  ) {
    let graphObject = {};
    graphObject.xaxis = widgetMetadata?.x_axis?.trace_name;
    graphObject.yaxis =
      widgetMetadata?.y_series?.[0]?.trace_name ||
      widgetMetadata?.y_axis?.y_series_1?.trace_name;
    graphObject.single =
      widgetMetadata?.graphData?.data?.[widgetMetadata?.chart?.chart_type][0]
        ?.data || excelData?.[0]?.data;
    let columns = [
      {
        title: graphObject?.xaxis,
        dataIndex: graphObject?.xaxis,
      },
      {
        title: graphObject?.yaxis,
        dataIndex: graphObject?.yaxis,
      },
    ];

    let datasource = graphObject?.single?.map((el, i) => {
      return {
        [columns[0]?.title]: el?.name,
        [columns[1]?.title]: isNaN(Number(el?.y))
          ? el?.y?.toString().includes("NaN")
            ? Number(0)
            : el?.y
          : Number(el?.y), // el?.y
      };
    });
    return { columns, datasource };
  } else if (widgetMetadata?.chart?.chart_type === "line") {
    let graphObject = { single: [], xaxis: null, yaxis: null };
    graphObject.xaxis = widgetMetadata?.x_axis?.trace_name;
    graphObject.yaxis =
      widgetMetadata?.y_series?.[0]?.trace_name ||
      widgetMetadata?.y_axis?.y_series_1?.trace_name;
    if (
      widgetMetadata?.graphData?.data?.[widgetMetadata?.chart?.chart_type]?.[0]
        ?.y_axis ||
      excelData?.[0]?.y_axis
    ) {
      widgetMetadata.chart.original_chart_type =
        widgetMetadata.chart.chart_type; // storing original chart type to replace later in combination condition after procesing
      widgetMetadata.chart.chart_type = "combination";
      widgetMetadata.turnedcombination = true; // identifier that its type changed for procesing
      return generateExcelData(
        graphConditionConfig,
        widgetMetadata,
        excelData,
        allAttributes
      );
    }
    graphObject.single[0] =
      widgetMetadata?.graphData?.data?.[widgetMetadata?.chart?.chart_type][0]
        ?.data?.[0] || excelData?.[0]?.data?.[0];
    if (graphObject?.single[0]?.data) {
      let columns = [
        {
          title: graphObject?.xaxis,
          dataIndex: graphObject?.xaxis,
        },
      ];
      let datasource = [];
      let multiData = [];
      let j = 0;
      let noOfIterationInColors = 0;
      let lengthOfColors = globalChartColor?.length;
      graphObject?.single[0]?.data?.map((d, i) => {
        let dataColor;
        if (
          d?.color !== undefined &&
          d?.color !== "#000000" &&
          d?.color !== null
        ) {
          dataColor = d?.color;
        } else {
          if (j >= lengthOfColors) {
            noOfIterationInColors = parseInt(j / lengthOfColors);
            let rem = parseInt(j % lengthOfColors);
            dataColor =
              noOfIterationInColors > 0
                ? newColorShadeInHex6(
                    globalChartColor[rem],
                    parseInt(noOfIterationInColors * 5)
                  )
                : globalChartColor[j];
          } else {
            dataColor = globalChartColor[j];
          }
          j++;
        }
        if (d?.attribute === "Rating") {
          multiData.push({
            name: `${d?.name} ⭐`,
            data: d?.y,
            color: `${dataColor}99`,
            dashStyle: "Solid",
            lineWidth: 3,
            fillColor: {
              linearGradient: [0, 0, 0, 300],
              stops: [
                [0, `${dataColor}99`],
                [1, `${dataColor}1a`],
              ],
            },
          });
        } else {
          multiData.push({
            name: d?.name,
            data: d?.y,
            dashStyle: "Solid",
            lineWidth: 3,
            fillColor: {
              linearGradient: [0, 0, 0, 300],
              stops: [
                [0, `${dataColor}99`],
                [1, `${dataColor}1a`],
              ],
            },
            color: `${dataColor}99`,
          });
        }
      });
      let lengthOfMultiData = multiData?.length;
      let lengthOfColumns = lengthOfMultiData + 1;
      for (let i = 0; i < lengthOfColumns; i++) {
        if (i == 0) {
          graphObject?.single?.[0]?.x?.forEach((xElem, x_index) => {
            datasource[x_index] = { [columns[i]?.title]: xElem };
          });
        } else {
          if (multiData[i - 1]?.name?.includes("|$|")) {
            let ProfileName = multiData[i - 1]?.name?.split("|$|")?.[1]?.trim();
            let channelName = multiData[i - 1]?.name?.split("|$|")?.[0]?.trim();
            columns[i] = {
              title: channelName + " | " + ProfileName,
              dataIndex: multiData[i - 1]?.name,
            };
          } else if (multiData[i - 1]?.name?.includes("|G|")) {
            let genderName = multiData[i - 1]?.name?.split("|G|")?.[1]?.trim();

            columns[i] = {
              title: genderName,
              dataIndex: multiData[i - 1]?.name,
            };
          } else if (multiData[i - 1]?.name?.includes("|C|")) {
            let countryName = multiData[i - 1]?.name?.split("|C|")?.[1]?.trim();

            columns[i] = {
              title: countryName,
              dataIndex: multiData[i - 1]?.name,
            };
          } else {
            columns[i] = {
              title: multiData[i - 1]?.name,
              dataIndex: multiData[i - 1]?.name,
            };
          }
          multiData[i - 1]?.data?.forEach((data, data_index) => {
            datasource[data_index] = {
              ...datasource[data_index],
              [columns[i]?.dataIndex]: false
                ? SecondstoHumanReadable(data)
                : isNaN(Number(data))
                ? data?.toString().includes("NaN")
                  ? Number(0)
                  : data
                : Number(data), // data
            };
          });
        }
      }
      return { columns, datasource };
    } else {
      let columns = [
        {
          title: graphObject?.xaxis,
          dataIndex: graphObject?.xaxis,
        },
        {
          title: graphObject?.yaxis,
          dataIndex: graphObject?.yaxis,
        },
      ];

      let datasource = graphObject?.single[0]?.y?.map((yElem, i) => {
        return {
          [columns[0]?.title]: graphObject?.single[0]?.x[i],
          [columns[1]?.title]: false
            ? SecondstoHumanReadable(yElem)
            : isNaN(Number(yElem))
            ? yElem?.toString().includes("NaN")
              ? Number(0)
              : yElem
            : Number(yElem), // yElem
        };
      });
      return { columns, datasource };
    }
  } else if (widgetMetadata?.chart?.chart_type === "area") {
    let graphObject = { single: [], xaxis: null, yaxis: null };
    graphObject.xaxis = widgetMetadata?.x_axis?.trace_name;
    graphObject.yaxis =
      widgetMetadata?.y_series?.[0]?.trace_name ||
      widgetMetadata?.y_axis?.y_series_1?.trace_name;
    if (
      widgetMetadata?.graphData?.data?.[widgetMetadata?.chart?.chart_type]?.[0]
        ?.y_axis ||
      excelData?.[0]?.y_axis
    ) {
      widgetMetadata.chart.original_chart_type =
        widgetMetadata.chart.chart_type; // storing original chart type to replace later in combination condition after procesing
      widgetMetadata.chart.chart_type = "combination";
      widgetMetadata.turnedcombination = true; // identifier that its type changed for procesing
      return generateExcelData(
        graphConditionConfig,
        widgetMetadata,
        excelData,
        allAttributes
      );
    }
    graphObject.single[0] =
      widgetMetadata?.graphData?.data?.[widgetMetadata?.chart?.chart_type][0]
        ?.data?.[0] || excelData?.[0]?.data?.[0];
    if (graphObject?.single[0]?.data) {
      let columns = [
        {
          title: graphObject?.xaxis,
          dataIndex: graphObject?.xaxis,
        },
      ];
      let datasource = [];
      let multiData = [];
      let j = 0;
      let noOfIterationInColors = 0;
      let lengthOfColors = globalChartColor?.length;
      graphObject?.single[0]?.data?.map((d, i) => {
        let dataColor;
        if (
          d?.color !== undefined &&
          d?.color !== "#000000" &&
          d?.color !== null
        ) {
          dataColor = d?.color;
        } else {
          if (j >= lengthOfColors) {
            noOfIterationInColors = parseInt(j / lengthOfColors);
            let rem = parseInt(j % lengthOfColors);
            dataColor =
              noOfIterationInColors > 0
                ? newColorShadeInHex6(
                    globalChartColor[rem],
                    parseInt(noOfIterationInColors * 5)
                  )
                : globalChartColor[j];
          } else {
            dataColor = globalChartColor[j];
          }
          j++;
        }
        if (d?.attribute === "Rating") {
          multiData.push({
            name: `${d?.name} ⭐`,
            data: d?.y,
            color: `${dataColor}99`,
            dashStyle: "Solid",
            lineWidth: 3,
            fillColor: {
              linearGradient: [0, 0, 0, 300],
              stops: [
                [0, `${dataColor}99`],
                [1, `${dataColor}1a`],
              ],
            },
          });
        } else {
          multiData.push({
            name: d?.name,
            data: d?.y,
            dashStyle: "Solid",
            lineWidth: 3,
            fillColor: {
              linearGradient: [0, 0, 0, 300],
              stops: [
                [0, `${dataColor}99`],
                [1, `${dataColor}1a`],
              ],
            },
            color: `${dataColor}99`,
          });
        }
      });

      let lengthOfMultiData = multiData?.length;
      let lengthOfColumns = lengthOfMultiData + 1;
      for (let i = 0; i < lengthOfColumns; i++) {
        if (i == 0) {
          graphObject?.single[0]?.x?.forEach((xElem, x_index) => {
            datasource[x_index] = { [columns[i]?.title]: xElem };
          });
        } else {
          columns[i] = {
            title: multiData[i - 1]?.name,
            dataIndex: multiData[i - 1]?.name,
          };
          multiData[i - 1]?.data?.forEach((data, data_index) => {
            datasource[data_index] = {
              ...datasource[data_index],
              [columns[i]?.title]: false
                ? SecondstoHumanReadable(data)
                : isNaN(Number(data))
                ? data?.toString().includes("NaN")
                  ? Number(0)
                  : data
                : Number(data), // data
            };
          });
        }
      }
      return { columns, datasource };
    } else {
      let columns = [
        {
          title: graphObject?.xaxis,
          dataIndex: graphObject?.xaxis,
        },
        {
          title: graphObject?.yaxis,
          dataIndex: graphObject?.yaxis,
        },
      ];

      let datasource = graphObject?.single[0]?.y?.map((yElem, i) => {
        return {
          [columns[0]?.title]: graphObject?.single[0]?.x[i],
          [columns[1]?.title]: false
            ? SecondstoHumanReadable(yElem)
            : isNaN(Number(yElem))
            ? yElem?.toString().includes("NaN")
              ? Number(0)
              : yElem
            : Number(yElem), // yElem
        };
      });
      return { columns, datasource };
    }
  } else if (widgetMetadata?.chart?.chart_type === "combination") {
    let graphObject = { single: [], xaxis: null, yaxis: null };
    graphObject.xaxis = widgetMetadata?.x_axis?.trace_name;
    graphObject.yaxis =
      widgetMetadata?.y_series?.[0]?.trace_name ||
      widgetMetadata?.y_axis?.y_series_1?.trace_name;
    graphObject.single = widgetMetadata?.turnedcombination
      ? widgetMetadata?.graphData?.data?.[widgetMetadata?.graph_type]?.[0] ||
        (excelData?.[0]?.y_axis ? excelData?.[0] : excelData)
      : widgetMetadata?.graphData?.data?.[widgetMetadata?.chart?.chart_type] ||
        (excelData?.[0]?.y_axis ? excelData?.[0] : excelData);

    let ySeriesFromConfig = widgetMetadata?.y_series
      ? widgetMetadata?.y_series
      : widgetMetadata?.y_axis
      ? Object?.entries(widgetMetadata?.y_axis)
      : [];
    let s_data = [];
    let stackeBarData = [];
    let flrSeriesExists = false;
    graphConditionConfig = [
      ...(graphConditionConfig?.["ticket-time-label-attrs"] ?? []),
      ...(graphConditionConfig?.["time-label-attrs"] ?? []),
    ];
    let seriesColorsFlag = false;
    let j = 0;
    let noOfIterationInColors = 0;
    let lengthOfColors = globalChartColor?.length;
    graphObject?.single?.y_axis?.map((d, i) => {
      stackeBarData = [];
      if (d?.y[0]?.name) {
        stackeBarData = d.y?.map((el, ind) => {
          let dataColor;
          if (
            el?.color !== undefined &&
            el?.color !== "#000000" &&
            el?.color !== null
          ) {
            dataColor = el?.color;
          } else {
            if (j >= lengthOfColors) {
              noOfIterationInColors = parseInt(j / lengthOfColors);
              let rem = parseInt(j % lengthOfColors);
              dataColor =
                noOfIterationInColors > 0
                  ? newColorShadeInHex6(
                      globalChartColor[rem],
                      parseInt(noOfIterationInColors * 5)
                    )
                  : globalChartColor[j];
            } else {
              dataColor = globalChartColor[j];
            }
            j++;
          }
          return {
            name: el?.name,
            data: el?.y,
            attribute: d?.attribute,
          };
        });
      }

      let seriesData = [];
      seriesColorsFlag = false;
      if (d?.colors != undefined && d?.colors?.length > 0) {
        seriesColorsFlag = true;
        seriesData = d?.y?.map((yElem, i) => {
          return {
            y: yElem,
            color:
              d?.colors != undefined
                ? d?.colors[i] != "#000000"
                  ? d?.colors[i]
                  : undefined
                : undefined,
          };
        });
      }
      if (ySeriesFromConfig?.length > i) {
        if (
          ySeriesFromConfig[i]?.attribute &&
          graphConditionConfig?.includes(ySeriesFromConfig[i]?.attribute)
        ) {
          flrSeriesExists = true;
        } else if (
          graphConditionConfig?.includes(ySeriesFromConfig[i][1]?.attribute)
        ) {
          flrSeriesExists = true;
        }
      }
      if (!d?.y[0]?.name) {
        s_data.push({
          name: d?.name,
          data: seriesColorsFlag ? seriesData : d?.y,
          attribute: d?.attribute,
        });
      }
      if (stackeBarData?.length > 0) {
        try {
          if (widgetMetadata?.chart?.chart_settings?.is_stacked) {
            if (stackeBarData && stackeBarData?.length > 0) {
              // stackeBarData = structuredClone(stackeBarData)?.reverse();
              stackeBarData = stackeBarData?.slice()?.reverse();
            }
          }
        } catch (error) {
          console.error("Error While convert dataset to reverse");
        }
        s_data = [...stackeBarData, ...s_data];
      }
    });

    s_data = s_data?.filter((d) => d?.name);

    let multiData = s_data;
    let columns = [
      {
        title: graphObject?.xaxis,
        dataIndex: graphObject?.xaxis,
      },
    ];
    let datasource = [];
    let lengthOfMultiData = multiData?.length;
    let lengthOfColumns = lengthOfMultiData + 1;
    for (let i = 0; i < lengthOfColumns; i++) {
      if (i == 0) {
        graphObject?.single?.x_axis?.forEach((xElem, x_index) => {
          datasource[x_index] = { [columns[i]?.title]: xElem };
        });
      } else {
        if (multiData[i - 1]?.name?.includes("|$|")) {
          let ProfileName = multiData[i - 1]?.name?.split("|$|")?.[1]?.trim();
          let channelName = multiData[i - 1]?.name?.split("|$|")?.[0]?.trim();
          columns[i] = {
            title: channelName + " | " + ProfileName,
            dataIndex: multiData[i - 1]?.name,
          };
        } else if (multiData[i - 1]?.name?.includes("|G|")) {
          let genderName = multiData[i - 1]?.name?.split("|G|")?.[1]?.trim();

          columns[i] = {
            title: genderName,
            dataIndex: multiData[i - 1]?.name,
          };
        } else if (multiData[i - 1]?.name?.includes("|C|")) {
          let countryName = multiData[i - 1]?.name?.split("|C|")?.[1]?.trim();

          columns[i] = {
            title: countryName,
            dataIndex: multiData[i - 1]?.name,
          };
        } else {
          columns[i] = {
            title: multiData[i - 1]?.name,
            dataIndex: multiData[i - 1]?.name,
          };
        }
        multiData[i - 1]?.data?.forEach((data, data_index) => {
          datasource[data_index] = {
            ...datasource[data_index],
            [columns[i]?.dataIndex]: data?.y
              ? graphConditionConfig?.includes(multiData[i - 1]?.attribute)
                ? SecondstoHumanReadable(data?.y)
                : isNaN(Number(data?.y))
                ? data?.y?.toString().includes("NaN")
                  ? Number(0)
                  : data?.y
                : Number(data?.y) // data?.y?.toLocaleString()
              : graphConditionConfig?.includes(multiData[i - 1]?.attribute)
              ? SecondstoHumanReadable(data)
              : isNaN(Number(data))
              ? data?.toString().includes("NaN")
                ? Number(0)
                : data
              : Number(data), //
          };
        });
      }
    }
    if (widgetMetadata?.turnedcombination) {
      widgetMetadata.chart.chart_type =
        widgetMetadata.chart.original_chart_type;
      delete widgetMetadata.turnedcombination;
      delete widgetMetadata.chart.original_chart_type;
    }

    return { columns, datasource };
  } else if (widgetMetadata?.chart?.chart_type === "heatmap") {
    let graphObject = { single: [], xaxis: null, yaxis: null };
    graphObject.xaxis =
      widgetMetadata?.x_axis?.trace_name ||
      allAttributes[widgetMetadata?.x_axis?.attribute] ||
      widgetMetadata?.x_axis?.attribute;
    graphObject.yaxis =
      widgetMetadata?.y_axes?.[0]?.trace_name ||
      widgetMetadata?.breakdown_by?.[0]?.trace_name;

    graphObject.single[0] =
      widgetMetadata?.graphData?.data?.[widgetMetadata?.chart?.chart_type][0]
        ?.data?.[0] || excelData?.[0]?.data?.[0];
    if (!graphObject.single) {
      return { columns: [], datasource: [] };
    }
    // Get axis names from metadata
    const xAxisName = graphObject?.xaxis || "X-axis";
    const yAxisName = graphObject?.yaxis || "Y-axis";
    // Get unique x and y values from the data
    const uniqueX = [...new Set(graphObject?.single?.[0]?.x)];
    const uniqueY = [...new Set(graphObject?.single?.[0]?.y)];
    if (!uniqueX || !uniqueY) return { columns: [], datasource: [] };
    // Define columns: first column for Y values then one for each unique X value
    let columns = [{ title: `${yAxisName}/${xAxisName}`, dataIndex: "Y" }];
    uniqueX?.forEach((xVal) => {
      columns.push({ title: xVal, dataIndex: xVal });
    });

    // Build datasource: each row represents a unique Y value.
    // For each X column, search for a matching [x, y, value] entry.
    let datasource = uniqueY?.map((yVal, yValIndex) => {
      let row = { Y: yVal };
      uniqueX?.forEach((xVal, xValIndex) => {
        const match = graphObject?.single?.[0]?.z?.find(
          (point) => point?.[0] === xValIndex && point?.[1] === yValIndex
        );
        let zValue = match?.[2];
        row[xVal] = match
          ? isNaN(Number(zValue))
            ? zValue?.toString().includes("NaN")
              ? Number(0)
              : zValue
            : Number(zValue)
          : "";
      });
      return row;
    });
    return { columns, datasource };
  } else if (widgetMetadata?.chart?.chart_type === "scatter") {
    let ySeriesFromConfig = widgetMetadata?.y_series
      ? widgetMetadata?.y_series
      : Object?.entries(widgetMetadata?.y_axis);
    let xAxisAttributeObj = ySeriesFromConfig?.[0]?.attribute
      ? ySeriesFromConfig[0]
      : ySeriesFromConfig?.[0]?.[1]?.attribute
      ? ySeriesFromConfig?.[0]?.[1]
      : null;
    let xAxisName = xAxisAttributeObj?.trace_name
      ? xAxisAttributeObj?.trace_name
      : "";
    let yAxisName = ySeriesFromConfig?.[1]?.attribute
      ? ySeriesFromConfig[1]?.trace_name
        ? ySeriesFromConfig[1]?.trace_name
        : ySeriesFromConfig[1]?.attribute
      : ySeriesFromConfig?.[1]?.[1]?.attribute
      ? ySeriesFromConfig?.[1]?.[1]?.trace_name
        ? ySeriesFromConfig?.[1]?.[1]?.trace_name
        : ySeriesFromConfig?.[1]?.[1]?.attribute
      : null;
    let singleData =
      widgetMetadata?.graphData?.data?.[widgetMetadata?.chart?.chart_type] ||
      excelData;
    let dataOfSeries = singleData?.[0]?.data ? singleData?.[0] : singleData;
    let checkIsBreakDownAdded =
      dataOfSeries?.data?.[0]?.breakdown_dimension &&
      dataOfSeries?.data?.[0]?.breakdown_val
        ? true
        : false;
    let plottableData = [];
    let formattedDataBasedOnBreakdown = {};
    // Before data processing calculating data based on breakdown if exists
    if (checkIsBreakDownAdded) {
      if (Array.isArray(dataOfSeries?.data)) {
        dataOfSeries?.data?.forEach((series, index) => {
          const key = series?.breakdown_val;
          if (!formattedDataBasedOnBreakdown?.[key]) {
            formattedDataBasedOnBreakdown[key] = {
              name: key,
              color:
                series?.color && series?.color !== "#000000"
                  ? series?.color
                  : globalChartColor?.[index],
              data: [],
            };
          }
          // Push the data point into the proper group
          formattedDataBasedOnBreakdown[key].data.push({
            name: series?.name,
            x: parseFloat(series?.x), // Convert string x to a number
            y: series?.y,
            marker: { radius: series?.size }, // Use the size value as marker radius
          });
        });
      }
    }

    // Data processing started here
    if (checkIsBreakDownAdded) {
      // Convert the object into an array for Highcharts
      const seriesValues = Object.values(formattedDataBasedOnBreakdown);
      if (Array.isArray(seriesValues) && seriesValues?.length) {
        seriesValues?.forEach((series, index) => {
          let pointsData = [];
          if (Array.isArray(series?.data) && series?.data?.length) {
            pointsData = series?.data?.map((point, pointIndex) => {
              return {
                x: Math.round(parseFloat(point?.x) * 100) / 100,
                y: point?.y,
                name: point?.name,
              };
            });
          }
          let seriesObject = {
            name: series?.name ? series?.name : "Scatter",
            color:
              series?.color && series?.color !== "#000000"
                ? series?.color
                : globalChartColor?.[index],
            data: pointsData,
          };
          plottableData?.push(seriesObject);
        });
      }
    } else {
      if (Array.isArray(dataOfSeries?.data)) {
        dataOfSeries?.data?.forEach((series, index) => {
          let pointData = [
            {
              x: Math.round(parseFloat(series?.x) * 100) / 100,
              y: series?.y,
            },
          ];
          // [
          //   [Math.round(parseFloat(series?.x) * 100) / 100, series?.y],
          // ];
          let seriesObject = {
            name: series?.name ? series?.name : "Scatter",
            color:
              series?.color && series?.color !== "#000000"
                ? series?.color
                : globalChartColor?.[index],
            data: pointData,
          };
          plottableData?.push(seriesObject);
        });
      }
    }

    // Excel Data processing started here
    let xAxisColumnName =
      widgetMetadata?.x_axis?.trace_name ||
      allAttributes[widgetMetadata?.x_axis?.attribute] ||
      widgetMetadata?.x_axis?.attribute;

    let ySeriesFirst = xAxisName;
    let ySeriesSecond = yAxisName;
    let breakdownAttr;
    // This is for calculating the breakdown name
    if (checkIsBreakDownAdded) {
      breakdownAttr =
        widgetMetadata?.y_axes && Array.isArray(widgetMetadata?.y_axes)
          ? widgetMetadata?.y_axes?.[0]?.attribute
            ? widgetMetadata?.y_axes?.[0]
            : null
          : widgetMetadata?.breakdown_by &&
            Array.isArray(widgetMetadata?.breakdown_by)
          ? widgetMetadata?.breakdown_by?.[0]?.attribute
            ? widgetMetadata?.breakdown_by?.[0]
            : null
          : null;
    }
    let breakdownColumnName = breakdownAttr?.trace_name || "Breakdown";

    let columns = checkIsBreakDownAdded
      ? [
          { title: breakdownColumnName, dataIndex: "breakdown" },
          { title: xAxisColumnName, dataIndex: "x_axis" },
          { title: ySeriesFirst, dataIndex: "y-series-1" },
          { title: ySeriesSecond, dataIndex: "y-series-2" },
        ]
      : [
          { title: xAxisColumnName, dataIndex: "x_axis" },
          { title: ySeriesFirst, dataIndex: "y-series-1" },
          { title: ySeriesSecond, dataIndex: "y-series-2" },
        ];
    const dataSource = [];
    if (Array.isArray(plottableData)) {
      plottableData?.forEach((series) => {
        let xAxisDataValue = checkIsBreakDownAdded ? "" : series?.name;
        let breakdownDataValue = checkIsBreakDownAdded ? series?.name : "";
        series?.data &&
          Array.isArray(series?.data) &&
          series?.data?.forEach((point) => {
            let ySeriesFirstValue = isNaN(Number(point?.x))
              ? point?.x?.toString().includes("NaN")
                ? Number(0)
                : point?.x
              : Number(point?.x);
            let ySeriesSecondValue = isNaN(Number(point?.y))
              ? point?.y?.toString().includes("NaN")
                ? Number(0)
                : point?.y
              : Number(point?.y);
            if (checkIsBreakDownAdded) {
              xAxisDataValue = point?.name;
              dataSource.push({
                breakdown: breakdownDataValue,
                x_axis: xAxisDataValue,
                "y-series-1": ySeriesFirstValue,
                "y-series-2": ySeriesSecondValue,
              });
            } else {
              dataSource.push({
                x_axis: xAxisDataValue,
                "y-series-1": ySeriesFirstValue,
                "y-series-2": ySeriesSecondValue,
              });
            }
          });
      });
    }
    return { columns, datasource: dataSource };
  }
};

export const checkIfValidNumberWithSlash = (str) => {
  let string = str.split("/");
  string.forEach((el, ind) => {
    if (isNaN(Number(el))) {
      return false;
    }
  });
  return true;
};

export const separateColumnsAndData = (totalData, attr, chartSettings) => {
  const hasNestedData = totalData?.some(
    (item) => Array.isArray(item?.data) || Array.isArray(item)
  );
  const dataArray = hasNestedData
    ? totalData.flatMap((item) => item?.data || item || [])
    : totalData;

  const isDataAvailable = (index, key) => {
    if (
      dataArray?.[index]?.[`${key}`] !== null &&
      dataArray?.[index]?.[`${key}`] !== undefined &&
      dataArray?.[index]?.[`${key}`] !== ""
    ) {
      return true;
    } else {
      return false;
    }
  };

  const groupedData = {};

  // Group data by attribute
  dataArray.forEach((dataItem, index) => {
    if (!dataItem?.attribute || !dataItem?.y_series || dataItem?.isBenchmark) {
      const columnTitle = dataItem?.base_name || dataItem?.text;
      const columnDataKey = columnTitle;
      if (columnTitle && !groupedData[columnTitle]) {
        groupedData[columnTitle] = { columns: [], data: [] };
      }

      columnTitle &&
        groupedData[columnTitle].columns.push({
          title: columnTitle,
          dataIndex: columnDataKey,
        });

      let colData = {
        [columnDataKey]: String(dataItem?.value)?.includes("%")
          ? dataItem?.value
          : String(dataItem?.value)?.includes("s") &&
            !isNaN(Number(dataItem?.value.slice(0, -1)))
          ? Number(dataItem?.value.slice(0, -1))
          : String(dataItem?.value)?.includes("/") &&
            checkIfValidNumberWithSlash(dataItem?.value)
          ? dataItem?.value
          : /^[0-9]+[dhmsyDHMSY]+$|^[0-9]+[dhmsyDHMSY]( [0-9]+[dhmsyDHMSY])*$/.test(
              dataItem?.value
            ) // Check for "15m 23s", "10h 20m","23D" etc with or without space.
          ? dataItem?.value
          : isNaN(Number(dataItem?.value))
          ? 0
          : Number(dataItem?.value),
      };
      // setting column names
      if (
        chartSettings.duration_comparison &&
        "percent_change" in dataArray?.[index] &&
        isDataAvailable(index, "percent_change") &&
        !groupedData[columnTitle].columns?.some(
          (col) => col.title === "Previous Duration Comparison"
        )
      ) {
        groupedData[columnTitle].columns.push({
          title: "Previous Duration Comparison",
          dataIndex: "Previous Duration Comparison",
        });
      }

      if (
        chartSettings.card_percent &&
        "share" in dataArray?.[index] &&
        isDataAvailable(index, "share") &&
        !groupedData[columnTitle].columns?.some(
          (col) => col.title === "Share Of Voice"
        )
      ) {
        groupedData[columnTitle].columns.push({
          title: "Share Of Voice",
          dataIndex: "Share Of Voice",
        });
      }
      // setting data for columns
      if (
        chartSettings?.duration_comparison &&
        isDataAvailable(index, "percent_change")
      ) {
        colData["Previous Duration Comparison"] =
          Number(dataItem?.percent_change) !== 0
            ? Number(dataItem?.percent_change).toFixed(2) + "%"
            : Number(dataItem?.percent_change);
      }
      if (chartSettings?.card_percent && isDataAvailable(index, "share")) {
        colData["Share Of Voice"] =
          Number(dataItem?.share) !== 0
            ? Number(dataItem?.share).toFixed(2) + "%"
            : Number(dataItem?.share);
      }
      columnTitle && groupedData[columnTitle].data.push(colData);
    } else {
      const mainAttr =
        dataItem?.attribute !== dataItem?.y_series?.attribute
          ? attr[dataItem?.attribute]
          : dataItem?.y_series?.trace_name || attr[dataItem?.attribute];
      const yAttr = attr[dataItem?.y_series?.attribute];
      if (!groupedData[mainAttr]) {
        groupedData[mainAttr] = { columns: [], data: [] };
      }

      if (dataItem?.attribute !== dataItem?.y_series?.attribute) {
        groupedData[mainAttr].columns = [
          { title: mainAttr, dataIndex: mainAttr },
          { title: yAttr, dataIndex: yAttr },
        ];
      } else {
        groupedData[mainAttr].columns = [
          { title: mainAttr, dataIndex: mainAttr },
        ];
      }

      if (
        chartSettings.card_percent &&
        "share" in dataArray?.[index] &&
        isDataAvailable(index, "share") &&
        !groupedData[mainAttr].columns.some(
          (col) => col.title === "Share Of Voice"
        )
      ) {
        groupedData[mainAttr].columns.push({
          title: "Share Of Voice",
          dataIndex: "Share Of Voice",
        });
      }

      if (
        chartSettings.duration_comparison &&
        "percent_change" in dataArray?.[index] &&
        isDataAvailable(index, "percent_change") &&
        !groupedData[mainAttr].columns?.some(
          (col) => col.title === "Previous Duration Comparison"
        )
      ) {
        groupedData[mainAttr].columns.push({
          title: "Previous Duration Comparison",
          dataIndex: "Previous Duration Comparison",
        });
      }

      if (dataItem?.text?.includes("|$|")) {
        dataItem.text = dataItem?.text?.split("|$|")?.[1]?.trim();
      } else if (dataItem?.text?.includes("|G|")) {
        dataItem.text = dataItem?.text?.split("|G|")?.[1]?.trim();
      } else if (dataItem?.text?.includes("|C|")) {
        dataItem.text = dataItem?.text?.split("|C|")?.[1]?.trim();
      }

      const rowData =
        dataItem?.attribute !== dataItem?.y_series?.attribute
          ? {
              [mainAttr]: !isNaN(Number(dataItem?.text))
                ? Number(dataItem?.text)
                : dataItem?.text,
              [yAttr]: dataItem?.value,
            }
          : {
              [mainAttr]: isNaN(Number(dataItem.value))
                ? dataItem.value?.toString().includes("NaN")
                  ? Number(0)
                  : dataItem.value
                : Number(dataItem.value),
            };

      if (chartSettings?.card_percent && isDataAvailable(index, "share")) {
        rowData["Share Of Voice"] = Number(dataItem?.share).toFixed(2) + "%";
      }
      if (
        chartSettings?.duration_comparison &&
        isDataAvailable(index, "percent_change")
      ) {
        rowData["Previous Duration Comparison"] =
          Number(dataItem?.percent_change) !== 0
            ? Number(dataItem?.percent_change).toFixed(2) + "%"
            : Number(dataItem?.percent_change);
      }
      groupedData[mainAttr].data.push(rowData);
    }
  });

  // Collect grouped results
  return Object.values(groupedData).map((group) => ({
    columns: group.columns,
    data: group.data,
  }));
};

//for quick filters in share case, updated selected pill in shareTemplateData
export const setSelectedPillInShareTemplate = (
  templateDetails,
  shareTemplateData
) => {
  const updatedShareTemplateData = deepCopy(shareTemplateData);
  let tempPaneFilters = updatedShareTemplateData?.filters;
  let selectedPill =
    updatedShareTemplateData?.selected_pills?.[0]?.saved_filters?.length;
  if (
    updatedShareTemplateData?.template_type === "competition" &&
    !updatedShareTemplateData?.private_conversation
  ) {
    let saved = templateDetails?.saved_filters;
    let comp_hidden_filters = updatedShareTemplateData?.comp_hidden_filter;

    if (!Object.keys(templateDetails).length) {
      if (tempPaneFilters?.length) {
        if (selectedPill) {
          let pillFilter =
            updatedShareTemplateData?.selected_pills?.[0]?.saved_filters;
          tempPaneFilters = removeHiddenFromSaved(
            deepCopy(tempPaneFilters),
            deepCopy(pillFilter)
          );
        }
        tempPaneFilters = mergeArrays(
          deepCopy(comp_hidden_filters),
          deepCopy(tempPaneFilters)
        );
        let isFilterConflict = isSameFilterDiffTypes(
          deepCopy(comp_hidden_filters),
          deepCopy(tempPaneFilters)
        );
        if (isFilterConflict) {
          callNotification(
            "Conflicting filter applied, please recheck the filters",
            "info"
          );
        }
      } else {
        tempPaneFilters = [...deepCopy(comp_hidden_filters)];
      }
    } else {
      if (tempPaneFilters.length && selectedPill) {
        let selectedPillFilter =
          updatedShareTemplateData?.selected_pills?.[0]?.saved_filters;
        tempPaneFilters = removeHiddenFromSaved(
          deepCopy(tempPaneFilters),
          deepCopy(comp_hidden_filters)
        );
        tempPaneFilters = removeHiddenFromSaved(
          deepCopy(tempPaneFilters),
          deepCopy(selectedPillFilter)
        );
        tempPaneFilters = mergeArrays(
          deepCopy(tempPaneFilters),
          deepCopy(saved)
        );
        let tempPaneFiltersCopy = deepCopy(tempPaneFilters);
        tempPaneFilters = mergeArrays(
          tempPaneFiltersCopy,
          deepCopy(comp_hidden_filters)
        );
        let isFilterConflict = isSameFilterDiffTypes(
          tempPaneFiltersCopy,
          deepCopy(comp_hidden_filters)
        );
        if (isFilterConflict) {
          callNotification(
            "Conflicting filters applied, please check your filters",
            "info"
          );
        }
      } else if (tempPaneFilters?.length) {
        let tempPaneFiltersCopy = deepCopy(tempPaneFilters);
        tempPaneFilters = mergeArrays(tempPaneFiltersCopy, deepCopy(saved));
        let isFilterConflict = isSameFilterDiffTypes(
          tempPaneFiltersCopy,
          deepCopy(saved)
        );
        if (isFilterConflict) {
          callNotification(
            "Conflicting filters applied, please check your filters",
            "info"
          );
        }
      } else {
        let saved_filters_copy = saved?.length ? deepCopy(saved) : [];

        tempPaneFilters = mergeArrays(
          deepCopy(comp_hidden_filters),
          deepCopy(saved_filters_copy)
        );
        let isFilterConflict = isSameFilterDiffTypes(
          deepCopy(comp_hidden_filters),
          deepCopy(saved_filters_copy)
        );
        if (isFilterConflict) {
          callNotification(
            "Conflicting filters applied, please check your filters",
            "info"
          );
        }
      }
    }

    updatedShareTemplateData.filters = tempPaneFilters;
    updatedShareTemplateData.selected_pills = templateDetails
      ? [templateDetails]
      : [];
  } else {
    if (Object.keys(templateDetails)?.length > 0) {
      let saved_filters = templateDetails?.saved_filters;
      if (tempPaneFilters?.length && selectedPill) {
        let pillFilter =
          updatedShareTemplateData?.selected_pills?.[0]?.saved_filters;
        tempPaneFilters = removeHiddenFromSaved(
          deepCopy(tempPaneFilters),
          deepCopy(pillFilter)
        );
        let tempPaneFiltersCopy = deepCopy(tempPaneFilters);
        tempPaneFilters = mergeArrays(
          tempPaneFiltersCopy,
          deepCopy(saved_filters)
        );
        let isFilterConflict = isSameFilterDiffTypes(
          tempPaneFiltersCopy,
          deepCopy(saved_filters)
        );
        if (isFilterConflict) {
          callNotification(
            "Conflicting filter applied, please recheck the filters",
            "info"
          );
        }
      } else if (tempPaneFilters?.length) {
        let tempPaneFiltersCopy = deepCopy(tempPaneFilters);
        let saved_filtersCopy = deepCopy(saved_filters);
        tempPaneFilters = mergeArrays(tempPaneFiltersCopy, saved_filtersCopy);
        let isFilterConflict = isSameFilterDiffTypes(
          tempPaneFiltersCopy,
          saved_filtersCopy
        );
        if (isFilterConflict) {
          callNotification(
            "Conflicting filter applied, please recheck the filters",
            "info"
          );
        }
      } else {
        tempPaneFilters = [...deepCopy(saved_filters)];
      }
    } else {
      if (selectedPill) {
        let pillFilter =
          updatedShareTemplateData?.selected_pills?.[0]?.saved_filters;
        tempPaneFilters = removeHiddenFromSaved(
          deepCopy(tempPaneFilters),
          deepCopy(pillFilter)
        );
      }
      tempPaneFilters = tempPaneFilters?.length ? tempPaneFilters : [];
    }
    if (updatedShareTemplateData?.hidden_filter) {
      let hiddenAttribute =
        updatedShareTemplateData?.hidden_filter?.attribute?.toLowerCase();
      tempPaneFilters = deepCopy(tempPaneFilters)?.filter(
        (item) => item?.attribute?.toLowerCase() !== hiddenAttribute
      );
      if (Object.keys(templateDetails)?.length > 0) {
        let channelIndexInSelectedPill =
          templateDetails?.saved_filters?.findIndex(
            (item) => item?.attribute?.toLowerCase() === "socialmediaplatforms"
          );
        if (channelIndexInSelectedPill > -1) {
          callNotification(
            "Conflicting filters applied, please recheck the filters",
            "info"
          );
        }
      }
    }
    updatedShareTemplateData.filters = tempPaneFilters;
    updatedShareTemplateData.selected_pills = templateDetails
      ? [templateDetails]
      : [];
  }
  return updatedShareTemplateData;
};
export const removeMatchingFilters = (filtersArray, selectedPill) => {
  // Handle invalid inputs
  if (!Array.isArray(filtersArray)) {
    return [];
  }

  // Deep copy to avoid mutations (assuming deepCopy function exists in your codebase)
  const safeFiltersArray =
    typeof deepCopy === "function"
      ? deepCopy(filtersArray)
      : JSON.parse(JSON.stringify(filtersArray));

  // Extract the pill object properly
  const pillObject = Array.isArray(selectedPill)
    ? selectedPill[0]
    : selectedPill;

  // If no valid saved_filters, return original array
  if (
    !pillObject ||
    !pillObject.saved_filters ||
    !Array.isArray(pillObject.saved_filters) ||
    pillObject.saved_filters.length === 0
  ) {
    return safeFiltersArray;
  }

  try {
    // Process each filter
    const processedFilters = safeFiltersArray.map((filter) => {
      // For each saved filter, remove matching columns
      let updatedFilter = { ...filter };

      pillObject.saved_filters.forEach((savedFilter) => {
        // Only process if attributes and types match
        if (
          filter.attribute === savedFilter.attribute &&
          filter.type === savedFilter.type
        ) {
          updatedFilter = removeMatchingColumns(updatedFilter, savedFilter);
        }
      });

      return updatedFilter;
    });

    // Remove filters with empty columns
    return processedFilters.filter(
      (filter) =>
        filter.columns &&
        ((Array.isArray(filter.columns) && filter.columns.length > 0) ||
          (!Array.isArray(filter.columns) &&
            Object.keys(filter.columns).length > 0))
    );
  } catch (error) {
    return safeFiltersArray;
  }
};
// New function to remove matching columns from a filter
export const removeMatchingColumns = (filter, savedFilter) => {
  // If attributes or types don't match, return the original filter
  if (
    filter.attribute !== savedFilter.attribute ||
    filter.type !== savedFilter.type
  ) {
    return filter;
  }

  // Handle range filters (columns as object with from/to)
  if (
    typeof filter.columns === "object" &&
    !Array.isArray(filter.columns) &&
    typeof savedFilter.columns === "object" &&
    !Array.isArray(savedFilter.columns)
  ) {
    // For range filters, if they match exactly, remove the whole filter
    if (
      String(filter.columns.from) === String(savedFilter.columns.from) &&
      String(filter.columns.to) === String(savedFilter.columns.to)
    ) {
      return { ...filter, columns: [] };
    }
    return filter;
  }

  // Handle array columns
  if (!Array.isArray(filter.columns) || !Array.isArray(savedFilter.columns)) {
    return filter;
  }

  // Check if column names might be arrays
  const hasNestedArrays = filter.columns.some(
    (col) => col && col.name && Array.isArray(col.name)
  );

  // If we have complex nested structures, use a different approach
  if (hasNestedArrays) {
    return removeComplexMatchingColumns(filter, savedFilter);
  }

  // Remove matching columns
  const newColumns = filter.columns.filter((filterCol) => {
    // Keep this column if it doesn't match any savedFilter column
    return !savedFilter.columns.some((savedCol) => {
      // Compare name and type
      return (
        filterCol.name === savedCol.name && filterCol.type === savedCol.type
      );

      // Commented out as per original code
      // && (
      //   (filterCol.display_name === null && savedCol.display_name === null) ||
      //   (filterCol.display_name !== null && savedCol.display_name !== null &&
      //    filterCol.display_name === savedCol.display_name)
      // );
    });
  });

  // Return the filter with updated columns
  return { ...filter, columns: newColumns };
};

// Function to handle complex column structures
export const removeComplexMatchingColumns = (filter, savedFilter) => {
  // If attributes or types don't match, return the original filter
  if (
    filter.attribute !== savedFilter.attribute ||
    filter.type !== savedFilter.type
  ) {
    return filter;
  }

  // Handle array columns
  if (!Array.isArray(filter.columns) || !Array.isArray(savedFilter.columns)) {
    return filter;
  }

  // Remove matching columns with complex structures
  const newColumns = filter.columns.filter((filterCol) => {
    // Keep this column if it doesn't match any savedFilter column
    return !savedFilter.columns.some((savedCol) => {
      // Handle array names
      if (Array.isArray(filterCol.name) && Array.isArray(savedCol.name)) {
        if (filterCol.name.length !== savedCol.name.length) {
          return false;
        }

        // Compare arrays element by element
        for (let i = 0; i < filterCol.name.length; i++) {
          if (filterCol.name[i] !== savedCol.name[i]) {
            return false;
          }
        }

        // Names match, compare types
        return filterCol.type === savedCol.type;
      }

      // Handle regular names
      return (
        filterCol.name === savedCol.name && filterCol.type === savedCol.type
      );

      // Commented out as per original code
      // && (
      //   (filterCol.display_name === null && savedCol.display_name === null) ||
      //   (filterCol.display_name !== null && savedCol.display_name !== null &&
      //    filterCol.display_name === savedCol.display_name)
      // );
    });
  });

  // Return the filter with updated columns
  return { ...filter, columns: newColumns };
};

export const isFilterMatch = (filter, savedFilter) => {
  // Basic validation
  if (!filter || !savedFilter) {
    return false;
  }

  // Check attribute and type
  if (
    filter.attribute !== savedFilter.attribute ||
    filter.type !== savedFilter.type
  ) {
    return false;
  }

  // Handle case where columns is an object with from/to properties (range filters)
  if (
    typeof filter.columns === "object" &&
    !Array.isArray(filter.columns) &&
    typeof savedFilter.columns === "object" &&
    !Array.isArray(savedFilter.columns)
  ) {
    // For range filters, compare from/to values
    return (
      String(filter.columns.from) === String(savedFilter.columns.from) &&
      String(filter.columns.to) === String(savedFilter.columns.to)
    );
  }

  // Handle case where columns is an array
  if (
    !Array.isArray(filter.columns) ||
    !Array.isArray(savedFilter.columns) ||
    filter.columns.length !== savedFilter.columns.length
  ) {
    return false;
  }

  try {
    // Handle potential complex nested structures
    // Check if column names themselves might be arrays
    const hasNestedArrays = filter.columns.some(
      (col) => col && col.name && Array.isArray(col.name)
    );

    if (hasNestedArrays) {
      // Handle nested array case - would need special comparison
      // For nested array names, we'd need to compare arrays element by element
      return compareComplexColumns(filter.columns, savedFilter.columns);
    }

    // Sort columns by name for consistent comparison
    const filterColumns = [...filter.columns].sort((a, b) =>
      (a?.name || "").localeCompare(b?.name || "")
    );
    const savedColumns = [...savedFilter.columns].sort((a, b) =>
      (a?.name || "").localeCompare(b?.name || "")
    );

    // Compare each column
    for (let i = 0; i < filterColumns.length; i++) {
      const filterCol = filterColumns[i];
      const savedCol = savedColumns[i];

      // Handle null/undefined safely
      if (!filterCol || !savedCol) {
        return false;
      }

      // Compare name and type
      if (
        filterCol.name !== savedCol.name ||
        filterCol.type !== savedCol.type
      ) {
        return false;
      }

      // Compare display_name with null handling (not consistent hence commented!)
      // if (
      //   (filterCol.display_name === null && savedCol.display_name !== null) ||
      //   (filterCol.display_name !== null && savedCol.display_name === null) ||
      //   (filterCol.display_name !== null &&
      //     savedCol.display_name !== null &&
      //     filterCol.display_name !== savedCol.display_name)
      // ) {
      //   return false;
      // }
    }

    // All columns match
    return true;
  } catch (err) {
    return false;
  }
};
// Helper for comparing complex nested column structures
export const compareComplexColumns = (columnsA, columnsB) => {
  if (columnsA.length !== columnsB.length) {
    return false;
  }

  // Sort by name if possible
  const sortColumns = (cols) => {
    return [...cols].sort((a, b) => {
      // Handle array names
      const nameA = Array.isArray(a?.name) ? a?.name.join(",") : a?.name || "";
      const nameB = Array.isArray(b?.name) ? b?.name.join(",") : b?.name || "";
      return nameA.localeCompare(nameB);
    });
  };

  const sortedA = sortColumns(columnsA);
  const sortedB = sortColumns(columnsB);

  // Compare each column
  for (let i = 0; i < sortedA.length; i++) {
    const colA = sortedA[i];
    const colB = sortedB[i];

    // Handle array names
    if (Array.isArray(colA?.name) && Array.isArray(colB?.name)) {
      if (colA.name.length !== colB.name.length) {
        return false;
      }

      // Compare arrays element by element
      for (let j = 0; j < colA.name.length; j++) {
        if (colA.name[j] !== colB.name[j]) {
          return false;
        }
      }
    } else if (colA?.name !== colB?.name) {
      return false;
    }

    // Compare types
    if (colA?.type !== colB?.type) {
      return false;
    }

    // Compare display names with null handling
    // if (
    //   (colA?.display_name === null && colB?.display_name !== null) ||
    //   (colA?.display_name !== null && colB?.display_name === null) ||
    //   (colA?.display_name !== null &&
    //     colB?.display_name !== null &&
    //     colA?.display_name !== colB?.display_name)
    // ) {
    //   return false;
    // }
  }

  return true;
};

// for ad campaign formatting
// Function to add a campaign to the map
export const addCampaignToMap = (map, column) => {
  const campaignId = column?.name || column?.id;
  if (!map?.has(campaignId)) {
    map?.set(campaignId, { ...column, ad_sets: [] });
  }
};

// Function to add an ad set to a campaign
export const addAdSetToCampaign = (campaign, adSetColumn, attribute = null) => {
  const adSetId = adSetColumn?.name || adSetColumn?.id;
  const existingAdSet = campaign?.ad_sets?.find(
    (adSet) => adSet?.name === adSetId || adSet?.id === adSetId
  );
  if (!existingAdSet) {
    campaign?.ad_sets?.push(
      attribute
        ? { ...adSetColumn, attribute: attribute, ads: [] }
        : { ...adSetColumn, ads: [] }
    );
  }
};

// Function to add an ad to an ad set
export const addAdToAdSet = (adSet, adColumn, attribute = null) => {
  const adId = adColumn?.name || adColumn?.id;
  const existingAd = adSet?.ads?.find(
    (ad) => ad?.name === adId || ad?.id === adId
  );
  if (!existingAd) {
    adSet?.ads?.push(
      attribute ? { ...adColumn, attribute: attribute } : { ...adColumn }
    );
  }
};

// Main logic to process campaigns, ad sets, and ads for Panes
export const processQuickFilterForADCampaign = (panes, index) => {
  let updatedColumnsMap = new Map();

  // Validate quick filter conditions
  if (
    (panes?.[index]?.quick_filter === "Ads_Campaign" ||
      panes?.[index]?.quick_filter_value?.attribute === "Ads_Campaign") &&
    panes?.[index]?.quick_filter_value?.columns &&
    Array.isArray(panes?.[index]?.quick_filter_value?.columns)
  ) {
    // Process campaigns
    panes[index].quick_filter_value.columns.forEach((adCampaignColumn) => {
      addCampaignToMap(updatedColumnsMap, adCampaignColumn);
    });

    // Process ad sets
    if (
      panes?.[index]?.adsset_value?.columns &&
      Array.isArray(panes[index].adsset_value.columns)
    ) {
      panes[index].adsset_value.columns.forEach((adSetColumn) => {
        const campaignId = adSetColumn?.campaign_id;
        if (updatedColumnsMap?.has(campaignId)) {
          const campaign = updatedColumnsMap.get(campaignId);
          addAdSetToCampaign(
            campaign,
            adSetColumn,
            panes[index].adsset_value.attribute
          );
        }
      });
    }

    // Process ads
    if (
      panes?.[index]?.ads_value?.columns &&
      Array.isArray(panes[index].ads_value.columns)
    ) {
      panes[index].ads_value.columns.forEach((adsColumn) => {
        const campaignId = adsColumn?.campaign_id;
        const adSetId = adsColumn?.adset_id;
        if (updatedColumnsMap?.has(campaignId)) {
          const campaign = updatedColumnsMap.get(campaignId);
          const adSet = campaign.ad_sets.find(
            (set) => set?.name === adSetId || set?.id === adSetId
          );
          if (adSet) {
            addAdToAdSet(adSet, adsColumn, panes[index].ads_value.attribute);
          }
        }
      });
    }
  }
  return updatedColumnsMap;
};

export const processQuickFilterForScheduleADCampaign = (
  quick_filter,
  adsset_value = null,
  ads_value = null
) => {
  let updatedColumnsMap = new Map();

  // Validate quick filter conditions
  if (
    quick_filter?.attribute === "Ads_Campaign" &&
    quick_filter?.columns &&
    Array.isArray(quick_filter?.columns)
  ) {
    // Process campaigns
    quick_filter.columns.forEach((adCampaignColumn) => {
      addCampaignToMap(updatedColumnsMap, adCampaignColumn);
    });

    // Process ad sets
    if (adsset_value?.columns && Array.isArray(adsset_value.columns)) {
      adsset_value.columns.forEach((adSetColumn) => {
        const campaignId = adSetColumn?.campaign_id;
        if (updatedColumnsMap.has(campaignId)) {
          const campaign = updatedColumnsMap.get(campaignId);
          addAdSetToCampaign(campaign, adSetColumn, adsset_value.attribute);
        }
      });
    }

    // Process ads
    if (ads_value?.columns && Array.isArray(ads_value.columns)) {
      ads_value.columns.forEach((adsColumn) => {
        const campaignId = adsColumn?.campaign_id;
        const adSetId = adsColumn?.adset_id;
        if (updatedColumnsMap.has(campaignId)) {
          const campaign = updatedColumnsMap.get(campaignId);
          const adSet = campaign.ad_sets.find(
            (set) => set?.name === adSetId || set?.id === adSetId
          );
          if (adSet) {
            addAdToAdSet(adSet, adsColumn, ads_value.attribute);
          }
        }
      });
    }
  }
  return updatedColumnsMap;
};
// to add ads and adssets in panes (if ppt is downloading)
export const setAdsOrAdsSet = (quick_filter, authParams, response) => {
  let adsset_list = [],
    adsset_value = null,
    ads_list = [],
    ads_value = null;

  if (quick_filter?.attribute === "Ads_Campaign") {
    const quickFiltersList = response?.data?.result || [];
    const selectedAdCampaignIds = authParams?.quickFilterValue?.includes("&")
      ? authParams?.quickFilterValue?.split("&")
      : [];
    const listOfAdCampaign = quickFiltersList?.filter((qF) =>
      selectedAdCampaignIds?.includes(qF?.id)
    );

    // Helper function to format list with "All" option
    const formatWithAllOption = (list, attribute, dsource, name) => {
      const allOption = { id: -1, name };
      list.unshift(allOption);
      return {
        attribute: attribute,
        data_source: dsource,
        type: "varchar",
        columns: [
          {
            name: `${allOption.id}`,
            type: "include",
            display_name: allOption.name,
          },
        ],
      };
    };

    const formatQuickFiltersForAdsOrAdSets = (data, listOfFilters = []) => {
      if (!data) return [];
      const ids = data.split("&");
      return ids.map((id) => {
        let selectedAdOrAdSetsObj;
        if (listOfFilters && Array.isArray(listOfFilters)) {
          selectedAdOrAdSetsObj = listOfFilters?.find(
            (obj) => obj?.id === id || parseInt(obj?.id) === parseInt(id)
          );
        }
        const campaignId = selectedAdOrAdSetsObj?.campaign_id
          ? selectedAdOrAdSetsObj?.campaign_id
          : null;
        const adSetId = selectedAdOrAdSetsObj?.adset_id
          ? selectedAdOrAdSetsObj?.adset_id
          : null;
        const status = selectedAdOrAdSetsObj?.status
          ? selectedAdOrAdSetsObj?.status
          : null;
        const obj = {
          name: id.toString(),
          type: "include",
          ...(campaignId && { campaign_id: campaignId }),
          ...(adSetId && { adset_id: adSetId }),
          ...(status && { adset_id: status }),
        };
        return obj;
      });
    };

    // Process ad sets
    listOfAdCampaign.forEach((campaign) => {
      if (Array.isArray(campaign?.ad_sets) && campaign.ad_sets.length) {
        const updatedAdSets = campaign.ad_sets.map((adSet) => ({
          ...adSet,
          campaign_id: campaign.id,
        }));
        adsset_list.push(...updatedAdSets);
      }
    });

    if (adsset_list.length) {
      adsset_value = authParams?.adssetValue
        ? {
            attribute: adsset_list[0]?.attribute,
            data_source: adsset_list[0]?.data_source || adsset_list[0]?.source,
            type: "varchar",
            columns: formatQuickFiltersForAdsOrAdSets(
              authParams?.adssetValue,
              adsset_list
            ),
          }
        : formatWithAllOption(
            adsset_list,
            adsset_list[0]?.attribute,
            adsset_list[0]?.data_source || adsset_list[0]?.source,
            "All AD Sets"
          );
    }

    // Process ads
    adsset_list.forEach((adSet) => {
      if (Array.isArray(adSet?.ads) && adSet.ads.length) {
        const updatedAds = adSet.ads.map((ad) => ({
          ...ad,
          campaign_id: adSet.campaign_id,
          adset_id: adSet.id,
        }));
        ads_list.push(...updatedAds);
      }
    });

    if (ads_list.length) {
      ads_value = authParams?.adsValue
        ? {
            attribute: ads_list[0]?.attribute,
            data_source: ads_list[0]?.data_source || ads_list[0]?.source,
            type: "varchar",
            columns: formatQuickFiltersForAdsOrAdSets(
              authParams?.adsValue,
              ads_list
            ),
          }
        : formatWithAllOption(
            ads_list,
            ads_list[0]?.attribute,
            ads_list[0]?.data_source || ads_list[0]?.source,
            "All ADs"
          );
    }
  }

  return { adsset_list, adsset_value, ads_list, ads_value };
};

export const getUpdatedBrandGroupListWithBrandList = (
  brandGroupList = [],
  stateValue = null
) => {
  // Return early if invalid inputs
  if (
    !Array.isArray(brandGroupList) ||
    brandGroupList.length === 0 ||
    !stateValue ||
    !stateValue?.groupWithBrandList ||
    !Array.isArray(stateValue?.updateForTheseBrandGroups)
  ) {
    return [];
  }
  // Create a shallow copy of the list to avoid mutating the original
  const updatedBrandGroupList = [...brandGroupList];
  // Loop for updateForTheseBrandGroups , pick one by one and update
  for (let i = 0; i < stateValue?.updateForTheseBrandGroups?.length; i++) {
    const knowForThisBrandGroup =
      stateValue?.updateForTheseBrandGroups[i]?.brand_group_name;
    const listOfBrands =
      stateValue?.groupWithBrandList?.[knowForThisBrandGroup];
    // console.log("listOfBrands : ", listOfBrands);
    // Use a for loop for better performance with large lists
    for (let j = 0; j < updatedBrandGroupList.length; j++) {
      if (
        (!Array.isArray(updatedBrandGroupList[j]?.brand_list) ||
          !(
            Array.isArray(updatedBrandGroupList[j]?.brand_list) &&
            updatedBrandGroupList[j]?.brand_list?.length
          )) &&
        knowForThisBrandGroup === updatedBrandGroupList[j]?.brand_group_name
      ) {
        updatedBrandGroupList[j] = {
          ...updatedBrandGroupList[j],
          brand_list: Array.isArray(listOfBrands) ? listOfBrands : [],
        };
        break; // Exit the loop as soon as the update is made
      }
    }
  }

  // console.log("updatedBrandGroupList : ", updatedBrandGroupList);
  return updatedBrandGroupList;
};

function deepCompare(obj1, obj2) {
  if (typeof obj1 !== typeof obj2) return false;

  if (typeof obj1 === "object" && obj1 !== null && obj2 !== null) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    // Compare keys' lengths
    if (keys1.length !== keys2.length) return false;

    // Compare each key-value pair recursively
    for (const key of keys1) {
      if (!obj2.hasOwnProperty(key)) return false;

      if (!deepCompare(obj1[key], obj2[key])) return false;
    }

    return true;
  }

  // Compare primitive values
  return obj1 === obj2;
}

export const isThemeSame = (baseObj, compareObj) => {
  // Check if both theme_json and logos_json keys are present
  if (
    !baseObj.hasOwnProperty("theme_json") ||
    !baseObj.hasOwnProperty("logos_json")
  ) {
    throw new Error("Base object does not have the required keys.");
  }
  if (
    !compareObj.hasOwnProperty("theme_json") ||
    !compareObj.hasOwnProperty("logos_json")
  ) {
    throw new Error("Compare object does not have the required keys.");
  }

  // Compare theme_json
  const themeMatch = deepCompare(baseObj.theme_json, compareObj.theme_json);
  if (!themeMatch) return false;

  // Compare logos_json
  // const logosMatch = deepCompare(baseObj.logos_json, compareObj.logos_json);
  // if (!logosMatch) return false;
  if (
    baseObj.logos_json?.banner_image !== compareObj.logos_json?.banner_image
  ) {
    return false;
  } else if (
    baseObj.logos_json?.brand_logo !== compareObj.logos_json?.brand_logo
  ) {
    return false;
  }

  return true;
};

export const capitalizeFirstLetter = (str) => {
  if (typeof str !== "string" || str.length === 0) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getClass = (authParams, type) => {
  const themePrefix = authParams?.theme_type == 1 ? "dark-theme-" : "";

  const classMap = {
    post: "post-header-color",
    comment: "comment-header-color",
    message: "message-header-color",
  };

  return `${themePrefix}${classMap[type] || "post-header-color"}`;
};

export const checkBackgroundIsDark = (bgColor) => {
  const color = bgColor?.substring(1); // remove the '#'
  const rgb = parseInt(color, 16); // convert rrggbb to decimal
  const r = (rgb >> 16) & 0xff; // extract red
  const g = (rgb >> 8) & 0xff; // extract green
  const b = (rgb >> 0) & 0xff; // extract blue

  const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // calculate luma
  return luma > 160 ? false : true; // return true for dark backgrounds and false for light backgrounds
};

export const hexToRgb = (hex) => {
  hex = hex.replace(/^#/, "");
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  }
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
};

export const rgbToHsl = (r, g, b) => {
  r /= 255;
  g /= 255;
  b /= 255;
  const max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  let h,
    s,
    l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
        break;
    }
    h /= 6;
  }
  return { h, s, l };
};

export const hslToRgb = (h, s, l) => {
  let r, g, b;
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255),
  };
};

export const rgbToHex = (r, g, b) =>
  "#" +
  [r, g, b]
    .map((x) => {
      const hex = x.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    })
    .join("");

export const getReadableTextColor = (bgHex) => {
  const { r, g, b } = hexToRgb(bgHex);
  const { h, s, l } = rgbToHsl(r, g, b);
  const textLightness = l > 0.5 ? 0.2 : 0.8;
  const { r: tr, g: tg, b: tb } = hslToRgb(h, s, textLightness);
  return rgbToHex(tr, tg, tb);
};
export const getChannelNameFromHiddenFilter = (
  hiddenFilter,
  graphConditionConfig
) => {
  if (!hiddenFilter) return "";
  let channelName = "";
  if (hiddenFilter?.columns?.length) {
    channelName = graphConditionConfig?.[`hidden-filter-channels`]
      ?.map((ch) => ch?.value)
      ?.find((chName) => hiddenFilter?.columns?.[0]?.name === chName);
  }
  return channelName;
};

export const checkIsKeyIncludesInInfoMetrics = (
  infoMetrics,
  keyName,
  index = undefined
) => {
  if (!infoMetrics || !infoMetrics?.open) return false;
  if (index !== undefined) {
    return (
      infoMetrics?.open &&
      infoMetrics?.index === index &&
      infoMetrics?.keys &&
      Array.isArray(infoMetrics?.keys) &&
      infoMetrics?.keys?.includes(keyName)
    );
  }
  return (
    infoMetrics?.open &&
    infoMetrics?.keys &&
    Array.isArray(infoMetrics?.keys) &&
    infoMetrics?.keys?.includes(keyName)
  );
};

// utils/textDirection.ts
export const detectArabic = (text = "") => {
  if (!text) {
    return false;
  }
  const arabicChars =
    text?.match(/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/g) || [];
  const totalChars = text?.replace(/\s/g, "").length;
  if (totalChars === 0) return false;
  const arabicRatio = arabicChars.length / totalChars;
  return arabicRatio > 0.3;
};

export const getTextDirection = (text = "") => {
  return detectArabic(text) ? "rtl" : "ltr";
};

export const formatTextForDirection = (text, dir) => {
  if (dir === "rtl") {
    return text.replace(/(@\w+)/g, '<span dir="ltr">$1</span>');
  }
  return text;
};
export const getWidgetMakerBrands = ({
  widgetGraphConfig,
  logicalBrandGroups,
  singleBrands,
}) => {
  if (widgetGraphConfig?.brands?.length > 0) return widgetGraphConfig?.brands;
  if (widgetGraphConfig?.brands?.columns?.[0])
    return widgetGraphConfig?.brands?.columns;
  if (logicalBrandGroups?.length > 0) {
    return [
      {
        brand_group_name: logicalBrandGroups[0]?.brand_group_name,
        group: true,
      },
    ];
  }
  if (singleBrands?.length > 0) {
    return [
      {
        brand_id: singleBrands[0]?.brand_id || singleBrands[0]?.name,
        brand_name: singleBrands[0]?.brand_name,
      },
    ];
  }
  return null;
};

export const updateChartSettingsInGraphObjectBasedOnSelection = (
  stateContainer = null
) => {
  if (!stateContainer) return null;
  let widgetGraphConfig = stateContainer?.widgetGraphConfig
    ? stateContainer?.widgetGraphConfig
    : null;
  let logicalBrandGroups =
    stateContainer?.brandlogicalgroup?.length > 0
      ? stateContainer?.brandlogicalgroup
      : [];
  let singleBrands =
    stateContainer?.brands?.length > 0 ? stateContainer?.brands : [];
  let updatedGraphObject = stateContainer?.graphObject
    ? { ...stateContainer?.graphObject }
    : null;

  if (!widgetGraphConfig || !updatedGraphObject) return null;

  let widgetMakerBrands = getWidgetMakerBrands({
    widgetGraphConfig,
    logicalBrandGroups,
    singleBrands,
  });

  const chartSettings = widgetGraphConfig?.chart_settings || {};

  if (
    !widgetGraphConfig?.breakdown_by?.[0]?.attribute &&
    widgetMakerBrands &&
    widgetMakerBrands[0]?.competitor &&
    widgetMakerBrands[0]?.competitorList?.length > 0 &&
    supportedBenchmarkTraceChartTypes?.includes(widgetGraphConfig?.chart_type)
  ) {
    updatedGraphObject.chart.chart_settings.group_line_agg =
      chartSettings?.benchmark_line
        ? chartSettings?.group_line_agg || "avg"
        : null;
    updatedGraphObject.chart.chart_settings.benchmark_line =
      chartSettings?.benchmark_line;
    updatedGraphObject.chart.chart_settings.benchmark_static_value =
      chartSettings?.benchmark_line
        ? chartSettings?.benchmark_static_value || null
        : null;
  } else if (
    !widgetGraphConfig?.breakdown_by?.[0]?.attribute &&
    widgetMakerBrands &&
    widgetMakerBrands?.length &&
    // !widgetMakerBrands[0]?.group && // now support added for logical and single brand
    supportedBenchmarkTraceChartTypes?.includes(widgetGraphConfig?.chart_type)
  ) {
    updatedGraphObject.chart.chart_settings.group_line_agg =
      chartSettings?.benchmark_line
        ? chartSettings?.group_line_agg || "avg"
        : null;
    updatedGraphObject.chart.chart_settings.benchmark_line =
      chartSettings?.benchmark_line;
    updatedGraphObject.chart.chart_settings.benchmark_static_value =
      chartSettings?.benchmark_line
        ? chartSettings?.benchmark_static_value || null
        : null;
  } else {
    updatedGraphObject.chart.chart_settings.group_line_agg = null;
    updatedGraphObject.chart.chart_settings.benchmark_line = false;
    updatedGraphObject.chart.chart_settings.benchmark_static_value = null;
  }
  return updatedGraphObject;
};

export const sentimentColor = {
  Neutral: "#F0C52F",
  Negative: "#FF5D48",
  Positive: "#5ED142",
};

// to check if the y_axis has valid series
export const hasValidYSeries = (y_axis) => {
  if (!y_axis || typeof y_axis !== "object") return false;

  return Object.values(y_axis).some((series) => series?.attribute);
};

// Exporting error handling utilities
export {
  handleApiError,
  handleAxiosError,
  makeApiCallWithErrorHandling,
} from "../utils/errorHandler";
